export const fileTypes = {
    1: "زمین",
    2: "آپارتمان",
    3: "خانه",
    4: "مغازه",
    5: "وسائل نقلیه سبک",
    6: "وسائل نقلیه سنگین",
    7: "ماشین آلات و لوازم و تجهیزات",
    8: "اثاثیه",
    9: "کارخانه",
    10: "باغ",
    11: "ساختمان",
    12: "مجتمع",
    13: "سوله",
    14: "کارگاه",
    15: "ورزشگاه",
    16: "دامداری",
    17: "پروژه",
    18: "ساختمان در حال احداث",
    19: "باغ - خانه",
    20: "تخریبی",
    21: "پروژه نیمه تمام",
    22: "ویلا",
    23: "مختلط",
    25: "زمین - پرورش ماهی",
    26: "تعمیرگاه",
    27: "پاساژ",
    28: "هتل",
    29: "مرغداری",
    30: "مجتمع تفریحی،توریستی،فرهنگی",
    31: "زمین با بنای احداثی",
    32: "واحد"
};

export const fileProperties = {
    is_elevator: "آسانسور",
    is_water: "آب",
    is_electricity: "برق",
    is_gas: "گاز",
    is_phone: "تلفن",
    is_warehouse: "انباری",
    is_remote_door: "ریموت",
    is_yard: "حیاط",
    is_balcony: "بالکن",
    is_toilet: "فرنگی",
    is_iranian_toilet: "ایرانی",
    is_pool: "استخر",
    is_split: "اسپلیت",
    is_bbq: "BBQ",
    is_janitor: "سرایدار",
    is_radiator: "رادیاتور",
    is_furnished: "مبله",
    is_gym: "باشگاه",
    is_parking: "پارکینگ",
    is_master: "مستر",
    is_patio: "پاسیو",
    is_suite: "سوییت",
    is_loby: "لابی",
    is_fire_alarm: "اعلام حریق",
    is_fire_fighting: "اطفا حریق",
    is_central_vacuum: "جارو مرکزی",
    is_central_anten: "آنتن مرکزی",
    is_camera: "دوربین",
    is_video_phone_door: "آیفون تصویری",
    is_security_system: "سیستم امنیتی",
    is_smart_system: "سیستم هوشمند",
    is_sauna: "سونا",
    is_jacuzzi: "جکوزی",
    is_cinema: "سالن سینما",
    is_conference_hall: "سالن کنفرانس",
    is_house_keeping: "خانه داری",
    is_laundry: "رختشوی خانه",
    is_servitor: "سرویس مستخدم",
    is_green_belt: "فضای سبز",
    is_roofgarden: "روف گاردن",
    is_chiler: "چیلر",
    is_split_duct: "داگت اسپلیت",
    is_floor_heating: "گرما از کف",
    is_fireplace: "شومینه",
    is_package: "پکیج",
    is_cooler: "کولر",
    is_heater: "هیتر",
    is_fancuel: "فن کویل",
    is_rebuilding: "بازسازی",
    is_finish: "پایان کار",
    is_penthouse: "پنت هاوس",
    is_water_refinery: "تصفیه آب",
    is_water_well: "چاه آب",
    is_shooting: "شوتینگ زباله",
    is_carwash: "کارواش",
    is_individual_meters: "کنتوز مجزا",
    is_water_source: "منبع آب",
    is_3phase: "برق۳فاز",
    is_estate_owner: "صاحب خانه"
};

export const usageTypes = {
    1: 'مسکونی',
    2: 'اداری',
    3: 'تجاری',
    4: 'خدماتی',
    5: 'مسکونی اداری',
    6: 'مسکونی تجاری',
    7: 'مسکونی خدماتی',
    8: 'اداری تجاری',
    9: 'اداری خدماتی',
    10: 'تجاری خدماتی',
    11: 'صنعتی',
    12: 'تخریبی',
    13: 'مزروعی',
    14: 'مغازه',
    15: 'آموزشی',
    16: 'چند منظوره',
    17: 'دامپروری',
    18: 'مرغداری',
    19: 'نمایشگاهی - اداری',
    20: 'سواری',
    21: 'تجاری-تفریحی',
    22: 'تولیدی',
    23: 'ورزشی - آموزشی',
    24: 'زمین'
};

export const Groups = [
    {
        id: 1,
        slug: 'completed',
        name: 'تکمیل شده',
    },
    {
        id: 2,
        slug: 'under_construction',
        name: 'در دست اجرا',
    },
    {
        id: 3,
        slug: 'under_design',
        name: 'در دست طراحی و ساخت',
    },
    {
        id: 4,
        name: 'branches',
        title: 'شعب',
    }
];

export const PortionTypes = [
    {
        id: 1,
        name: 'دانگ',
    },
    {
        id: 2,
        name: 'حبه',
    },
    {
        id: 3,
        name: 'شعیر',
    },
    {
        id: 4,
        name: 'سهم',
    },
    {
        id: 5,
        name: 'درصد',
    }
];

export const PageSlugs = {
    housing: {
        title: 'اخبار حوزه مسکن',
        slug: 'housing-news'
    },
    company: {
        title: 'اخبار شرکت',
        slug: 'news'
    }
};

export const provinces = {
    1: 'تهران',
    2: 'کرمان',
    3: 'زنجان',
    4: 'آذربایجان غربی',
    5: 'فارس',
    6: 'گیلان',
    9: 'اردبیل',
    10: 'خراسان رضوی',
    11: 'آذربایجان شرقی',
    14: 'کهکیلویه و بویر احمد',
    15: 'گلستان',
    17: 'کردستان',
    18: 'کرمانشاه',
    19: 'مرکزی',
    20: 'همدان',
    21: 'یزد',
    22: 'اصفهان',
    23: 'ایلام',
    24: 'بوشهر',
    25: 'چهارمحال و بختیاری',
    26: 'خوزستان',
    27: 'سمنان',
    28: 'سیستان و بلوچستان',
    29: 'قم',
    30: 'هرمزگان',
    33: 'قزوین',
    35: 'مازندران',
    36: 'خراسان شمالی',
    37: 'خراسان جنوبی',
    38: 'لرستان',
    39: 'البرز',
    59: 'هرمزگان(کیش)'
};

export const cities = {
    1: {
        11437: 'تهران',
        11438: 'بومهن',
        11439: 'کمردصنعتی',
        11440: 'گل خندان',
        11441: 'شهرک/پردیس/1',
        11442: 'واصفجان',
        11443: 'شهرک/پردیس/2',
        11444: 'همه سین',
        11445: 'باغ کمیش',
        11446: 'جاجرود',
        11447: 'کرشت',
        11448: 'خرمدشت/سیاه سنگ',
        11449: 'سولقان',
        11450: 'امامزاده/داوود',
        11451: 'سنگان',
        11452: 'کشار/علیا/سفلی',
        11453: 'فشم',
        11454: 'زایگان/لالان',
        11455: 'گرمابدر',
        11456: 'ایگل باغ گل',
        11457: 'گلوکان',
        11458: 'شهرک صنعتی/امیریه/زردبند',
        11459: 'امامیه/راحت آباد',
        11460: 'رودک',
        11461: 'میگون',
        11462: 'شمشک',
        11463: 'دربندسر',
        11464: 'اوشان',
        11465: 'آهارفشم',
        11466: 'لواسان بزرگ',
        11467: 'سینک/هنزک',
        11468: 'افجه',
        11469: 'بوجان',
        11470: 'نیکنام ده',
        11471: 'ایرا',
        11472: 'برگ جهان',
        11473: 'گلندوک/لواسان کوچک',
        11474: 'کلان رسنان',
        11475: 'کندعلیا/سفلی',
        11476: 'دماوند/گیلاوند',
        11477: 'چنارشرق',
        11478: 'هومند',
        11479: 'کیلان کوهان',
        11480: 'ساران',
        11481: 'ویرانه',
        11482: 'زان/لومان',
        11483: 'گرم آبسرد',
        11484: 'مومج',
        11485: 'سیدآباد',
        11486: 'آئینه ورزان',
        11487: 'سربندان',
        11488: 'مشهدیدره/کلارک',
        11489: 'آبسرد',
        11490: 'جابان',
        11491: 'سرخده',
        11492: 'اسلام آباد',
        11493: 'مشاع',
        11494: 'وادان',
        11495: 'آرو',
        11496: 'رودهن',
        11497: 'زره در',
        11498: 'مهرآباد',
        11499: 'وسکاره',
        11500: 'آبعلی',
        11501: 'گلاهک',
        11502: 'پیست آبعلی',
        11503: 'چنارغرب',
        11504: 'جوردآرینه',
        11505: 'فیروزکوه',
        11506: 'پیرده',
        11507: 'درده',
        11508: 'جلیزجند',
        11509: 'طرود/سرانزاها',
        11510: 'کتالان',
        11511: 'سله بن',
        11512: 'زرین دشت/انزاها',
        11513: 'امین آباد',
        11514: 'حصاربن',
        11515: 'شهرآبادفیروزکوه',
        11516: 'سیمین دشت',
        11517: 'هرانده',
        11518: 'ارجمند',
        11519: 'لزور',
        11520: 'وزنا/وزمان',
        11521: 'آسور/اندریه',
        11522: 'نجفدر/بهان',
        11523: 'اسلام شهر/شهرک/واوان',
        11524: 'حسن آباد/خالصه',
        11525: 'احمدآبادمستوفی',
        11526: 'فیروزبهرام',
        11527: 'ایرین',
        11528: 'چیچکلو',
        11529: 'علی آباد/تپانچه',
        11530: 'نا معلوم 1',
        11531: 'قمی آباد',
        11532: 'قلعه نوخالصه',
        11533: 'طالب آباد',
        11534: 'چاله ترخان',
        11535: 'کاشانک/مرجان آباد',
        11536: 'عشق آباد',
        11537: 'عباس آبادعلاقه بند',
        11538: 'قاسم آباد/تهرانچی',
        11539: 'کریم آبادتهرانچی',
        11540: 'کهریزک',
        11541: 'شورآباد/قاسم آباد',
        11542: 'قوچ حصار/اسماعیل آباد',
        11543: 'قمصر',
        11544: 'درسون آباد',
        11545: 'فیروزآبادده خیر',
        11546: 'دوتویه سفلی',
        11547: 'سامان دام',
        11548: 'تورقوزآباد',
        11549: 'قیصرآباد',
        11550: 'حسن آباد/فشاپویه',
        11551: 'سلمان آباداسلامشهر',
        11552: 'ابراهیم آباد/اسلامشهر',
        11553: 'شمس آباد',
        11554: 'وهن آباد',
        11555: 'خانلق',
        11556: 'محمدیه',
        11557: 'شهرصنعتی/پرند',
        11558: 'رباط کریم',
        11559: 'گلستان/سلطان آباد',
        11560: 'حصارک پائین',
        11561: 'منجیل آباد',
        11562: 'اکبرآباد/نسیم شهر',
        11563: 'شهرک/صنعتی/نصیرآباد',
        11564: 'شهرک/خانه',
        11565: 'قلعه میر',
        11566: 'آلارد',
        11567: 'انجم آباد',
        11568: 'اورین',
        11569: 'آدران اسلامشهر',
        11570: 'مجتمع/مسکونی/گروه/33توپخانه',
        11571: 'صالح آباداسلامشهر',
        11572: 'خیرآباد/اسلامشهر',
        11573: 'نصیرآبادقاجار',
        11574: 'پادگان/پرندک',
        11575: 'جدید پرند',
        11576: 'نامعلوم',
        11850: 'آتشگاه',
        11851: 'سیاهکلان',
        11852: 'کمال آباد/کمال شهر',
        11853: 'ولایت رود/دیزین',
        11854: 'آیگان/کلوان',
        11855: 'مورود',
        11856: 'سیرا/پل خواب',
        11857: 'شهرستانک',
        11858: 'نسا',
        11859: 'آسارا',
        11860: 'گچسر',
        11861: 'درده سر/کیاسرلات',
        11862: 'کندر',
        11863: 'ارنگه/ابهرک',
        11864: 'آدران کرج',
        11865: 'پورکان',
        11866: 'سیجان',
        11867: 'جی',
        11868: 'چاران',
        11869: 'گرمدره',
        11870: 'محمدآباد/محمدشهر/مشکین دشت',
        11871: 'ولدآباد',
        11872: 'شهرک/مهندسی/زراعی/هما',
        11873: 'شهرک/ناز',
        11874: 'فرخ آباد/زیبادشت',
        11875: 'ماهدشت/مردآباد',
        11876: 'احمدآباد/سردارآباد',
        11877: 'راشته',
        11878: 'قلعه حسن خان',
        11879: 'وردیج/واریش',
        11881: 'شهرک صنعتی/اشتهارد',
        11882: 'ایپک',
        11883: 'رحمانیه',
        11884: 'مرادتپه',
        11885: 'جارو',
        11886: 'زعفرانیه',
        11887: 'شهریار',
        11888: 'خادم آباد',
        11889: 'شهرک/وائین',
        11890: 'شهرک/اندیشه/فاز4/فاز5',
        11891: 'هفتجوی',
        11892: 'شهرآباد/صفادشت',
        11893: 'شهیدآباد',
        11894: 'یبارک کرج',
        11895: 'فردوسیه',
        11896: 'خوشنام',
        11897: 'حصارساتی',
        11898: 'شهرک/اندیشه/فاز1',
        11899: 'شهرک/اندیشه/فاز2',
        11900: 'شهرک/اندیشه/فاز3',
        11901: 'یوسف آبادقوام',
        11902: 'رضی آباد',
        11903: 'گلگون',
        11904: 'قاسم آباد/صباشهر',
        11905: 'جوقین',
        11906: 'بردآباد',
        11907: 'سعیدآبادشهریار',
        11908: 'ملارد',
        11909: 'اسدآباد/چهارباغ',
        11910: 'بیدگنه',
        11911: 'کردزار',
        11912: 'خاتونلر/امیرآبادتوانبخشی',
        11913: 'اصیل آباد',
        11914: 'محمدآبادویره شهریار',
        11915: 'یوسف آبادصیرفی',
        11916: 'بکه',
        11917: 'اسکمان',
        11918: 'قلعه حسنخان/شهرقدس',
        11919: 'باباسلمان',
        11920: 'رزکان',
        11921: 'اخترآباد',
        11922: 'ورآباد',
        11923: 'قره ترپاق',
        11924: 'نصیرآبادشهریار',
        11925: 'ده شاد',
        11926: 'ارغش آباد',
        11928: 'جدید هشتگرد',
        11929: 'چندار',
        11930: 'کردان',
        11931: 'سرخاب',
        11932: 'ینگی امام',
        11933: 'رامجین',
        11934: 'سنقرآباد',
        11935: 'طاووسیه',
        11936: 'احمدآبادکاشانی/کاظم آباد',
        11937: 'آردهه',
        11938: 'لشگرآباد',
        11939: 'زکی آباد',
        11940: 'آران',
        11941: 'قوهه',
        11942: 'علی سید/اقبالیه',
        11943: 'سیف آباد',
        11944: 'حسین خانلو',
        11945: 'آجین دوجین',
        11946: 'قاسم آباد/بزرگ',
        11947: 'قاسم آباد',
        11948: 'حاجی بیگ',
        11949: 'حاجی آباد/کرج',
        11950: 'چهاردانگه',
        11951: 'ولیان',
        11952: 'اقلان تپه',
        11953: 'قارپوزآباد',
        11954: 'خوروین',
        11955: 'تنکمان',
        11956: 'هیو',
        11957: 'خور',
        11958: 'فشند/کوشک زر',
        11959: 'برغان',
        11960: 'سعیدآبادهشتگرد',
        11961: 'تالیان علاقبند',
        11962: 'شهرک/طالقان',
        11963: 'سنگ بن',
        11964: 'ورکش',
        11965: 'خسبان',
        11966: 'هرنج',
        11967: 'وشته',
        11968: 'فشندک',
        11969: 'ناریان',
        11970: 'جوستان',
        11971: 'خچیره',
        11972: 'گته ده',
        11973: 'مهران',
        11974: 'دیزان',
        11975: 'کرود',
        11976: 'دنبلید',
        11977: 'زیدشت',
        11978: 'منگلان',
        11979: 'گوران',
        11980: 'میر',
        11981: 'سوهان/آرموت/کش/لهران/تکیه ناوه',
        11982: 'بزج',
        11983: 'شیخ حسن',
        11984: 'آغشت',
        11985: 'دنگیزک/ابراهیم بیگی',
        11986: 'ملک آباد',
        11987: 'صفرخواجه',
        11988: 'عرب آبادکوه',
        11989: 'فخرایران',
        11991: 'شهرک/صنعتی/سپهر',
        11992: 'نجم آباد',
        11993: 'شهرک/آزادگان',
        12222: 'ورامین',
        12223: 'باغ خواص',
        12224: 'خورین',
        12225: 'ریحان آباد',
        12226: 'احمدآباد/اوسط',
        12227: 'فردیس',
        12228: 'قرچک/زیباشهر',
        12229: 'باقرآباد',
        12230: 'صالح آبادقرچک',
        12231: 'محمدآباد/ولی آباد',
        12232: 'پیشوا',
        12233: 'علی آبادمحیط',
        12234: 'طارندین',
        12235: 'سرگل/گل عباس',
        12236: 'اسلام آباد/زمان آباد/غنی آباد',
        12237: 'گل تپه',
        12238: 'یوسف رضا',
        12239: 'شوران',
        12240: 'جلیل آباد',
        12241: 'معین آباد',
        12242: 'سعیدآبادورامین',
        12243: 'پاکدشت',
        12244: 'شهرک/قائم',
        12245: 'توچال',
        12246: 'خاتون آباد/فرون آباد',
        12247: 'آلوئک',
        12248: 'کلین خالصه',
        12249: 'جمال آباد',
        12250: 'حصارکلک/گلزار',
        12251: 'حصارامیر',
        12252: 'فیلستان',
        12253: 'قلعه نواملاک',
        12254: 'حاجی آباد/ورامین',
        12255: 'حمامک',
        12256: 'شهرک صنعتی/عباس آباد',
        12257: 'کریم آباد/شهرصنعتی خوارزمی',
        12258: 'چنگی',
        12259: 'شریف آباد',
        12260: 'ابراهیم آباد/ورامین',
        12261: 'قرمزتپه',
        12262: 'جوادآباد',
        12263: 'آب باریک',
        12264: 'محمدآبادعربهاورامین',
        12265: 'قلعه بلند',
        12266: 'سلمان آبادورامین',
        12267: 'قلعه خواجه',
        12268: 'حصارحسن بیک',
        12269: 'نجف آبادطغان',
        12270: 'چرمشهر',
        12271: 'رستم آباد',
        18540: 'شهرری',
        18541: 'اسلامشهر'
    },
    2: {
        12556: "کرمان",
        12557: "حجت آباد",
        12558: "رباط",
        12559: "باغین",
        12560: "استخروئیه",
        12561: "شهرک صنعتی\/کرمان",
        12562: "کهنوج مدیم",
        12563: "کوه باداموئیه",
        12564: "ده بالا",
        12565: "شاهرخ آباد",
        12566: "اختیارآباد",
        12567: "باقرآباد",
        12568: "سعدی",
        12569: "زنگی آباد",
        12570: "چشمه گز",
        12571: "رحیم آباد",
        12572: "چترود",
        12573: "قوام آباد\/حمیدیه",
        12574: "هوتک",
        12575: "ده زیار",
        12576: "معزآباد",
        12577: "حرجند",
        12578: "قنات سه",
        12579: "بی بی حیات",
        12580: "تیکدر",
        12581: "کریم آبادآبنیل",
        12582: "کاظم آباد",
        12583: "سرآسیاب",
        12584: "گورچوئیه",
        12585: "راور",
        12586: "فیض آباد",
        12587: "طرزراور",
        12588: "ده علی راور",
        12589: "خورندراور",
        12590: "کوه جهرراور",
        12591: "طاشک",
        12592: "قنات گرم",
        12593: "زرند",
        12594: "خانوک",
        12595: "دشت خاک",
        12596: "شبجره",
        12597: "جلال آباد",
        12598: "خیرآباد",
        12599: "شهرک\/طالقانی",
        12600: "فتح آباد",
        12601: "عیسی آباد",
        12602: "باب تنگل",
        12603: "ده احمدی",
        12604: "طغرل الجرد",
        12605: "چاهگین",
        12606: "احمدآباد\/زرند",
        12607: "سیریز",
        12608: "سبلوئیه",
        12609: "علی آبادعلیا",
        12610: "داهوئیه",
        12611: "یزدان آباد",
        12612: "ده ایرج",
        12613: "جرجافک",
        12614: "سنگ",
        12615: "حصن آباد",
        12616: "بهشت وحدت",
        12617: "اسلام آباد\/زرند",
        12618: "کوهبنان",
        12619: "ده علی",
        12620: "جور",
        12621: "بردسیر",
        12622: "لاله زار",
        12623: "نگار",
        12624: "گلزار",
        12625: "باغابر",
        12626: "دشت کار",
        12627: "قلعه عسگر",
        12628: "هراران",
        12629: "ده بالابیدخوان",
        12630: "هجین",
        12631: "نارپ",
        12632: "اسماعیل آباد",
        12633: "قنات سیر",
        12634: "ماهان",
        12635: "جوپار",
        12636: "محی آباد",
        12637: "قناتغستان",
        12638: "سکنج",
        12639: "عرب آباد",
        12640: "راین",
        12641: "گزک راین",
        12642: "گروه راین",
        12643: "شهداد",
        12644: "اندوهجرد",
        12645: "چهارفرسنگ",
        12646: "استحکام",
        12647: "ابراهیم آباد\/کرمان",
        12648: "سیرچ",
        12649: "گلباف",
        12650: "جوشان",
        12651: "بم",
        12652: "براوات",
        12653: "دهبکری",
        12654: "خواجه عسکر",
        12655: "ابارق",
        12656: "ارگ جدید",
        12657: "تهرود",
        12658: "سیرجان",
        12659: "عزت آباد",
        12660: "نجف آباد\/نجف شهر",
        12661: "محمودآبادسید",
        12662: "بلورد",
        12663: "عمادآباد",
        12664: "ملک آباد",
        12665: "منطقه آزادسیرجان",
        12666: "خسروانی",
        12667: "امیرآباد\/شول",
        12668: "شریک آباد\/پوزه خون",
        12669: "اسطور",
        12670: "کفریز",
        12671: "تاج آباد",
        12672: "نظام آباد",
        12673: "دولت آباد\/انصاری",
        12674: "مومن آباد",
        12675: "قطب آباد",
        12676: "طرزبم",
        12677: "زرین آباد",
        12678: "رستم آباد",
        12679: "قاسم آبادبم",
        12680: "ابراهیم آباد\/سیرجان",
        12681: "فهرج",
        12682: "برج معاذ",
        12683: "برج اکرم",
        12684: "بدرآباد",
        12685: "شهید\/چمن",
        12686: "ریگان",
        12687: "محمدآبادگنبکی",
        12688: "رحمت آباد\/ریگان",
        12689: "عباس آبادریگان",
        12690: "وحیدآباد",
        12691: "شلتوک آباد",
        12692: "شورآباد",
        12693: "پاریز",
        12694: "زیدآباد",
        12695: "سعادت آباد",
        12696: "پسوجان",
        12697: "گستوئیه",
        12698: "امیرآباد\/سوخک",
        12699: "بافت",
        12700: "بزنجان",
        12701: "کیسکان",
        12702: "گوغر\/چشمه سبز",
        12703: "چهارطاق",
        12704: "کرگین",
        12705: "خبرسیرجان",
        12706: "کشکوئیه سیرجان",
        12707: "دهسرد",
        12708: "آهوئیه",
        12709: "دیخوئیه",
        12710: "شصت فیج",
        12711: "بنگان",
        12712: "کوشک",
        12713: "برکنان",
        12714: "طرنگ",
        12715: "بیدکردوئیه",
        12716: "سیاه کوه",
        12717: "کهک اسفیج",
        12718: "رابر",
        12719: "کبیر",
        12720: "جواران",
        12721: "گتک",
        12722: "سیه بنوئیه",
        12723: "هنزا",
        12724: "گنجان",
        12725: "تذرج",
        12726: "قنات ملک",
        12727: "اسکر",
        12728: "کنگری",
        12729: "کلدان",
        12730: "ارزوئیه",
        12731: "وکیل آباد",
        12732: "دولت آباد",
        12733: "گیجوئیه",
        12734: "سلطان آباد",
        12735: "صوغان",
        12736: "معدن آبدشت",
        12737: "حسین آباد\/ارزونیه",
        12738: "علی آبادشمشیر",
        12739: "سرنی",
        12740: "جیرفت",
        12741: "دکت",
        12742: "دولت آباد\/مرکزی",
        12743: "علی آبادعمران",
        12744: "ساغری",
        12745: "ده بنه",
        12746: "باغ باغوئیه",
        12747: "دولت آباد\/اسفندقه",
        12748: "ده پیش سفلی",
        12749: "پشت لر",
        12750: "اسفندقه",
        12751: "بلوک",
        12752: "امیرآباد\/نظریان",
        12753: "دهنوشهسوار",
        12754: "حسین آباد\/جیرفت",
        12755: "طرج",
        12756: "درمزار\/ساردوئیه",
        12757: "گور",
        12758: "محمدآبادمسکون",
        12759: "سقدر",
        12760: "عنبرآباد",
        12761: "دوساری",
        12762: "مردهک",
        12763: "کهنوج",
        12764: "فاریاب",
        12765: "رودبار",
        12766: "زهکلوت",
        12767: "قلعه گنج",
        12768: "سرتک زر",
        12769: "رمشک",
        12770: "منوجان",
        12771: "نودژ",
        12772: "شهرک\/بجگان",
        13232: "رفسنجان",
        13233: "قاسم آباد\/رفسنجان",
        13234: "هرمزآباد",
        13235: "کریم آباد",
        13236: "خنامان",
        13237: "کبوترخان",
        13238: "اودرج",
        13239: "لاهیجان",
        13240: "رضاآباد",
        13241: "فردوسیه آزادگان",
        13242: "حاجی آباد",
        13243: "دره در",
        13244: "ناصریه",
        13245: "چاروک",
        13246: "داوران",
        13247: "مس سرچشمه",
        13248: "عبدل آباد",
        13249: "کشکوئیه رفسنجان",
        13250: "حسین آباد\/کشکوئیه",
        13251: "شریف آباد",
        13252: "احمدآباد\/دئفه",
        13253: "عباس آباد",
        13254: "راویز",
        13255: "کارخانه سرچشمه",
        13256: "انار",
        13257: "گلشن",
        13258: "حسین آباد\/رفسنجان",
        13259: "لطف آباد",
        13260: "بیاض",
        13261: "فردوسیه نوقع",
        13262: "اسماعیل آباد\/رفسنجان",
        13263: "رکن آباد",
        13264: "دقوق آباد",
        13265: "سه قریه",
        13266: "جوادیه",
        13267: "شمس آباد",
        13268: "مهدی آباد",
        13269: "شهربابک",
        13270: "خاتون آباد",
        13271: "دهج",
        13272: "خرسند",
        13273: "استبرق",
        13274: "محمدآباداشکور",
        13275: "خبررفسنجان",
        13276: "جوزم",
        13277: "مرج",
        13278: "برفه",
        13279: "رباط شهربابک",
        13280: "ریسه",
        13281: "کم سفید"
    },
    3: {
        11631: 'زنجان',
        11632: 'شهرک صنعتی/زنجان',
        11633: 'سهرین',
        11634: 'ارمغانخانه',
        11635: 'نیماور',
        11636: 'یامچی',
        11637: 'ینگجه',
        11638: 'تهم',
        11639: 'کاوند',
        11640: 'قلتوق',
        11641: 'آقکند',
        11642: 'والارود',
        11643: 'چورزق معجزات',
        11644: 'شهرک روی/اژدهاتو',
        11645: 'مشکین',
        11646: 'بوغداکندی',
        11647: 'گوگجه قیا',
        11648: 'بناب',
        11649: 'آمادگاه میثم',
        11650: 'همایون',
        11651: 'آزادسفلی',
        11652: 'امین آباد',
        11653: 'نیک پی',
        11654: 'قره بوته',
        11655: 'مهرآباد',
        11656: 'مشمپا',
        11657: 'رجعین',
        11658: 'حصارمشمپا',
        11659: 'قولی قصه',
        11660: 'دیزج آباد',
        11661: 'سایان',
        11662: 'آب بر',
        11663: 'دستجرده',
        11664: 'گیلوان',
        11665: 'گیلانکشه',
        11666: 'چورزق طارم',
        11667: 'هزاررود/آستاگل',
        11668: 'درام',
        11669: 'سانسیز/قلات',
        11670: 'تشویر',
        11671: 'گوهر',
        11672: 'هندی کندی',
        11673: 'رزه بند',
        11674: 'ونی سر',
        11675: 'انذر',
        11676: 'مامالان/پرچم',
        11677: 'ماه نشان',
        11678: 'پری',
        11679: 'دندی',
        11680: 'انگوران',
        11681: 'زرین آبادایجرود',
        11682: 'ینگی کندسیدلر',
        11683: 'احمدکندی',
        11684: 'جوقین',
        11685: 'حلب',
        11686: 'شیوه',
        11687: 'گلابرسفلی',
        11688: 'آرکوئین',
        11689: 'اینچه رهبری',
        11690: 'چسب/نکتو',
        11691: 'سعیدآباد',
        11692: 'ملاپیری',
        11693: 'شهرک/ایجرود',
        11694: 'خدابنده/قیدار',
        11695: 'جرین',
        11696: 'دوتپه سفلی',
        11697: 'سجاس',
        11698: 'حصار',
        11699: 'سهرورد',
        11700: 'محمودآباد',
        11701: 'لاچوان',
        11702: 'بیجقین/ورجوشان',
        11703: 'بلکه شیر',
        11704: 'خنداب',
        11705: 'کرسف',
        11706: 'نورآباد',
        11707: 'توپقره',
        11708: 'مزیدآباد',
        11709: 'نعلبندان',
        11710: 'آقچه قیا',
        11711: 'چوزک',
        11712: 'آبی سفلی',
        11713: 'گوندره',
        11714: 'محمدآباد/بولاماجی',
        11715: 'زرین آبادخدابنده',
        11716: 'حسام آباد',
        11717: 'محمدخلج',
        11718: 'کهلا',
        11719: 'بزین',
        11720: 'حی',
        11721: 'غلام ویس',
        11722: 'گل تپه',
        11723: 'توزلو',
        11724: 'گرماب',
        11725: 'ابهر',
        11726: 'شریف آباد',
        11727: 'نورین',
        11728: 'میموندره',
        11729: 'قروه',
        11730: 'درسجین',
        11731: 'رحمت آباد/اسپاس',
        11732: 'خرمدره',
        11733: 'صائین قلعه',
        11734: 'قلعه حسینیه',
        11735: 'الگزیر',
        11736: 'سوکهریز',
        11737: 'عمیدآباد',
        11738: 'اردجین',
        11739: 'نصیرآباد',
        11740: 'شویر',
        11741: 'پیرزاغه',
        11742: 'هیدج',
        11743: 'چرگر',
        11744: 'کبودچشمه',
        11745: 'ارهان',
        11746: 'سلطانیه',
        11747: 'گوزل دره',
        11748: 'یوسف آباد',
        11749: 'ویر',
        11750: 'قره بلاغ',
        11751: 'خیرآباد',
        11752: 'بوئین',
        11753: 'سنبل آباد',
        11754: 'شیت',
        11755: 'ارشت',
        11756: 'تسکین'
    },
    4: {
        13562: 'توشمانلو/لیوانلو',
        13889: 'الخلج',
        13981: 'ارومیه',
        13982: 'قره حسنلو',
        13983: 'دیزج دول',
        13984: 'گچین',
        13985: 'امامزاده',
        13986: 'بارانداز',
        13987: 'زینالو',
        13988: 'خطایلو',
        13989: 'قره آغاج ارومیه',
        13990: 'رشکان',
        13991: 'دستجرد',
        13992: 'تومتر',
        13993: 'قزل عاشق',
        13994: 'الیاس آباد',
        13995: 'بالانج',
        13996: 'قره باغ',
        13997: 'کهریز',
        13998: 'قولنجی',
        13999: 'آلمان آباد',
        14000: 'طسمالو',
        14001: 'بالو',
        14002: 'بند',
        14003: 'گوگ تپه ارومیه',
        14004: 'آغچه قلعه',
        14005: 'توپراق قلعه',
        14006: 'راژان',
        14007: 'زیوه ارومیه',
        14008: 'دیزج مرگور',
        14009: 'کشتیبان',
        14010: 'شهرک صنعتی/ارومیه',
        14011: 'میاوق',
        14012: 'ترکمان',
        14013: 'جارچلوارومیه',
        14014: 'جارچی لو',
        14015: 'قرارگاه/حمزه',
        14016: 'جبل کندی',
        14017: 'گل تپه',
        14018: 'گورچین قلعه',
        14019: 'دیزج تکیه',
        14020: 'سعیدلو',
        14021: 'قرابقلو',
        14022: 'قره حسنلوخواجه پاشا',
        14023: 'گردآباد',
        14024: 'انگنه',
        14025: 'پر',
        14026: 'خانقاه سرخ',
        14027: 'طلاتپه',
        14028: 'عسگرآبادکوه',
        14029: 'نازلو',
        14030: 'مرنه',
        14031: 'گنگچین',
        14032: 'ممکان',
        14033: 'هشتیان',
        14034: 'گنبد',
        14035: 'نی چالان',
        14036: 'علی بیگلو',
        14037: 'وقاصلو',
        14038: 'کریم آباد',
        14039: 'حیدرلوی بیگلر',
        14040: 'خانشان',
        14041: 'باوان',
        14042: 'بچه جیک',
        14043: 'ساعتلوی بیگلر',
        14044: 'عسگرآبادتپه',
        14045: 'مرنگلوی بزرگ',
        14046: 'مهاباد',
        14047: 'خانقاه مهاباد',
        14048: 'دارلک',
        14049: 'یوسف کندی',
        14050: 'قره قشلاق مهاباد',
        14051: 'قزل قپی',
        14052: 'خورخوره',
        14053: 'دریاس',
        14054: 'لج',
        14055: 'کهریزه شیخان',
        14056: 'کیک آبادگابازله',
        14057: 'قم قلعه',
        14058: 'کوسه کهریز',
        14059: 'گوگ تپه مهاباد',
        14060: 'اگریقاش',
        14061: 'حاجی خوش',
        14062: 'قوشچی ارومیه',
        14063: 'کارخانه قند/نوشین شهر',
        14064: 'سیلوانا',
        14065: 'سرو',
        14066: 'سلماس/مغانجوق',
        14067: 'سرنق',
        14068: 'تمر',
        14069: 'قره قشلاق سلماس',
        14070: 'سوره',
        14071: 'تازه شهرارومیه',
        14072: 'ملحم',
        14073: 'هفتوان',
        14074: 'دیلزی',
        14075: 'کانیان',
        14076: 'سیلاب',
        14077: 'سلطان احمد',
        14078: 'کلشان',
        14079: 'یالقوزآغاج',
        14080: 'کنگرلو',
        14081: 'وردان',
        14082: 'شکریازی',
        14083: 'سرای ملک',
        14084: 'آخته خانه',
        14085: 'هشتراک',
        14086: 'گلعذان',
        14087: 'نقده',
        14088: 'میرآبادارومیه',
        14089: 'حسنلو',
        14090: 'محمدیار',
        14091: 'کویک',
        14092: 'خلیفه لو',
        14093: 'فرخزاد',
        14094: 'بیگم قلعه',
        14095: 'قارنا',
        14096: 'تازه قلعه',
        14097: 'راهدانه',
        14098: 'شهرک/المهدی',
        14099: 'خلیفان',
        14100: 'سردشت',
        14101: 'قلعه رش',
        14102: 'درمان آباد',
        14103: 'کانی زرد',
        14104: 'نلاس',
        14105: 'میرآبادمهاباد',
        14106: 'الواتان',
        14107: 'ربط',
        14108: 'بیوران سفلی',
        14109: 'کلوسه سفلی',
        14110: 'اسلام آباد',
        14111: 'بیطوش',
        14112: 'پیرانشهر',
        14113: 'سروکانی/اندیزه',
        14114: 'پسوه',
        14115: 'گردکشانه',
        14116: 'دربکه',
        14117: 'پادگان/پسوه',
        14118: 'قلعه تراش',
        14119: 'زیوه مهاباد',
        14120: 'جلدیان',
        14121: 'کولیج',
        14122: 'بازارچه مرزی/تمرچین',
        14123: 'بسطام بگ',
        14124: 'کله سپیان',
        14125: 'حاجی غلده',
        14126: 'بن دره',
        14127: 'اشنویه',
        14128: 'آغبلاغ',
        14129: 'نالوس',
        14130: 'نلیوان',
        14131: 'صوفیان',
        14493: 'خوی',
        14494: 'رهال',
        14495: 'قوروق',
        14496: 'دیزج دیز',
        14497: 'زارعان',
        14498: 'سیدتاج الدین',
        14499: 'خاکمزدان',
        14500: 'پیرکندی',
        14501: 'ولدیان',
        14502: 'یزدکان',
        14503: 'حاشیه رود',
        14504: 'بیله وار',
        14505: 'پکاچیک',
        14506: 'بیزنده',
        14507: 'شهرک صنعتی/خوی',
        14508: 'ویشلق علیا',
        14509: 'قشلاق',
        14510: 'زاویه حسن خان',
        14511: 'ملهزان',
        14512: 'زورآباد',
        14513: 'قطور',
        14514: 'رازی',
        14515: 'چاوشقلی',
        14516: 'پسک سفلی',
        14517: 'وار',
        14518: 'سیه باز',
        14519: 'فیرورق',
        14520: 'ایواوغلی',
        14521: 'قره ضیاالدین',
        14522: 'چورس',
        14523: 'حاجیلار',
        14524: 'بادکی',
        14525: 'زنگلان سفلی',
        14526: 'قنات میرزاجلیل',
        14527: 'گجوت',
        14528: 'ماکوخوی',
        14529: 'کشمش تپه',
        14530: 'دیم قشلاق',
        14531: 'آق گل',
        14532: 'هندور',
        14533: 'بازرگان خوی',
        14534: 'چالدران/سیاه چشمه',
        14535: 'کلیساکندی',
        14536: 'سعدل',
        14537: 'شوط',
        14538: 'صوفی خوی',
        14539: 'مخور',
        14540: 'یولاگلدی',
        14541: 'قره آغاج خوی',
        14542: 'خضرلو',
        14543: 'قرانقو',
        14544: 'مرگنلرخوی',
        14545: 'تازه کندخوی',
        14546: 'قره تپه خوی',
        14547: 'احمدآباد/کش ارخی',
        14548: 'پلدشت',
        14549: 'حسن کندی',
        14550: 'شهرک/سدارس',
        14551: 'نازک علیا',
        14552: 'پورناک',
        14553: 'بهلول آباد',
        14554: 'قیرکندی/میرزاکندی',
        14555: 'خانه/های/سازمانی/سدارس',
        14610: 'میاندوآب',
        14611: 'شبیلو/علیا',
        14612: 'گوگ تپه میاندوآب',
        14613: 'للکلو',
        14614: 'فسندوز',
        14615: 'ملاشهاب الدین',
        14616: 'فیروزآباد',
        14617: 'چلیک',
        14618: 'آغداش',
        14619: 'ممدل',
        14620: 'قپچاق',
        14621: 'سرچنار',
        14622: 'چلخماز',
        14623: 'قبان کندی',
        14624: 'گاومیش گلی',
        14625: 'مظفرآباد',
        14626: 'جارچلومیاندوآب',
        14627: 'نصیرکندی',
        14628: 'گل سلیمان آباد',
        14629: 'یقین علی تپه',
        14630: 'حاجی بهزاد',
        14631: 'جوادحصاری',
        14632: 'حاصل قپی افشار',
        14633: 'جعفرآباد',
        14634: 'یاریجان خالصه',
        14635: 'قره تپه میاندوآب',
        14636: 'سوگلی تپه',
        14637: 'حیدرآباد',
        14638: 'اوچ تپه قلعه',
        14639: 'اوچ تپه کرد',
        14640: 'بکتاش',
        14641: 'گرده رش',
        14642: 'حاج حسن مکریان',
        14643: 'علی بگلو',
        14644: 'قاریاغدی',
        14645: 'باروق',
        14646: 'چهاربرج',
        14647: 'حمید',
        14648: 'گوی جلو',
        14649: 'شاهین دژ',
        14650: 'قشلاق بختیاری',
        14651: 'هاچه سوشاهیندژ',
        14652: 'مامالو',
        14653: 'قوزلوی افشار',
        14654: 'قیزکورپی',
        14655: 'ینگی آرخ',
        14656: 'هولاسو',
        14657: 'صفاخانه',
        14658: 'محمودآباد',
        14659: 'چوپلوجه شاهین دژ',
        14660: 'کشاورز',
        14661: 'تیزخراب',
        14662: 'احمدآباد/شاهیندژ',
        14663: 'آغچه مسجد',
        14664: 'اقبال',
        14665: 'تکاب',
        14666: 'سبیل',
        14667: 'عرب شاه',
        14668: 'احمدآباد/تکاب',
        14669: 'آغول بیک',
        14670: 'دورباش',
        14671: 'یولقون آغاج',
        14673: 'چوپلوتکاب',
        14674: 'تخت سلیمان',
        14675: 'قینرجه',
        14676: 'آرپاچای',
        14677: 'حسن آباد/تکاب',
        14678: 'انگورد',
        14679: 'داش قیزقاپان',
        14680: 'نبی کندی',
        14681: 'بوکان',
        14682: 'برده زرد',
        14683: 'رحیم خان',
        14684: 'ملالر',
        14685: 'شرفکند',
        14686: 'شهری کند',
        14687: 'اختتار',
        14688: 'قره کند',
        14689: 'حمامیان',
        14690: 'قره موسی لو',
        14691: 'حاجی آباد',
        14692: 'داش بند',
        14693: 'اوچ تپه بوکان',
        14694: 'آغجیوان',
        14695: 'کانی سیران',
        14696: 'ساری قامیش',
        14697: 'سراب',
        14698: 'شیخ علی',
        14699: 'حسین مامه',
        14714: 'النجق'
    },
    5: {
        16530: 'شیراز',
        16531: 'اکبرآباد/قرآن',
        16532: 'دودج',
        16533: 'داریون',
        16534: 'تربرجعفری',
        16535: 'باجگاه',
        16536: 'ایزدخواست باصری',
        16537: 'بزن',
        16538: 'قصرقمشه',
        16539: 'قلات شیراز',
        16540: 'دوکوهک',
        16541: 'گویم',
        16542: 'آب پرده',
        16543: 'کلستان',
        16544: 'دهک/دولت آباد',
        16545: 'شاپورجان',
        16546: 'دهنوبیدزرد',
        16547: 'ظفرآباد',
        16548: 'شهرصنعتی بزرگ/شیراز',
        16549: 'تفیهان',
        16550: 'کوشک بیدک',
        16551: 'گشنگان',
        16552: 'علی آبادقره باغ',
        16553: 'بیدزرد',
        16554: 'جرسقان',
        16555: 'محمودآبادهوربافت',
        16556: 'اسلام آباد/دارنگون',
        16557: 'زنگنه بن رود',
        16558: 'خان زنیان',
        16559: 'کرونی',
        16560: 'چهل چشمه',
        16561: 'دهنوقلندری',
        16562: 'دشت ارژن',
        16563: 'کدنج',
        16564: 'همت آبادشیراز',
        16565: 'جدید صدرا',
        16566: 'زرقان',
        16567: 'حسین آباد/سبزآباد',
        16568: 'مهریان',
        16569: 'رحمت آباد',
        16570: 'کورکی',
        16571: 'لپوئی',
        16572: 'شهرک صنعتی/آب باریک',
        16573: 'خرامه',
        16574: 'سقاآباد',
        16575: 'خیرآباد/توللی',
        16576: 'بندامیر',
        16577: 'معزآبادجابری',
        16578: 'شهرک/ایثار',
        16579: 'دهقانان',
        16580: 'معزآبادگورگیر',
        16581: 'سلطان آباد',
        16582: 'قوام آبادشیراز',
        16583: 'کفدهک',
        16584: 'سروستان شیراز',
        16585: 'کته گنبد',
        16586: 'مهارلونو',
        16587: 'کوهنجان',
        16588: 'دهنوسروستان',
        16589: 'نظرآباد',
        16590: 'کوار',
        16591: 'هکوان',
        16592: 'آبگرم',
        16593: 'اربابی سفلی',
        16594: 'قصراحمد',
        16595: 'ده شیب',
        16596: 'طسوج',
        16597: 'اکبرآباد/کوار',
        16598: 'محمودآباددودانگ',
        16599: 'مظفری',
        16600: 'نوروزان',
        16601: 'ذرات',
        16602: 'فتح آبادکوار',
        16603: 'فیروزآباد',
        16604: 'مشکان شیراز',
        16605: 'جایدشت',
        16606: 'زنجیران',
        16607: 'احمدآباد/شیراز',
        16608: 'جوکان',
        16609: 'بایگان',
        16610: 'میمند',
        16611: 'پرزیتون',
        16612: 'فراشبند',
        16613: 'دهرم',
        16614: 'نوجین',
        16615: 'دژگاه',
        16616: 'اردکان سپیدان',
        16617: 'سنگر',
        16618: 'دالین',
        16619: 'ده پاگاه شیراز',
        16620: 'برشنه',
        16621: 'بهرغان',
        16622: 'کمهر',
        16623: 'دلخان',
        16624: 'ابنو',
        16625: 'ریگان',
        16626: 'رودبال',
        16627: 'هرایجان',
        16628: 'راشک',
        16629: 'اسفیان',
        16630: 'علی آبادسرتل',
        16631: 'هرابال',
        16632: 'ایاسجان',
        16633: 'علی آبادتنگ',
        16634: 'کوشک هزار',
        16635: 'بانش',
        16636: 'تل بیضا',
        16637: 'شهیدآبادشیراز',
        16638: 'شیخ عبود',
        16639: 'دشمن زیاری',
        16640: 'کازرون',
        16641: 'مهرنجان کازرون',
        16642: 'دریس',
        16643: 'تل کوهک',
        16644: 'قلعه سید',
        16645: 'سیف آبادکازرون',
        16646: 'انارستان',
        16647: 'پل آبگینه',
        16648: 'دوان',
        16649: 'بوشیگان',
        16650: 'قائمیه',
        16651: 'جره',
        16652: 'حاجی آباد/موزی',
        16653: 'ده پاگاه کازرون',
        16654: 'سرمشهد',
        16655: 'بالاده کازرون',
        16656: 'سیدحسین عموئی',
        16657: 'رشن آباد',
        16658: 'دادین',
        16659: 'رضاآباد/کازرون',
        16660: 'تنگ چوگان',
        16661: 'سیریزجان',
        16662: 'خشت',
        16663: 'کنارتخته',
        16664: 'برج سید',
        16665: 'بورکی علیا',
        16666: 'کمارج',
        16667: 'شهبازخانی',
        16668: 'بنه سیدرضا',
        16669: 'گرگدان',
        16670: 'نودان',
        16671: 'گاوکشک',
        16672: 'کلانی',
        16673: 'ملاانباری',
        16674: 'بناف',
        16675: 'پورنجان',
        16676: 'دیکانک',
        16677: 'نورآباد/ممسنی',
        16678: 'اسکان عشایر',
        16679: 'مراسخوان علیا',
        16680: 'بابامیدان',
        16681: 'آهنگری',
        16682: 'دهنومقیمی',
        16683: 'مصیری',
        16684: 'فهلیان',
        16685: 'تل مشکی',
        16686: 'کوپن',
        16687: 'خومه زار',
        16688: 'چهارطاق',
        16689: 'مورکی',
        16690: 'میانه بردنگان',
        16691: 'برم سیاه',
        16692: 'تل کهنه/زیردو',
        16693: 'شیراسپاری',
        16694: 'مهرنجان نورآباد',
        16695: 'گلگون',
        16696: 'سراوان جنجان',
        16697: 'کلاه سیاه',
        16698: 'تلمبه خانه حسنی',
        16699: 'ده گپ محمودی',
        16700: 'دشت آزادگان',
        16701: 'مشایخ',
        16702: 'بابامنیر',
        16703: 'میشان',
        16704: 'حسین آباد/رستم',
        16705: 'دشتک سادات',
        16706: 'پهون',
        16707: 'مرودشت',
        16708: 'حاجی آباد/نقش رستم',
        16709: 'خلف طاهونه',
        16710: 'فتح آباد',
        16711: 'مراگلو',
        16712: 'زرگران',
        16713: 'قصرخلیل',
        16714: 'ده بید',
        16715: 'فیروزی مرودشت',
        16716: 'زنگی آباد',
        16717: 'عزآباد',
        16718: 'شول ساروئی',
        16719: 'شهرک/ولیعصرمرودشت',
        16720: 'عمادآباد',
        16721: 'گرم آباد',
        16722: 'قاسم آباد/ساروئی',
        16723: 'کناره',
        16724: 'بریانک',
        16725: 'کوشک مرودشت',
        16726: 'کوه سبز',
        16727: 'محمدآبادگشک',
        16728: 'رجاآباد',
        16729: 'مجدآباد',
        16730: 'گلدشت علیا',
        16731: 'کوشکک رامجرد',
        16732: 'مجتمع/گوشت',
        16733: 'شهرک/خارا',
        16734: 'حسین آباد/تل کمین',
        16735: 'دره باد',
        16736: 'هشتیجان',
        16737: 'دشتک ابرج',
        16738: 'درودزن',
        16739: 'بورکی',
        16740: 'شهرک/ابرج',
        16741: 'رزمنجان',
        16742: 'بیدگل',
        16743: 'جشنیان رامجرد',
        16744: 'جهان آباد',
        16745: 'بنی یکه',
        16746: 'زراره',
        16747: 'جمال آباد/درودزن',
        16748: 'سیدان',
        16749: 'کره ای مرودشت',
        16750: 'سعادت آبادشوشتری',
        16751: 'راهنویه',
        16752: 'میج',
        16753: 'فاروق',
        16754: 'سیوند',
        16755: 'حسن آباد/سنجرلو',
        16756: 'انجیره',
        16757: 'احمدآباد/مرودشت',
        16758: 'کره تاوی',
        16759: 'مرادآباد',
        16760: 'مشهدبیلو',
        16761: 'خانیمن',
        16762: 'بکیان',
        16763: 'علی آبادعلیا',
        16764: 'حسین آباد/کام فیروز',
        16765: 'گرمه',
        16766: 'شول بزرگ',
        16767: 'خواجه ای',
        16768: 'سعادت شهر/جیسقان',
        16769: 'ابوالوردی',
        16770: 'نعیم آباد',
        16771: 'علی رسیده',
        16772: 'مادرسلیمان',
        16773: 'قوام آبادمرودشت',
        16774: 'همت آبادمرودشت',
        16775: 'ارسنجان',
        16776: 'جلودر',
        16777: 'جوادیه',
        16778: 'جمال آباد/ارسنجان',
        16779: 'خبریز',
        16780: 'علی آبادملک',
        16781: 'حسین آباد/لیاقت',
        16782: 'شورآب',
        16783: 'شرق آباد',
        16784: 'فساء',
        16785: 'صحرارود',
        16786: 'کوشک قاضی',
        16787: 'دستجه',
        16788: 'تنگ کرم',
        16789: 'کچویه',
        16790: 'هارم/شستگان',
        16791: 'نوبندگان',
        16792: 'موردی',
        16793: 'دولت آباد/سه چاه',
        16794: 'جلیان',
        16795: 'غیاث آباد',
        16796: 'یاسریه',
        16797: 'زاهدشهر',
        16798: 'میانده فسا',
        16799: 'رحیم آباد',
        16800: 'فدشکویه',
        16801: 'ششده',
        16802: 'وکیل آباد',
        16803: 'دوگان/جرغه',
        16804: 'زنگنه/فسا',
        16805: 'قاسم آباد',
        16806: 'امیرحاجیلو',
        16807: 'اکبرآباد/ششده',
        16808: 'داراکویه',
        16809: 'استهبان',
        16810: 'ایج فسا',
        16811: 'درب قلعه',
        16812: 'رونیزعلیا',
        16813: 'رونیزسفلی',
        16814: 'ماهفرخان',
        16815: 'گرده استهبان',
        16816: 'محمدآباد',
        16817: 'بنوان فسا',
        16818: 'علی آبادشمس',
        16819: 'نیریز',
        16820: 'قلعه بهمن',
        16821: 'صادق آباد',
        16822: 'مشکان فسا',
        16823: 'قطرویه',
        16824: 'ده چاه',
        16825: 'غوری',
        16826: 'شهرک/امام فسا',
        16827: 'شهرک/امام/رضا',
        16828: 'بشنه',
        16829: 'آباده طشک',
        16830: 'خواجه جمالی',
        16831: 'کوشکک',
        16832: 'چاه گز',
        16833: 'ده مورد',
        16834: 'چاه سوارآقا',
        16835: 'تمشولی',
        16836: 'طشک',
        16837: 'بسترم',
        16838: 'تنگ حنا',
        16839: 'داراب',
        16840: 'ده خیرعلیا/جنت شهر',
        16841: 'شهرک/الغدیر',
        16842: 'برگان',
        16843: 'شهرک/فتح المبین',
        16844: 'دارلینگونه',
        16845: 'چمن مروارید',
        16846: 'شهرک/ثاراله',
        16847: 'فتح آبادفسا',
        16848: 'بریسکان',
        16849: 'پاسخن فسا',
        16850: 'تیزآب',
        16851: 'شهنان',
        16852: 'نصروان',
        16853: 'باینوج',
        16854: 'حسن آباد/فسا',
        16855: 'جونان',
        16856: 'مادوان',
        16857: 'دولت آباد',
        16858: 'هربدان',
        16859: 'قلعه بیابان',
        16860: 'نوایگان',
        16861: 'رستاق',
        16862: 'شهرک/والفجر',
        16863: 'لایزنگان',
        16864: 'شهرک/ولیعصرفسا',
        16865: 'آب جهان',
        16866: 'بیاده',
        16867: 'بهروزآباد',
        16868: 'تل بارگاه',
        16869: 'حاجی آباد',
        16870: 'گلوگاه',
        16871: 'دره شور',
        16872: 'دوبران',
        16873: 'شهرپیر',
        16874: 'خسویه',
        16875: 'زیرآب فسا',
        16876: 'ساچون',
        16877: 'دروافسا',
        16878: 'میانده حاجی آباد',
        16879: 'مزایجان فسا',
        16880: 'دهنوفسا',
        16881: 'گلکویه',
        16882: 'دوبرجی فسا',
        16883: 'فدامی',
        16884: 'قلاتوپه',
        16885: 'مرز',
        16886: 'قلعه نو',
        17013: 'آباده',
        17014: 'حشمتیه',
        17015: 'فیروزی آباده',
        17016: 'بیدک',
        17017: 'دهدق',
        17018: 'شورجستان',
        17019: 'صغاد',
        17020: 'بهمن',
        17021: 'ایزدخواست',
        17022: 'سورمق',
        17023: 'بوانات/سوریان',
        17024: 'فخرآباد',
        17025: 'مزایجان آباده',
        17026: 'شیدان',
        17027: 'مروشکان',
        17028: 'منج',
        17029: 'سروستان آباده',
        17030: 'آباده مرشدی',
        17031: 'سیمکان',
        17032: 'توجردی',
        17033: 'باغ صفا',
        17034: 'خورکش',
        17035: 'جعفریه',
        17036: 'جشنیان بوانات',
        17037: 'فنجان',
        17038: 'جوی سفید',
        17039: 'ده بید/خرم بیدآباده',
        17040: 'خرمی',
        17041: 'مشکان آباده',
        17042: 'مظفرآباد',
        17043: 'قاضیان',
        17044: 'انارک',
        17045: 'شهیدآبادآباده',
        17046: 'قشلاق',
        17047: 'قادرآباد',
        17048: 'مشهدمرغاب',
        17049: 'کره ای آباده',
        17050: 'حسامی',
        17051: 'کوپان',
        17052: 'اقلید',
        17053: 'چشمه رعنا',
        17054: 'حسن آباد/آباده',
        17055: 'خسروشیرین',
        17056: 'خنجشت',
        17057: 'شهرمیان',
        17058: 'کافتر',
        17059: 'نظام آبادآباده',
        17060: 'آب باریک',
        17061: 'بکان',
        17062: 'امامزاده/اسماعیل',
        17063: 'رضاآباد/میان رودآباده',
        17064: 'شهرآشوب',
        17065: 'سده اقلید',
        17066: 'دزکرد',
        17067: 'آسپاس',
        17068: 'بابائی',
        17317: 'حسین زائری',
        17431: 'لار',
        17432: 'بریز',
        17433: 'دهکویه',
        17434: 'دنگز',
        17435: 'علی آبادلار',
        17436: 'کورده',
        17437: 'گرموستج/لار',
        17438: 'هرمودمهرخوئی',
        17439: 'چاه نهر',
        17440: 'گراش',
        17441: 'آغصه',
        17442: 'ارد',
        17443: 'زینل آباد',
        17444: 'خلور',
        17445: 'خلیلی',
        17446: 'دشتی',
        17447: 'دیده بان',
        17448: 'زروان',
        17449: 'عمادده',
        17450: 'باغ',
        17451: 'هرمودباغ',
        17452: 'فداغ',
        17453: 'ده میان',
        17454: 'جویم',
        17455: 'بلغان',
        17456: 'بنارویه',
        17457: 'دامچه',
        17458: 'ده فیش',
        17459: 'شرفویه',
        17460: 'لاغران',
        17461: 'منصورآباد',
        17462: 'هرم',
        17463: 'احمدمحمودی',
        17464: 'چغان',
        17465: 'کاریان',
        17466: 'اوز',
        17467: 'بیدشهر',
        17468: 'کوره',
        17469: 'هودلار',
        17470: 'کهنه قدیم لار',
        17471: 'کهنه جدید',
        17472: 'مز',
        17473: 'گلار',
        17474: 'محلچه',
        17475: 'قلات لار',
        17476: 'هیرم',
        17477: 'بیرم لار',
        17478: 'بالاده بیرم',
        17479: 'کریشکی',
        17480: 'محمله',
        17481: 'خنج',
        17482: 'گرمشت',
        17483: 'هفتوان',
        17484: 'بیغرد',
        17485: 'چاه طوس',
        17486: 'کورده خنج',
        17487: 'سیف آبادلار',
        17488: 'آشنا',
        17489: 'باغان',
        17490: 'سده لار',
        17491: 'مکویه',
        17492: 'فیشور',
        17493: 'کهنویه خنج',
        17494: 'پنگرویه',
        17495: 'لامرد',
        17496: 'فاضلی',
        17497: 'چاه ورز',
        17498: 'خوزی',
        17499: 'دهنوحاج هدایت',
        17500: 'نرمان',
        17501: 'ترمان',
        17502: 'وراوی لار',
        17503: 'سیگارلار',
        17504: 'ده شیخ',
        17505: 'چاه شرف',
        17506: 'نورآباد',
        17507: 'لاورخشت',
        17508: 'کندرعبدالرضا',
        17509: 'پاقلات',
        17510: 'پسبند',
        17511: 'اشکنان',
        17512: 'کال',
        17513: 'خشت/رکن آباد',
        17514: 'اهل',
        17515: 'گله دار',
        17516: 'اسیر',
        17517: 'مزایجان لار',
        17518: 'شهرک/امام لار',
        17519: 'مهر',
        17520: 'آرودان',
        17521: 'ذیقان',
        17522: 'چاه عینی',
        17523: 'خیرگو',
        17524: 'کمالی',
        17525: 'دهنوغیب الهی',
        17526: 'کهنویه لامرد',
        17527: 'چاه کور',
        17528: 'جهرم/حیدرآباد',
        17529: 'کناردان/هکان',
        17530: 'دوزه',
        17531: 'کوشکسار',
        17532: 'بهجان',
        17533: 'آرجویه',
        17534: 'بادنجان',
        17535: 'جرمشت',
        17536: 'باب انار/خفر',
        17537: 'زرجان',
        17538: 'محمودآبادجهرم',
        17539: 'تادوان',
        17540: 'طاهونه',
        17541: 'فشان',
        17542: 'خانگهدان/خاوران',
        17543: 'آبسرد',
        17544: 'بالاشهر',
        17545: 'برایجان',
        17546: 'کرفت',
        17547: 'چرگ/جلیل آباد',
        17548: 'علی آباد',
        17549: 'گلبرنجی',
        17550: 'قالینی',
        17551: 'کته',
        17552: 'آسمان جرد',
        17553: 'باغ کبیر',
        17554: 'اسماعیل آباد',
        17555: 'قطب آباد',
        17556: 'موسویه/ده زیر',
        17557: 'علویه/باباعرب',
        17558: 'گلدامچه',
        17559: 'قیر/کارزین',
        17560: 'مبارک آباد',
        17561: 'تنگ روئین',
        17562: 'فتح آبادقیر',
        17563: 'نجف آباد',
        17564: 'اسلام آباد/جهرم',
        17565: 'شهرک/امام/خمینی',
        17566: 'افزرشمالی',
        17567: 'شهرک/علی آبادپشگان',
        17568: 'شهرک/قلات',
        17569: 'شهرک/هنگام',
        17570: 'مرند',
        17571: 'بندوبست',
        18538: 'جهرم',
        18539: 'جهرم',
        18545: 'فسا'
    },
    6: {
        10618: 'رشت',
        10619: 'فخب',
        10620: 'سقالکسر',
        10621: 'تویسروندان',
        10622: 'پیرکلاچای',
        10623: 'امامزاده/هاشم',
        10624: 'بلسبنه',
        10625: 'بیجارکنار',
        10626: 'صیقلان ورزل',
        10627: 'پیربازار',
        10628: 'طرازکوه',
        10629: 'شهرصنعتی/رشت',
        10630: 'فلکده',
        10631: 'کتیگر/آقاسیدشریف',
        10632: 'شیخ علی بست',
        10633: 'بداب',
        10634: 'تش',
        10635: 'خمام',
        10636: 'اشکیک',
        10637: 'تمل شیرکوه',
        10638: 'تیسیه',
        10639: 'جورکویه',
        10640: 'نوشر',
        10641: 'جیرکویه',
        10642: 'چوکام',
        10643: 'خشکبیجار',
        10644: 'فشتکه',
        10645: 'کته سرولات',
        10646: 'دافچاه',
        10647: 'حاجی بکنده',
        10648: 'کلاچاه دوم',
        10649: 'شیجان',
        10650: 'رودپشت',
        10651: 'چپرپرد',
        10652: 'ویشکا',
        10653: 'لله کا',
        10654: 'شهرستان',
        10655: 'برمچه قوام',
        10656: 'مبارک آباد',
        10657: 'لشت نشا',
        10658: 'جلیدان',
        10659: 'جوپشت',
        10660: 'زیباکنار',
        10661: 'فخرآباد',
        10662: 'لیچاه',
        10663: 'گفشه',
        10664: 'آج بوزایه',
        10665: 'اسطلک',
        10666: 'لاشک',
        10667: 'لیموچاه',
        10668: 'اژدهابلوچ',
        10669: 'جیرهنده',
        10670: 'نوده لشت نشا',
        10671: 'کوچصفهان',
        10672: 'چولاب/ابراهیم سرا',
        10673: 'طارم سر',
        10674: 'فشتم',
        10675: 'کنارسر',
        10676: 'گورابسر',
        10677: 'گیلوادشتان',
        10678: 'لولمان کوچصفهان',
        10679: 'مژده',
        10680: 'شکارسرا',
        10681: 'پلکوه/پاچکنار',
        10682: 'کیاسرا',
        10683: 'سده',
        10684: 'کتیک',
        10685: 'سنگر',
        10686: 'شاقاجی/اسلام آباد',
        10687: 'ویشکاننک',
        10688: 'پیش کنار',
        10689: 'بازقلعه اکبر',
        10690: 'شیخ علی توسه',
        10691: 'جوبنه',
        10692: 'نشرودگل',
        10693: 'سروندان',
        10694: 'گیله پرده سر',
        10695: 'دلچه',
        10696: 'سراوان',
        10697: 'قاضیان',
        10698: 'کنستان',
        10699: 'رودبار',
        10700: 'کلشتر',
        10701: 'گنجه',
        10702: 'اسکولک',
        10703: 'جمال آباد',
        10704: 'رستم آباد',
        10705: 'خاصه کول',
        10706: 'لوشان',
        10707: 'منجیل',
        10708: 'چهارمحل',
        10709: 'بره سر',
        10710: 'جوبن',
        10711: 'علی آباد',
        10712: 'شهربیجار',
        10713: 'ناش/نوده',
        10714: 'توتکابن',
        10715: 'نصفی',
        10716: 'دشتویل',
        10717: 'اسطلخ جان',
        10718: 'شیرکوه',
        10719: 'چلکاسر',
        10720: 'چلوانسرا',
        10721: 'جیرنده/عمارلو',
        10722: 'گوفل',
        10723: 'پاکده',
        10724: 'کلیشم',
        10725: 'فومن',
        10726: 'چیران',
        10727: 'قلعه رودخان',
        10728: 'خشکنودهان',
        10729: 'تطف رود',
        10730: 'ماکلوان',
        10731: 'آلیان',
        10732: 'شولم',
        10733: 'لولمان فومن',
        10734: 'زیده',
        10735: 'کمامردخ',
        10736: 'کلرم',
        10737: 'گل افزان/کلده',
        10738: 'دارباغ',
        10739: 'گشت',
        10740: 'گوراب پس',
        10741: 'گوشلوندان',
        10742: 'رودپیش',
        10743: 'گوراب لیشاوندان/تازآباد',
        10744: 'ماسوله',
        10745: 'کاس احمدان',
        10746: 'راسته کنار/بوئین',
        10747: 'نوده مرخال',
        10748: 'کوزان',
        10749: 'بالاخرطوم',
        10750: 'لپوندان',
        10751: 'نهزوم',
        10752: 'ویسه رود',
        10753: 'شفت',
        10754: 'چماچاه',
        10755: 'نصیرمحله',
        10756: 'چوبرشفت',
        10757: 'دوبخشر',
        10758: 'شالما',
        10759: 'ملسکام/خسروآباد',
        10760: 'شادخال',
        10761: 'احمدسرگوراب',
        10762: 'مژدهه',
        10763: 'جیرده',
        10764: 'کمساربزرگ',
        10765: 'سیاه مزگی/توسه',
        10766: 'خطیبان',
        10767: 'لاقان/مردخه',
        10768: 'لاهیجان',
        10769: 'سرچشمه',
        10770: 'لیالستان',
        10771: 'گل رودبار',
        10772: 'دیزین',
        10773: 'بارکوسرا',
        10774: 'بالارودپشت/بین کلایه',
        10775: 'پهمدان',
        10776: 'حسنعلی ده',
        10777: 'نوبیجارمحله',
        10778: 'کوشال',
        10779: 'رودبنه',
        10780: 'سرشکه',
        10781: 'سطل سر',
        10782: 'شیخ علی کلایه',
        10783: 'آهندان',
        10784: 'سراجار',
        10785: 'کچلام',
        10786: 'لفمجان',
        10787: 'سیاه گوراب',
        10788: 'امام/ده',
        10789: 'ناصرکیاده',
        10790: 'کورنده',
        10791: 'کتشال',
        10792: 'ایوان استخر',
        10793: 'سیاهکل',
        10794: 'پاشاکی بالامحله/پائین محله',
        10795: 'فشتال',
        10796: 'انارستان',
        10797: 'دیلمان',
        10798: 'ایزبرم',
        10799: 'پیرکوه',
        10800: 'مالفجان',
        10801: 'دیارجان',
        10802: 'تازه آباد/جنگاه',
        10803: 'خرارود',
        10804: 'آستانه اشرفیه',
        10805: 'تجن گوکه',
        10806: 'چورکوچان',
        10807: 'پوشل',
        10808: 'کارسیدان',
        10809: 'ششکل',
        10810: 'کیسم',
        10811: 'لفوت بالا/ماشک تهرانچی',
        10812: 'چهارده',
        10813: 'امیرهنده',
        10814: 'داخل',
        10815: 'شرفشاده/کهنه رودپشت',
        10816: 'گیلده',
        10817: 'کته شصت',
        10818: 'کماچال',
        10819: 'کینچاه',
        10820: 'استخربیجار',
        10821: 'امشل',
        10822: 'نقره ده',
        10823: 'حسن بکنده',
        10824: 'بندر/کیاشهر',
        10825: 'دهگاه',
        10826: 'لسکوکلایه',
        10827: 'لوخ',
        10828: 'دهشال',
        10829: 'پرکاپشت',
        10830: 'درگاه',
        10831: 'سالکده',
        10832: 'صفرابسته',
        10833: 'دستک',
        10834: 'گورابجوار',
        10835: 'لنگرود',
        10836: 'سادات محله/صیدرمحله',
        10837: 'چمخاله',
        10838: 'لیلاکوه',
        10839: 'فتیده',
        10840: 'شلمان',
        10841: 'کومله',
        10842: 'نالکیاشهر',
        10843: 'لوکلایه',
        10844: 'مریدان',
        10845: 'سالکویه',
        10846: 'اطاق ور',
        10847: 'گل سفید',
        10848: 'حاجی سرا',
        10849: 'پاپکیاده',
        10850: 'چماقستان',
        10851: 'چاف',
        10852: 'پروش',
        10853: 'رودسر',
        10854: 'رضامحله',
        10855: 'چایجان',
        10856: 'تمیجان',
        10857: 'سیاهکل رود',
        10858: 'قاسم آباد/علیا',
        10859: 'روشن آبسر',
        10860: 'چابکسر',
        10861: 'واجارگاه',
        10862: 'دعوی سرا',
        10863: 'قاسم آباد/سفلی',
        10864: 'اوشیان',
        10865: 'لشکاجان',
        10866: 'طول لات',
        10867: 'کلاچای/بی بالان',
        10868: 'املش',
        10869: 'شبخوسلات',
        10870: 'سیویر',
        10871: 'هلوسرا',
        10872: 'سورکوه',
        10873: 'جیرگوابر',
        10874: 'گرکه رود',
        10875: 'کرفستان',
        10876: 'البرز/جورکاسر',
        10877: 'لات لیل',
        10878: 'کویه علیا',
        10879: 'رحیم آباد',
        10880: 'سجیران/جیرکول',
        11263: 'بندر/انزلی',
        11264: 'حسن رود',
        11265: 'طالب آباد',
        11266: 'کولیور',
        11268: 'کوچک محله',
        11269: 'خمیران',
        11270: 'سیاه خاله سر',
        11271: 'سنگاچین',
        11272: 'کپورچال',
        11273: 'آبکنار',
        11274: 'صومعه سرا',
        11275: 'دوگور',
        11276: 'گوراب زرمیخ',
        11277: 'بهمبر',
        11278: 'کسما',
        11279: 'بلگور',
        11280: 'پشت مسار',
        11281: 'ضیابر',
        11282: 'پشتیر',
        11283: 'دلیوندان',
        11284: 'اباتر',
        11285: 'مرکیه',
        11286: 'اسفقن سر',
        11287: 'پیشخان',
        11288: 'نوکاشت',
        11289: 'کوده/میانده',
        11290: 'اسپند/چکوور',
        11291: 'گلسر/قاضده',
        11292: 'ولدپشت مخ',
        11293: 'طاهرگوراب',
        11294: 'سه سار',
        11295: 'نرکستان',
        11296: 'شیخ محله/سیاه درویشان',
        11297: 'هندخاله',
        11298: 'نوخاله اکبری',
        11299: 'بازارجمعه',
        11300: 'لیف شاگرد',
        11301: 'سسمس',
        11302: 'خراط محله',
        11303: 'هشتپر/تالش',
        11304: 'خرجیگل',
        11305: 'چوبربندرانزلی',
        11306: 'جوکندان',
        11307: 'شیرآباد',
        11308: 'ویزنه',
        11309: 'خطبه سرا',
        11310: 'حویق',
        11311: 'تکی تازه آباد',
        11312: 'قروق/جماکوه',
        11313: 'بداغ محله',
        11314: 'اسالم/خلیفه آباد/ناورود',
        11315: 'خاله سرا',
        11316: 'لیسار',
        11317: 'رضوانشهر',
        11318: 'چوکا',
        11319: 'پره سر',
        11320: 'خوشابر',
        11321: 'دیناچال',
        11322: 'رودبارسرا',
        11323: 'اردجان',
        11324: 'شفارود',
        11325: 'دارسرا',
        11326: 'ارده',
        11327: 'نوکنده',
        11328: 'سیاه بیل/دیگه سرا',
        11329: 'ارشادمحله',
        11330: 'ماسال',
        11331: 'میرمحله',
        11332: 'شاندرمن',
        11333: 'طاسکوه',
        11334: 'شیخ نشین',
        11335: 'اولم',
        11336: 'شهرک صنعتی/صومعه سرا',
        11337: 'کوچکام',
        11338: 'پیرسرا',
        11339: 'ندامان',
        11340: 'خشک رودبار',
        11341: 'وردم',
        11342: 'آستارا',
        11343: 'ویرمونی',
        11344: 'عنبران محله',
        11345: 'کانرود',
        11346: 'حیران',
        11347: 'عباس آباد',
        11348: 'لوندویل'
    },
    9: {
        14132: 'اردبیل',
        14133: 'آقاباقر',
        14134: 'امیدچه',
        14135: 'تقی دیزج',
        14136: 'حسن باروق',
        14137: 'انزاب علیا',
        14138: 'قره تپه سبلان',
        14139: 'آتشگاه/ارجستان',
        14140: 'دره آباد/کلور',
        14141: 'اردیموسی',
        14142: 'الماس',
        14143: 'زردآلو',
        14144: 'سامیان',
        14145: 'حکیم قشلاقی',
        14146: 'تپراقلو',
        14147: 'آغبلاغ رستم خان',
        14148: 'چناقرود',
        14149: 'صومعه',
        14150: 'خیارک',
        14151: 'مجنده',
        14152: 'گرجان',
        14153: 'ابربکوه',
        14154: 'رضی آباد',
        14155: 'قلعه جوق سبلان',
        14156: 'باروق',
        14157: 'تازه کندشریف آباد',
        14158: 'ایمیر',
        14159: 'جمایران',
        14160: 'شریف بیگلو',
        14161: 'دیولق',
        14162: 'آقچه کند',
        14163: 'پیراقوم',
        14164: 'قره لر',
        14165: 'طالب قشلاقی',
        14166: 'ثمرین',
        14167: 'جبه دار',
        14168: 'شام اسبی',
        14169: 'کرکرق',
        14170: 'گیلانده',
        14171: 'سلطان آباد',
        14172: 'شهرک/صنعتی/اردبیل',
        14173: 'آغبلاغ آقاجان',
        14174: 'سرعین',
        14175: 'آلوارس',
        14176: 'شایق',
        14177: 'انزاب سفلی',
        14178: 'ویلادرق',
        14179: 'اسب مرز',
        14180: 'الداشین',
        14181: 'کنزق',
        14182: 'گندیشمین',
        14183: 'کریق',
        14184: 'شیخ احمد',
        14185: 'شیرین بلاغ',
        14186: 'مهماندوست',
        14187: 'قوناق قران',
        14188: 'ملااحمد',
        14189: 'کوهساره',
        14190: 'حفظ آباد',
        14191: 'نمین',
        14192: 'حور',
        14193: 'ننه کران',
        14194: 'عنبران سفلی',
        14195: 'آبی بیگلو',
        14196: 'خانقاه علیا',
        14197: 'دولت آباد',
        14198: 'نوشنق',
        14199: 'یزن آباد',
        14200: 'نیارق',
        14201: 'نوجه ده',
        14202: 'مین آباد',
        14203: 'پیله رود',
        14204: 'بریس',
        14205: 'آرخازلو',
        14206: 'مرنی',
        14207: 'یونجالو',
        14208: 'گرده',
        14209: 'میرزانق',
        14210: 'بویاغچلو',
        14211: 'خواجه بلاغ',
        14212: 'گلشن',
        14213: 'جید',
        14214: 'عنبران علیا',
        14215: 'قزل قیه',
        14216: 'خانقاه سفلی',
        14217: 'گللو',
        14218: 'کریق بزرگ',
        14219: 'هیر',
        14220: 'آراللو',
        14221: 'نوشهر',
        14222: 'بقرآباد',
        14223: 'خلیل آباد',
        14224: 'گورادل',
        14225: 'کرگان',
        14226: 'آلوچه فولادلو',
        14227: 'اینلو',
        14228: 'بودالالو',
        14229: 'دم صغرلو',
        14230: 'کهریز',
        14231: 'بلقیس آباد',
        14232: 'کله سرنیر',
        14233: 'قیدقشلاقی',
        14234: 'گوگرچین',
        14235: 'نیر',
        14236: 'کورعباسلو',
        14237: 'کورائیم',
        14238: 'بوسجین',
        14239: 'ایوریق',
        14240: 'خانه شیر',
        14241: 'حاجی محمود',
        14242: 'ایرینجی/خانه شهر',
        14243: 'ویرثق',
        14244: 'قره شیران',
        14245: 'قورتولموش',
        14246: 'رضاقلی قشلاقی',
        14247: 'کمال آباد',
        14248: 'جین قشلاقی',
        14249: 'ولیعصرنیر/ایلانجیق',
        14250: 'لکندشت',
        14251: 'هل آباد',
        14252: 'جعفرلو',
        14253: 'چالگرود',
        14254: 'گلیجان',
        14255: 'ابلی سفلی',
        14256: 'سکرآباد',
        14257: 'پیربداغ',
        14258: 'بورستان',
        14259: 'خلخال',
        14260: 'لمعه دشت',
        14261: 'گورانسراب',
        14262: 'ترزنق',
        14263: 'لنبر',
        14264: 'خمس',
        14265: 'مجره',
        14266: 'طولش',
        14267: 'بفراجرد',
        14268: 'کزج',
        14269: 'خانقاه بفراجرد',
        14270: 'قزل درق',
        14271: 'اناویز',
        14272: 'گزاز',
        14273: 'صومعه رودبار',
        14274: 'گلوزان',
        14275: 'مرشت',
        14276: 'اواشانق',
        14277: 'قره قشلاق',
        14278: 'فاراب',
        14279: 'آقامیرلو',
        14280: 'گنجگاه',
        14281: 'نیلق',
        14282: 'کرندق',
        14283: 'بنیادآباد',
        14284: 'بنماران',
        14285: 'کلورامام رود',
        14286: 'کرین',
        14287: 'شال',
        14288: 'لرد',
        14289: 'تیل',
        14290: 'اسکستان',
        14291: 'ماجولان',
        14292: 'چملوگبین',
        14293: 'گیلوان',
        14294: 'میانرودان',
        14295: 'آغبلاغ کرد',
        14296: 'ایلخچی کوثر',
        14297: 'صوفلو',
        14298: 'زاویه کرد',
        14299: 'پیرآغاج',
        14300: 'ام آباد',
        14301: 'نمهیل',
        14302: 'هشتجین',
        14303: 'برندق',
        14304: 'کجل',
        14305: 'خوشنامه',
        14306: 'نساز',
        14307: 'منامین',
        14308: 'سوسهاب',
        14309: 'آهو',
        14310: 'گیوی زاویه',
        14311: 'گیوی/کوثر',
        14312: 'فیروزآباد',
        14313: 'سنگ آباد',
        14314: 'زرج آباد',
        14315: 'قوزلو',
        14316: 'بلوکانلو',
        14317: 'هشین',
        14318: 'مشکین شهر',
        14319: 'لاهرود',
        14320: 'انار',
        14321: 'بالوجه میرک',
        14322: 'پریخان',
        14323: 'نقدی علیا',
        14324: 'جبدرق',
        14325: 'دده بیگلو',
        14326: 'جمال آباد',
        14327: 'قصابه',
        14328: 'کوجنق',
        14329: 'بیجق',
        14330: 'آلنی',
        14331: 'قره قیه',
        14332: 'فخرآباد',
        14333: 'ارباب کندی',
        14334: 'آغبلاغ مشکین شهر',
        14335: 'شعبانلو',
        14336: 'ارجق',
        14337: 'احمدآباد',
        14338: 'قورت تپه',
        14339: 'احمدبیگلو',
        14340: 'مجنده مشکین شهر',
        14341: 'میزان',
        14342: 'دوه چی',
        14343: 'زاویه سنگ',
        14344: 'قره باغلار',
        14345: 'علی کهریز',
        14346: 'کنگرلو',
        14347: 'موئیل',
        14348: 'خرم آباد',
        14349: 'سریخانلو',
        14350: 'میرکندی',
        14351: 'دستگیر',
        14352: 'دوشانلو',
        14353: 'انزان',
        14354: 'قلی بیگلو',
        14355: 'قلیچ خانلو',
        14356: 'آغبلاغ گدوک',
        14357: 'زرگر',
        14358: 'گلنوجه',
        14359: 'آق درق',
        14360: 'جبارلو',
        14361: 'رضی',
        14362: 'چاپاقان',
        14363: 'ساره بانلار',
        14364: 'خلیفه لومشکین شهر',
        14365: 'مرادلو',
        14366: 'قوشه سفلی',
        14367: 'کلی علیا',
        14368: 'صلوات',
        14369: 'برک چای',
        14370: 'کنده کندی',
        14371: 'قره آغاج پشته',
        14372: 'مازافا',
        14373: 'آلمای علیا',
        14374: 'کنجوبه',
        14375: 'قورت تپه مرادلو',
        14376: 'مشیران',
        14377: 'گرمی/شهرک/ولیعصر',
        14378: 'ایلخچی گرمی',
        14379: 'کله سرسفلی',
        14380: 'آنی علیا',
        14381: 'اظماره',
        14382: 'بینه',
        14383: 'بنه',
        14384: 'محمدتقی کندی',
        14385: 'شکراب/هاچاکندی',
        14386: 'حمزه خانلو/حسن کندی',
        14387: 'آقاحسن بیگلو',
        14388: 'پرچین',
        14389: 'شهرک/بعثت',
        14390: 'پرمهر',
        14391: 'وان',
        14392: 'اوماسلان',
        14393: 'کردلر',
        14394: 'تکانلو',
        14395: 'مجیدلو',
        14396: 'بیلداشی',
        14397: 'تولون',
        14398: 'چونگنش',
        14399: 'نجفقلی قشلاقی',
        14400: 'انگوتلار',
        14401: 'چونه خانلو',
        14402: 'تازه کندانگوت',
        14403: 'زیوه',
        14404: 'قره آغاج',
        14405: 'دیزج',
        14406: 'قاسم کندی',
        14407: 'آقامحمدبیگلو',
        14408: 'قلعه برزند',
        14409: 'قره خان بیگلو',
        14410: 'تک بلاغ',
        14411: 'درگاهلو',
        14412: 'گوده کهریز',
        14413: 'عباسعلیلو',
        14414: 'جدا',
        14415: 'قربانلو',
        14416: 'دیکداش',
        14417: 'چنارساریخان بیگلو',
        14418: 'زنگیر',
        14419: 'آزادلو',
        14420: 'اکبرآباد',
        14421: 'دمیرچی',
        14422: 'زنگبار',
        14423: 'تازه کندقره بلاغ',
        14424: 'سامانلو',
        14425: 'طاووس دره سی',
        14426: 'شورستان',
        14427: 'عمارات',
        14428: 'کدخدالو',
        14429: 'لکرآبادسفلی',
        14430: 'سروآغاجی',
        14431: 'قشلاق عبا',
        14432: 'گونی کندی',
        14433: 'چنارخروسلوداغ',
        14434: 'پارس آباد',
        14435: 'اسماعیل کندی',
        14436: 'اولتان',
        14437: 'ایران آباد',
        14438: 'تکله کندی',
        14439: 'تکچی',
        14440: 'گوشلو',
        14441: 'ابراهیم آباد/آغدام',
        14442: 'حاج عوض قشلاقی',
        14443: 'حاجی تاپدوق',
        14444: 'اجیرلو',
        14445: 'پریواتلو',
        14446: 'اسلام آباد/جدید',
        14447: 'اسلام آباد/قدیم',
        14448: 'اوزون قوئی',
        14449: 'ابراهیم کندی وسطی',
        14450: 'تازه کندقدیم',
        14451: 'پاراقشلاق',
        14452: 'محمودآباد',
        14453: 'دشت مغان/شهرک/مغان',
        14454: 'خان قشلاقی',
        14455: 'صفرلو',
        14456: 'قشلاق ساری قوئی شاهمار',
        14457: 'اصلان دوز',
        14458: 'قوشاقشلاق',
        14459: 'آق قباق',
        14460: 'عمران آباد',
        14461: 'مقصودلو',
        14462: 'نورمحمدکندی',
        14463: 'بران علیا',
        14464: 'دلیک یاریقان/طاهرآباد',
        14465: 'هزارکندی',
        14466: 'سرخای کندی',
        14467: 'قشلاق جلیللو',
        14468: 'حاجی دولت',
        14469: 'ایدر',
        14470: 'قره تکانلو',
        14471: 'بودجه سفلی',
        14472: 'بیله سوار',
        14473: 'بابک',
        14474: 'روح کندی',
        14475: 'گوگ تپه',
        14476: 'ادلو',
        14477: 'فولادلوقوئی',
        14478: 'اینجلو',
        14479: 'اوجاق قشلاق خروسلو',
        14480: 'هیبت جهانخانلو',
        14481: 'اوچ بلاغ',
        14482: 'قشلاق حاج طهراج',
        14483: 'جعفرآباد',
        14484: 'شورگل',
        14485: 'خلیفه لوبیله سوار',
        14486: 'گوردیگل',
        14487: 'خورخورعلیا',
        14488: 'حاج خانعلی کندی',
        14489: 'میرودی کندی',
        14490: 'باباش علیا',
        14491: 'قشلاق اینالی برات',
        14492: 'دمیرچی خرابه سی'
    },
    10: {
        14784: 'مشهد',
        14785: 'چاهشک',
        14786: 'جغری',
        14787: 'احمدآباد/تبادگان',
        14788: 'هندل آباد',
        14789: 'تبادگان',
        14790: 'دهرود/گرجی سفلی',
        14791: 'دوین/چنارسوخته',
        14792: 'ماریان',
        14793: 'شهرک/صنعتی/کلات',
        14794: 'کورده',
        14795: 'چهچهه/پائین ده',
        14796: 'شترک',
        14797: 'کنه بیست',
        14798: 'امرغان سفلی',
        14799: 'عسگریه',
        14800: 'فاز',
        14801: 'رضوان',
        14802: 'خلق آباد',
        14803: 'فرخد',
        14804: 'پرمه/فارمد',
        14805: 'علی آبادسیاسک',
        14806: 'ناظریه',
        14807: 'کال زرکش',
        14808: 'حسین آباد/قرقی',
        14809: 'انداد',
        14810: 'سروآباد/بازمرگی',
        14811: 'ده غیبی مشهد',
        14812: 'قازقان',
        14813: 'شهرک/صنعتی/طوس',
        14814: 'چهاربرج',
        14815: 'دیزباد',
        14816: 'شهرک صنعتی/کاویان',
        14817: 'هدایت آباد',
        14818: 'چرمشهر',
        14819: 'گوارشک',
        14820: 'لائین نو',
        14821: 'کریم آبادکلات',
        14822: 'شهرطوس',
        14823: 'کلات نادر',
        14824: 'قله زو',
        14825: 'زاوین',
        14826: 'چنارمشهد',
        14827: 'گرو',
        14828: 'ایده لیک',
        14829: 'آبگرم',
        14830: 'قلعه نوکلات',
        14831: 'شهید/هنرمند',
        14832: 'کالوکلات',
        14833: 'کرناوه شیرین',
        14834: 'چهچهه کلات',
        14835: 'شهرک/رضوی',
        14836: 'چاهک',
        14837: 'اره آبمال',
        14838: 'میامی',
        14839: 'تنگل شورعلیا',
        14840: 'سالارآباد',
        14841: 'تقی آباد',
        14842: 'سلیمانی مشهد',
        14843: 'آبروان',
        14844: 'ملک آبادمشهد',
        14845: 'جیم آباد',
        14846: 'نریمانی',
        14847: 'تپه سلام',
        14848: 'اوارشک',
        14849: 'بینالود',
        14850: 'صیدآباد',
        14851: 'سلطان آبادنمک',
        14852: 'امام/تقی',
        14853: 'حسین آباد/سرجام',
        14854: 'سرغایه',
        14855: 'قاسم آباد/بزرگ',
        14856: 'فخرداود',
        14857: 'پیوه ژن',
        14858: 'رباط سفید',
        14859: 'النگ امان آباد',
        14860: 'کال چغوکی',
        14861: 'حسین آباد/رازون',
        14862: 'ده سرخ',
        14863: 'بزوشک',
        14864: 'طرقبه',
        14865: 'جاغرق',
        14866: 'دهبار',
        14867: 'حصارمشهد',
        14868: 'مایان',
        14869: 'ازغد',
        14870: 'نقندر',
        14871: 'شاندیز',
        14872: 'حصارسرخ/سرآسیاب سوران',
        14873: 'زشک',
        14874: 'کنگ',
        14875: 'ویرانی',
        14876: 'مغان',
        14877: 'گراخک',
        14878: 'سرخس',
        14879: 'قوش عظیم',
        14880: 'قوش سربوزی',
        14881: 'قوش خزاعی',
        14882: 'شیرتپه',
        14883: 'کندکلی',
        14884: 'گنبدلی',
        14885: 'تپه میراحمد',
        14886: 'تام میرزاحسن',
        14887: 'سنگر',
        14888: 'کچولی',
        14889: 'یاس تپه',
        14890: 'ابراهیم آباد/مشهد',
        14891: 'چاله زرد',
        14892: 'کلاته اله نظر',
        14893: 'مزداوند',
        14894: 'چکودر',
        14895: 'بزنگان',
        14896: 'معدن/زغال سنگ',
        14897: 'پس کمر',
        14898: 'فریمان',
        14899: 'سنگ بست',
        14900: 'کارخانه/قند/فریمان',
        14901: 'باغ عباسی',
        14902: 'قلعه نومشهد',
        14903: 'فرهادگرد',
        14904: 'عشق آبادفریمان',
        14905: 'احمدآباد/سرجام',
        14906: 'اقرعلیا',
        14907: 'میاندهی فریمان',
        14908: 'حسن آباد/صوفی',
        14909: 'بزجانی',
        14910: 'سردشت',
        14911: 'زرکک',
        14912: 'قلندرآباد',
        14913: 'سفیدسنگ',
        14914: 'کاریزحاج محمدجان',
        14915: 'کته شمشیرسفلی',
        14916: 'رخنه گل',
        14917: 'کته شمشیرعلیا',
        14918: 'تربت جام',
        14919: 'محمودآبادسفلی',
        14920: 'محمودآبادعلیا',
        14921: 'بزد',
        14922: 'رونج',
        14923: 'چشمه گل',
        14924: 'امغان',
        14925: 'موسی آباد',
        14926: 'نوده تربت جام',
        14927: 'تیمنک/علیا/سفلی',
        14928: 'اسماعیل آباد/گرجی',
        14929: 'شیخ لو',
        14930: 'یکه پسته',
        14931: 'احمدآباد/تربت جام',
        14932: 'خیرآباد/تربت جام',
        14933: 'رباط سمنگان',
        14934: 'کاریزنو',
        14935: 'نیل آباد',
        14936: 'قلعه گک',
        14937: 'رحمت آباد/تربت جام',
        14938: 'نصرآباد',
        14939: 'یاقوتین',
        14940: 'سمیع آباد',
        14941: 'قلعه سرخ تربت جام',
        14942: 'ابدال آباد',
        14943: 'خرم آباد/تربت جام',
        14944: 'مومن آباد',
        14945: 'جعفرآباد/تربت جام',
        14946: 'حسن آباد/تربت جام',
        14947: 'قلعه شیر',
        14948: 'کلاته بزرگ',
        14949: 'یادگار',
        14950: 'برود/علی آباد',
        14951: 'محمدآبادتربت جام',
        14952: 'دولت آباد/تربت جام',
        14953: 'المجوق',
        14954: 'سملخون',
        14955: 'کلاته صوفی',
        14956: 'بنی تاک',
        14957: 'صالح آباد',
        14958: 'گوش لاغر',
        14959: 'جنت آباد/تربت جام',
        14960: 'آزاده ده',
        14961: 'کاریزکهندل',
        14962: 'درازآب تربت جام',
        14963: 'ممیزآب تربت جام',
        14964: 'شورستان',
        14965: 'باغ کشمیر',
        14966: 'یکه توت',
        14967: 'جعفریه',
        14968: 'جهان آباد',
        14969: 'درخت بید',
        14970: 'تایباد',
        14971: 'کوه آباد',
        14972: 'فرزنه',
        14973: 'کاریز',
        14974: 'گمرک دوغارون',
        14975: 'مشهدریزه',
        14976: 'آبقه',
        14977: 'فرمان آباد',
        14978: 'پل بند',
        14979: 'استای',
        14980: 'حسینی',
        14981: 'پشته',
        14982: 'کرات',
        14983: 'خیرآباد/تایباد',
        14984: 'جوزقان',
        14985: 'اسدآباد/دربندی',
        14986: 'سوران',
        14987: 'چهاربرجی',
        14988: 'همت آبادتربت جام',
        14989: 'قلعه سرخ باخرز',
        14990: 'سورستان',
        14991: 'باخرز',
        14992: 'جیزآباد',
        14993: 'ارزنه',
        14994: 'قلعه باخزر',
        14995: 'آبینه',
        14996: 'کردیان',
        14997: 'سنقرآباد',
        14998: 'کوه سفید',
        14999: 'تورانه',
        15000: 'ده برزو',
        15001: 'کافج',
        15002: 'تربت حیدریه',
        15003: 'اسفیوخ',
        15004: 'فدرد',
        15005: 'ده پائین',
        15006: 'فهندر',
        15007: 'کامه علیا',
        15008: 'صنوبر',
        15009: 'آبرودتربت حیدریه',
        15010: 'سیوکی',
        15011: 'حوض سرخ',
        15012: 'بوری آباد',
        15013: 'سنگل آباد',
        15014: 'آلی',
        15015: 'بایگ',
        15016: 'رزگ',
        15017: 'حصارتربت حیدریه',
        15018: 'رودمعجن',
        15019: 'سرخ آباد',
        15020: 'فدیهه',
        15021: 'رباط سنگ',
        15022: 'کدکن',
        15023: 'نسر',
        15024: 'سلطان آباد',
        15025: 'عبدآباد',
        15026: 'سربالا',
        15027: 'برس',
        15028: 'تلخ بخش',
        15029: 'فخرآبادتربت حیدریه',
        15030: 'جوادیه',
        15031: 'اسدآبادرخ',
        15032: 'سرهنگ',
        15033: 'گرماب تربت حیدریه',
        15034: 'علاقه',
        15035: 'یک لنگی علیا',
        15036: 'احمدآباد/خزائی',
        15037: 'رودخانه',
        15038: 'خرم/عمادیه',
        15039: 'دافی',
        15040: 'اسفیز',
        15041: 'حاجی بیگی',
        15042: 'حاجی آباد/تربت حیدریه',
        15043: 'ژرف',
        15044: 'گلسرا',
        15045: 'کلاته زنگنه',
        15046: 'ریگان',
        15047: 'عنبرسرا',
        15048: 'سرگلان',
        15049: 'گوجی',
        15050: 'دولت آباد/تربت حیدریه',
        15051: 'چخماق',
        15052: 'زاوه',
        15053: 'کاریزک ناگهانی',
        15054: 'صفی آباد',
        15055: 'قلعه آقاحسن',
        15056: 'کاهیجه',
        15057: 'علیک تربت حیدریه',
        15058: 'ساق',
        15059: 'پطرو',
        15060: 'مرغزار',
        15061: 'شهن آباد',
        15062: 'سهل آباد',
        15063: 'دهنوتلخی',
        15064: 'نصیرآباد',
        15065: 'قلعه نی',
        15066: 'قلعه نوصفی آباد',
        15067: 'کنگ علیا',
        15068: 'بیدوی',
        15069: 'کشکک',
        15070: 'شاهین علیا',
        15071: 'شهوار',
        15072: 'جعفرآباد/زاوه',
        15073: 'خواف',
        15074: 'احمدآباد/خواف',
        15075: 'چمن آباد',
        15076: 'رزدآب',
        15077: 'سلمان/خلیل آباد',
        15078: 'سلامی',
        15079: 'سده خواف',
        15080: 'خرگرد',
        15081: 'تیزآب',
        15082: 'فایندر',
        15083: 'چهارده',
        15084: 'مهرآباد',
        15085: 'عباس آبادخواف',
        15086: 'شهرک/خواف',
        15087: 'خیرآباد/خواف',
        15088: 'سیجاوند',
        15089: 'حسن آباد/خواف',
        15090: 'هزارخوشه',
        15091: 'سنگان پائین',
        15092: 'برآباد/تربت حیدریه',
        15093: 'نشتیفان',
        15094: 'معدن سنگان',
        15095: 'نیازآباد',
        15096: 'مژن آباد',
        15097: 'بهدادین',
        15098: 'چاه زول',
        15099: 'حسین آباد/کاریون',
        15100: 'اسدآباد/خواف',
        15101: 'قاسم آبادتربیت حیدریه',
        15102: 'بیاس آباد',
        15103: 'کال شور/تپه خان',
        15104: 'علی آباد/خواف',
        15105: 'حسن آباد/پائین',
        15106: 'بنیاباد',
        15107: 'رشتخوار',
        15108: 'احمدآباد/رشتخوار',
        15109: 'جنگل',
        15110: 'فتح آبادتربت حیدریه',
        15111: 'سنگان بالا',
        15112: 'محمدآبادرشتخوار',
        15113: 'دولت آباد/رشتخوار',
        15114: 'مهدی آبادرشتخوار',
        15115: 'باسفر',
        15116: 'جنت آباد/جنگل',
        15117: 'عباس آبادفرامیشان',
        15118: 'سعادت آباد',
        15119: 'عبس آباد',
        15120: 'نوق تربت حیدریه',
        15121: 'علی آباددامن',
        15122: 'براکوه',
        15123: 'کت',
        15124: 'روح آباد/تربت حیدریه',
        15125: 'ملک آبادتربت حیدریه',
        15126: 'شعبه',
        15127: 'فاردق',
        15128: 'اکبرآباد/رشتخوار',
        15129: 'آهنگران',
        15130: 'بندازبک',
        15131: 'قادرآباد',
        15132: 'چاهشورک',
        15133: 'فیض آبادتربت حیدریه',
        15134: 'دوغ آباد',
        15135: 'عبدل آباد',
        15136: 'احمدآباد/محولات',
        15137: 'مهنه',
        15138: 'شادمهر',
        15139: 'ازغند',
        15140: 'حسن آباد/محولات',
        15141: 'همت آبادفیض آباد',
        15142: 'چنارتربت حیدریه',
        15143: 'خیرآباد/تربت حیدریه',
        15144: 'زرمهر',
        15145: 'شمس آبادتربت حیدریه',
        15146: 'خوشدره',
        15147: 'جنت آباد/محولات',
        15148: 'علی آبادفیض آباد',
        15149: 'قلعه جوق',
        15150: 'میاندهی فیض آباد',
        15151: 'بردسکن',
        15152: 'کوشه بردسکن',
        15153: 'انابد',
        15154: 'شفیع آباد',
        15155: 'شهرآباد/بردسکن',
        15156: 'زیرک آباد',
        15157: 'کبودان',
        15158: 'سیر',
        15159: 'باب الحکم',
        15160: 'رکن آباد',
        15161: 'علی آبادکشمر',
        15162: 'درونه',
        15163: 'مظفرآباد',
        15164: 'عظیم آباد',
        15165: 'کاظم آباد',
        15166: 'حسن آباد/بردسکن',
        15167: 'ابراهیم آباد',
        15168: 'ظاهرآبادبردسکن',
        15169: 'کلاته نو',
        15170: 'اسلام آباد/تربت حیدریه',
        15171: 'سیف آباد',
        15172: 'جلال آباد',
        15173: 'هدک/سربرج',
        15174: 'خور/بیجورد',
        15175: 'کاسف',
        15176: 'برجک',
        15177: 'خلیل آباد',
        15178: 'کندرخلیل آباد',
        15179: 'سعدالدین',
        15180: 'ارغا',
        15181: 'جابوز',
        15182: 'نقاب تربت حیدریه',
        15183: 'کلاته شادی',
        15184: 'مهدی آبادکاشمر',
        15185: 'جعفرآباد/کاشمر',
        15186: 'کاهه',
        15187: 'کاریزک خلیل آباد',
        15188: 'هفت خانه',
        15189: 'تکمار',
        15190: 'کاشمر',
        15191: 'عشرت آباد/ممرآباد',
        15192: 'رزق آباد',
        15193: 'جردوی',
        15194: 'فدافن',
        15195: 'سرحوضک',
        15196: 'قلعه بالا',
        15197: 'تربقان',
        15198: 'نای',
        15199: 'فرشه',
        15200: 'کسرینه',
        15201: 'فرگ',
        15202: 'عارف آباد',
        15203: 'اسحاق آبادتربت حیدریه',
        15204: 'قوچ پلنگ',
        15205: 'شهرک صنعتی/کاشمر',
        15206: 'خضربیگ',
        15207: 'ریوش',
        15208: 'ایورتربت حیدریه',
        15209: 'تولی/بختیار',
        15210: 'اوندر',
        15211: 'موشک',
        15212: 'مکی',
        15213: 'طرق',
        15214: 'نامق',
        15215: 'اکبرآبادریوش',
        15216: 'کریز',
        15217: 'تنورچه',
        15218: 'ده میان',
        15219: 'توندر',
        15220: 'کوشه کوه سرخ',
        15221: 'قراچه',
        15222: 'قصون',
        15223: 'بندقرا',
        15224: 'فردوس',
        15225: 'اسلامیه',
        15226: 'مهوید',
        15227: 'باغستان',
        15228: 'بیدسکان',
        15229: 'فتح آبادفردوس',
        15230: 'برون',
        15231: 'خانکوک',
        15232: 'مهران کوشک',
        15233: 'سرند',
        15234: 'گستج',
        15235: 'انارستانک/خانیک برون',
        15236: 'بشرویه',
        15237: 'شهرک/امام/خمینی',
        15238: 'ارسک',
        15239: 'رقه',
        15240: 'کرند',
        15241: 'غنی آباد',
        15242: 'نیگنان',
        15243: 'خانیک بشرویه/یگی',
        15244: 'فتح آبادارسک',
        15245: 'بجستان',
        15246: 'آهنگ',
        15247: 'یونسی',
        15248: 'سردق',
        15249: 'جزین',
        15250: 'فخرآبادفردوس',
        15251: 'مرندیز',
        15252: 'سریده',
        15253: 'نوق فردوس',
        15254: 'زین آباد',
        15255: 'درزآب فردوس',
        15256: 'منصوری',
        15257: 'مزار',
        15258: 'قاسم آباد/فردوس',
        15259: 'گناباد',
        15260: 'حاجی آباد/فردوس',
        15261: 'بیدخت',
        15262: 'خانیک گناباد',
        15263: 'زیبد',
        15264: 'کلات',
        15265: 'کاخک',
        15266: 'روچی',
        15267: 'سقی',
        15268: 'دیسفان',
        15269: 'بیمرغ',
        15270: 'گیسور',
        15271: 'سنو',
        15272: 'قوژدفردوس',
        15273: 'ریاب',
        15274: 'روشناوند',
        15275: 'رهن',
        15276: 'نوده پشنگ',
        15277: 'نوده/بیهود',
        15278: 'فودنجان',
        15279: 'استاد',
        15280: 'رحمت آباد/فردوس',
        15281: 'زیرجان',
        15440: 'نیشابور',
        15441: 'قلعه نوجمشید',
        15442: 'جیلو',
        15443: 'سیدآبادنیشابور',
        15444: 'بشنج',
        15445: 'خرمبک/سه چوب',
        15446: 'بوژان',
        15447: 'صومعه',
        15448: 'لطف آبادنیشابور',
        15449: 'نوروزآباد',
        15450: 'فوشنجان',
        15451: 'بوژآباد',
        15452: 'شاداب',
        15453: 'فرخک',
        15454: 'مجتمع/فولاد/نیشابور',
        15455: 'باغشن گچ',
        15456: 'قطن آباد',
        15457: 'بشرآباد',
        15458: 'میرآباد',
        15459: 'روح آباد/نیشابور',
        15460: 'قدمگاه',
        15461: 'دررود',
        15462: 'حصارزبرخان',
        15463: 'حاجی آباد/نیشابور',
        15464: 'خروعلیا',
        15465: 'اسحاق آبادنیشابور',
        15466: 'دیش دیش',
        15467: 'باغشن نیشابور',
        15468: 'چناران نیشابور',
        15469: 'گرینه',
        15470: 'بوژمهران',
        15471: 'اردوغش',
        15472: 'عبداله آبادنیشابور',
        15473: 'دیزبادعلیا',
        15474: 'دستجردآقابزرگ',
        15475: 'محسن آباد',
        15476: 'سعدیه',
        15477: 'عشق آبادنیشابور',
        15478: 'صمدیه',
        15479: 'گلبو',
        15480: 'اردمه',
        15481: 'بزق',
        15482: 'فدیشه',
        15483: 'حسین آباد/جنگل',
        15484: 'احمدآباد/نیشابور',
        15485: 'رئیسی',
        15486: 'چاه نسر',
        15487: 'قاسم آباد/دهنه',
        15488: 'اسلام آباد/نیشابور',
        15489: 'چاه سالار',
        15490: 'حسن آباد/نیشابور',
        15491: 'ریگی/زمه',
        15492: 'شوررود',
        15493: 'عطائیه',
        15494: 'جنداب',
        15495: 'همائی',
        15496: 'سالاری',
        15497: 'شهرآباد/نیشابور',
        15498: 'شهرفیروزه',
        15499: 'گرماب نیشابور',
        15500: 'سلیمانی نیشابور',
        15501: 'بار',
        15502: 'همت آبادشهرکهنه',
        15503: 'شوراب',
        15504: 'ینگه قلعه/شمس',
        15505: 'امان آباد',
        15506: 'همت آبادزمانی',
        15507: 'خانلق',
        15508: 'معدن فیروزه',
        15509: 'رهن کاریز/کفکی',
        15510: 'قلعه یزدان',
        15511: 'نیرآباد/توزنده جان کهنه ونو',
        15512: 'بتو',
        15513: 'بقیع',
        15514: 'چنبرجوق',
        15515: 'چزگ',
        15516: 'شوری بزرگ/رشیدآباد',
        15517: 'شوریاب',
        15518: 'فرخار',
        15519: 'شورگشت',
        15520: 'قره باغ فیروزه',
        15521: 'ماروسک',
        15522: 'مرزان/فهنه',
        15523: 'دستجردطاقانکوه',
        15524: 'بجنو',
        15525: 'نوسرانومیری',
        15526: 'برزنون',
        15527: 'سرچاه',
        15528: 'سلطان میدان',
        15529: 'چگنه سفلی',
        15530: 'ساقی بیک',
        15531: 'طالبی',
        15532: 'زهان',
        15533: 'دزق',
        15534: 'ینگجه',
        15535: 'کلیدر',
        15536: 'کوه سخت',
        15537: 'عبداله گیو',
        15708: 'سبزوار',
        15709: 'فسنقر',
        15710: 'ابارش',
        15711: 'رباط سرپوش',
        15712: 'باغجر',
        15713: 'شهرصنعتی/سبزوار',
        15714: 'استیر',
        15715: 'کراب',
        15716: 'کسکن',
        15717: 'علی آبادشور',
        15718: 'نزل آباد',
        15719: 'جلین',
        15720: 'خیرآباد/سبزوار',
        15721: 'آزادمنجیر',
        15722: 'ایزی',
        15723: 'خسروجرد',
        15724: 'دولت آباد/سبزوار',
        15725: 'حارث آباد',
        15726: 'برزو',
        15727: 'قره قلی',
        15728: 'افچنگ',
        15729: 'هاشم آباد',
        15730: 'ششتمد',
        15731: 'شامکان',
        15732: 'کیذور',
        15733: 'تندک',
        15734: 'مچ',
        15735: 'طرسک',
        15736: 'برازق',
        15737: 'بجدن تکاب',
        15738: 'عزیزآباد',
        15739: 'یحیی آباد',
        15740: 'روشن آباد',
        15741: 'حسین آباد/شامکان',
        15742: 'خرسف',
        15743: 'کلاته نوبهار',
        15744: 'داورزن',
        15745: 'مهر',
        15746: 'نامن',
        15747: 'بیزه',
        15748: 'باشتین',
        15749: 'نهالدان',
        15750: 'کلاته مزینان',
        15751: 'ریوند',
        15752: 'کمیز',
        15753: 'صدخرو',
        15754: 'مزینان',
        15755: 'چشام',
        15756: 'مقیسه',
        15757: 'آبرودسبزوار',
        15758: 'سویز',
        15759: 'فیض آبادداورزن',
        15760: 'خسروآباد',
        15761: 'حسین آباد/ناوی',
        15762: 'نقاب سبزوار',
        15763: 'حکم آباد',
        15764: 'برغمد',
        15765: 'قزل قارشی',
        15766: 'کلاته عرب',
        15767: 'کلاته میمری',
        15768: 'کارخانه/قندجوین',
        15769: 'انداده',
        15770: 'قلعه نو/شفیع آباد',
        15771: 'زورآباد',
        15772: 'رحمت آباد/سبزوار',
        15773: 'عباس آباد',
        15774: 'خرم آباد/سبزوار',
        15775: 'ارگ نوجوی',
        15776: 'حسین آباد/میرزامومن',
        15777: 'زیرآباد',
        15778: 'جلمبادان',
        15779: 'بید',
        15780: 'احمدآباد/بالاجوین',
        15781: 'رامشین',
        15782: 'کریم آباد',
        15783: 'عباس آبادملک',
        15784: 'بداغ آباد',
        15785: 'جغتای',
        15786: 'زرقان',
        15787: 'ده امام',
        15788: 'راه چمن',
        15789: 'فراشیان',
        15790: 'شهرستانک',
        15791: 'ابوچناری',
        15792: 'فریمانه',
        15793: 'عبدل آبادسبزوار',
        15794: 'آزادوار',
        15795: 'محمدآبادگفت',
        15796: 'زمند',
        15797: 'کهنه',
        15798: 'حسین آباد/رحیم خان',
        15799: 'برقبان',
        15800: 'سلطان آبادسبزوار',
        15801: 'رباط جز',
        15802: 'مشکان',
        15803: 'نوده انقلاب',
        15804: 'شم آباد',
        15805: 'طبس',
        15806: 'بلقان آباد',
        15807: 'سیدآبادسبزوار',
        15808: 'شیرخان',
        15809: 'چرو',
        15810: 'درفک',
        15811: 'نودهان',
        15812: 'علیک سبزوار',
        15822: 'سارمران',
        15832: 'راوخ',
        15838: 'قلعه نوروداب',
        15839: 'آریان',
        15841: 'برآباد/سبزوار',
        15842: 'ملوند',
        15843: 'شمس آبادسبزوار',
        15844: 'بجدن خواشد',
        15845: 'قوچان',
        15846: 'شفیع',
        15847: 'دیزادیز/کچلانلو',
        15848: 'دوغائی',
        15849: 'عمارت',
        15850: 'یدک',
        15851: 'فرخان',
        15852: 'داغیان',
        15853: 'آلماجوق',
        15854: 'علی آبادقوچان',
        15855: 'بیگ نظر',
        15856: 'مقصودآباد',
        15857: 'کلاته علی زینل',
        15858: 'آق کاریز',
        15859: 'خمارتاش',
        15860: 'زیدانلو',
        15861: 'بیگلر',
        15862: 'قره شاه وردی',
        15863: 'چیتگر',
        15864: 'آبگرگ',
        15865: 'داودلی',
        15866: 'یوسفخان',
        15867: 'حسن آباد/قوچان',
        15868: 'شهرکهنه',
        15869: 'الهیان',
        15870: 'مزرج',
        15871: 'شغل آباد',
        15872: 'کلوخی',
        15873: 'کهنه فرود',
        15874: 'گوجه',
        15875: 'شاهرگ',
        15877: 'باجگیران',
        15878: 'امامقلی',
        15879: 'جوزان/شیرزن',
        15880: 'کلاته ملامحمد/قاچکانلو',
        15881: 'امام وردیخان',
        15882: 'آب جهان/رهورد',
        15883: 'شارک',
        15884: 'چکنه سفلی',
        15885: 'درگز',
        15886: 'تاج الدین',
        15887: 'قره قویونلو',
        15888: 'کاهودرگز',
        15889: 'چقر',
        15890: 'نوخندان',
        15891: 'برج قلعه',
        15892: 'پالکانلو',
        15893: 'زیندانلو',
        15894: 'شوی',
        15895: 'چنارقوچان',
        15896: 'محمدتقی بیگ',
        15897: 'تگن',
        15898: 'جشن آباد',
        15899: 'لطف آبادقوچان',
        15900: 'شیلیگان',
        15901: 'تیرگان',
        15902: 'حاتم قلعه',
        15903: 'زنگانلو',
        15904: 'قازان بیک',
        15905: 'چاپشلو',
        15906: 'حسن آباد/درگز',
        15907: 'داغدار',
        15908: 'پرکند',
        15909: 'میاب',
        15910: 'چناران قوچان',
        15911: 'بقمج',
        15912: 'رادکان',
        15913: 'سیدآبادچناران',
        15914: 'بهمن جان علیا',
        15915: 'قیاص آباد',
        15916: 'گلبهار',
        15917: 'گلمکان',
        15918: 'دولت آباد/قوچان',
        15919: 'اخلمد',
        15920: 'موچنان',
        15921: 'چمگرد',
        15922: 'حکیم آباد',
        15923: 'بهمن جان سفلی',
        15924: 'سرک',
        15925: 'خرم آباد/قوچان',
        15926: 'محمدآبادقوچان',
        15927: 'فریزی',
        15928: 'سرآسیاب',
        15929: 'کاهوچناران',
        15930: 'اسجیل',
        15931: 'سلوگرد',
        15932: 'نوبهار',
        15933: 'احمدآباد/قوچان',
        15934: 'کلاته پایه'
    },
    11: {
        13282: 'تبریز',
        13283: 'سهلان',
        13284: 'مایان سفلی',
        13285: 'الوارسفلی',
        13286: 'الوارعلیا',
        13287: 'قزل دیزج',
        13288: 'ینگی اسپران',
        13289: 'اولی کندی',
        13290: 'باباباغی',
        13291: 'خواجه دیزج',
        13292: 'باغ معروف/کجاآباد',
        13293: 'اسنجان',
        13294: 'انرجان',
        13295: 'زینجناب',
        13296: 'کرجان',
        13297: 'هزارباران',
        13298: 'قزلچه میدان',
        13299: 'کندرودتبریز',
        13300: 'دیزج لیلی خانی',
        13301: 'سفیده خوان/اسپرج خوان',
        13302: 'استیارتبریز',
        13303: 'بیرق',
        13304: 'چاوان',
        13305: 'اسکندر',
        13306: 'شادآبادمشایخ',
        13307: 'شادآبادعلیا',
        13308: 'لیقوان',
        13309: 'ملک کیان',
        13310: 'هروی',
        13311: 'آرپادره سی',
        13312: 'کرکج',
        13313: 'باسمنج',
        13314: 'بارانلو',
        13315: 'لاهیجان',
        13316: 'خسروشهر',
        13317: 'تازه کندتبریز',
        13318: 'اسفهلان',
        13319: 'ساتلو',
        13320: 'آخولا',
        13321: 'نوجه ده',
        13322: 'خلجان',
        13323: 'اسکو',
        13324: 'ایلخچی',
        13325: 'عنصرود',
        13326: 'کردلرتبریز',
        13327: 'گنبرف',
        13328: 'کردآباد',
        13329: 'زین الحاجیلو',
        13330: 'دیزج امیرمدار',
        13331: 'شهرک/سهند',
        13332: 'کهنمو',
        13333: 'کلجاه',
        13334: 'اسفنجان',
        13335: 'باویل علیاسفلی',
        13336: 'اسکندان',
        13337: 'مجارشین',
        13338: 'قپچاق',
        13339: 'خورخور',
        13340: 'سرین دیزج',
        13341: 'آمقان',
        13342: 'آق گنبد',
        13343: 'خاصبان',
        13344: 'گمیچی',
        13345: 'سرای ده',
        13346: 'اربط',
        13347: 'بوراچارلو',
        13348: 'تپه قندیلو',
        13349: 'آذرشهر',
        13350: 'الوانق',
        13351: 'ممقان',
        13352: 'سیلاب',
        13353: 'امیردیزج',
        13354: 'قاضی جهان',
        13355: 'شیرامین',
        13356: 'نادیلو',
        13357: 'پیرچوپان',
        13358: 'هفت چشمه',
        13359: 'خانقاه تبریز',
        13360: 'دین آباد',
        13361: 'گاوکان/آخی جهان/تیمورلو',
        13362: 'داشکسن تبریز',
        13363: 'کوخالو',
        13364: 'صغایش',
        13365: 'داش آلمالو',
        13366: 'زینتلو',
        13367: 'قدمگاه/بادامیار',
        13368: 'قوشقرا',
        13369: 'کلوانق تبریز',
        13370: 'گواهر',
        13371: 'بناب تبریز',
        13372: 'زاوشت',
        13373: 'خانه برق جدید',
        13374: 'خانه برق قدیم',
        13375: 'خوشه مهر/ینگی کندی',
        13376: 'آلقو',
        13377: 'تازه کندچلقائی',
        13378: 'دیزج پروانه',
        13379: 'قره قشلاق',
        13380: 'آخوندقشلاق',
        13381: 'روشت بزرگ/دوش',
        13382: 'زوارق/کوته مهر',
        13383: 'چپقلو',
        13384: 'توتاخانه',
        13385: 'مراغه',
        13386: 'ورجوی',
        13387: 'کرده ده',
        13388: 'تازه کندسفلی',
        13389: 'گل تپه',
        13390: 'ینگجه مراغه',
        13391: 'نرج آباد',
        13392: 'کهجوق',
        13393: 'قلعه خالصه',
        13394: 'سرج',
        13395: 'داش آتان',
        13396: 'دیورزم',
        13397: 'سنوکش',
        13398: 'تازه کندقشلاق',
        13399: 'اشان',
        13400: 'هریس مراغه',
        13401: 'آهق',
        13402: 'قرطاول',
        13403: 'کرج آباد',
        13404: 'مغانجیق',
        13405: 'کهق',
        13406: 'بهنق',
        13407: 'مردق',
        13408: 'خانقاه مراغه',
        13409: 'کامل آباد',
        13410: 'اصفهانجیق',
        13411: 'سرگیزه',
        13412: 'شلیلوند',
        13413: 'اکیس',
        13414: 'خلیفه کندی',
        13415: 'خرمازرد',
        13416: 'چوان علیا',
        13417: 'چوانباغ',
        13418: 'چوان سفلی',
        13419: 'گشایش',
        13420: 'گل',
        13421: 'عجب شیر',
        13422: 'خضرلو',
        13423: 'شیراز',
        13424: 'رازیان',
        13425: 'ینگجه عجب شیر',
        13426: 'نبرین',
        13427: 'هرکلان',
        13428: 'قوزلوجه',
        13429: 'جوان قلعه',
        13430: 'مهماندارعجب شیر',
        13431: 'آلمالو',
        13432: 'بوکت',
        13433: 'چنار',
        13434: 'حوری',
        13435: 'گنبد/زاویه',
        13436: 'ولنجیق',
        13437: 'تجرق مراغه',
        13438: 'یایچی',
        13439: 'چهاربرود',
        13440: 'خراجو',
        13441: 'بلوک آباد',
        13442: 'کرمجوان',
        13443: 'صومعه سفلی',
        13444: 'آغچه کهل مراغه',
        13445: 'صومعه علیامراغه',
        13446: 'چلان سفلی',
        13447: 'پالچقلو',
        13448: 'چگان',
        13449: 'گلستان علیا',
        13450: 'هبش',
        13451: 'یانبلاغ',
        13452: 'گلستان سفلی',
        13453: 'گویجه قملاق',
        13454: 'آغبلاغ علیا',
        13455: 'جیران سفلی',
        13456: 'گلی کندی',
        13457: 'آلماچوان',
        13458: 'بیانلوجه',
        13459: 'داشبلاغ بازار',
        13460: 'چبینلو',
        13461: 'چلان علیا',
        13462: 'مولو',
        13463: 'ملکان',
        13464: 'لیلان',
        13465: 'آغکندقره خضر',
        13466: 'دمیرچی ملکان',
        13467: 'علی آبادگوراوان قشلاقی',
        13468: 'آروق',
        13469: 'بایقوت',
        13470: 'تازه قلعه',
        13471: 'تورچی',
        13472: 'شریفلو',
        13473: 'قره خضر',
        13474: 'یوزباش کندی',
        13475: 'مهماندارملکان',
        13476: 'قوریجان',
        13477: 'لکلر',
        13478: 'مبارک آباد',
        13479: 'تپه/اسماعیل آباد',
        13480: 'یورقنلوی جدید',
        13481: 'آغمنار',
        13482: 'حسین آباد',
        13483: 'گدکلو',
        13484: 'شورجه طورآغای',
        13485: 'قلعه جوق',
        13486: 'شیرین کندی',
        13487: 'قوش قیه سی',
        13488: 'ایده لوی بزرگ',
        13489: 'باباکلک',
        13490: 'شیخ الاسلام',
        13491: 'قاشقچی',
        13492: 'قربان کندی',
        13493: 'مجیدآبادمراغه',
        13494: 'محسن آباد',
        13495: 'شیخ بابا',
        13496: 'میانه',
        13497: 'کهبنان',
        13498: 'گون دوغدی',
        13499: 'آچاچی',
        13500: 'برنلیق',
        13501: 'چتاب/علیا/سفلی',
        13502: 'ماهی آباد',
        13503: 'دوه داشی',
        13504: 'خوبستان',
        13505: 'سبزارباط',
        13506: 'ممان',
        13507: 'چرکنلو',
        13508: 'گونلو',
        13509: 'سیاه کمر',
        13510: 'پورسخلو',
        13511: 'قاسم درق',
        13512: 'قلیچ چی',
        13513: 'قواق علیا',
        13514: 'زاویه میانه',
        13515: 'گلبوس',
        13516: 'دادلو',
        13517: 'قویجاق',
        13518: 'طغای',
        13519: 'قره اور',
        13520: 'چولاقلو',
        13521: 'شیخدرآباد',
        13522: 'کنگاور',
        13523: 'طوق',
        13524: 'زرنق میانه',
        13525: 'قراجه میانه',
        13526: 'قره طورق',
        13527: 'باشماق میانه',
        13528: 'درین درق',
        13529: 'کلوچه خالصه',
        13530: 'ترکمن چای',
        13531: 'یالقوزآغاج میانه',
        13532: 'گاوینه رود',
        13533: 'نودلق',
        13534: 'برزلیق',
        13535: 'بقرآباد',
        13536: 'دستجرد/بلوکان',
        13537: 'صومعه علیامیانه',
        13538: 'کلهرمیانه',
        13539: 'ورزقان میانه',
        13540: 'غریب دوست/مهماندوست',
        13541: 'شیخ احمدلو',
        13542: 'خاتون آباد',
        13543: 'گوگدرق',
        13544: 'کوهسالار',
        13545: 'قباق تپه',
        13546: 'بیات سفلی',
        13547: 'شیخ طبق',
        13548: 'ورنکش',
        13549: 'حلمسی',
        13550: 'خواجه غیاث',
        13551: 'آشنار',
        13552: 'سوینج',
        13553: 'بلفه تیمور',
        13554: 'ترک',
        13555: 'کزرج',
        13556: 'قشلاق سیف الدین',
        13557: 'ایشلق',
        13558: 'اونلیق',
        13559: 'بالسین',
        13560: 'آرموداق',
        13561: 'آوین/مسجدلو',
        13563: 'خانقاه میانه',
        13564: 'النجارق',
        13565: 'کسلان',
        13566: 'نشق/نقاباد',
        13567: 'ونجان',
        13568: 'طوین',
        13569: 'ملک',
        13570: 'ینگجه میانه',
        13571: 'تجرق میانه',
        13572: 'هندلان',
        13573: 'طارون',
        13574: 'سنقرآباد',
        13575: 'فندقلو',
        13576: 'چشمه کش',
        13577: 'خواجه ده/کلاله',
        13578: 'کندوان',
        13579: 'دلی قیز',
        13580: 'زرنکش',
        13581: 'حاج یوسفلوی علیا',
        13582: 'کاغذکنان',
        13583: 'احمدآباد/گروس',
        13584: 'باغجغازعلیا',
        13585: 'استانجین',
        13586: 'بارانقار',
        13587: 'قوشه بلاغ',
        13588: 'خیرآباد',
        13589: 'قره بلاغ میانه',
        13590: 'لله لو',
        13591: 'بهمن آباد',
        13592: 'رشیدآباد',
        13593: 'سهل آباد',
        13594: 'هشترود',
        13595: 'حسن کندی رود',
        13596: 'آغبلاغ مهمان',
        13597: 'باشماق هشترود',
        13598: 'ذولبین',
        13599: 'وظیفه خوران',
        13600: 'لامشان',
        13601: 'علی آبادمیانه',
        13602: 'سلوک',
        13603: 'مغامیر',
        13604: 'نصیرآبادسفلی',
        13605: 'مکتو',
        13606: 'کله گرد',
        13607: 'داشبلاغ هشترود',
        13608: 'اوشندل',
        13609: 'دیزج رضاقلی بیگ/دیزج علیقلی بیگ',
        13610: 'بیک کندی',
        13611: 'ارقنه',
        13612: 'سعادتلو',
        13613: 'کماجرود',
        13614: 'عرقطو',
        13615: 'بزوجیق',
        13616: 'اکوزگنبدی',
        13617: 'بایقراکوه',
        13618: 'سیدبیگ',
        13619: 'صوفیلار',
        13620: 'خراسانک',
        13621: 'قویون قشلاقی',
        13622: 'حاجی کندی',
        13623: 'ویران قیه',
        13624: 'قره آغاج میانه',
        13625: 'آغ زیارت',
        13626: 'شهنوازوسطی',
        13627: 'ورقه علیا',
        13628: 'شورقره کندی',
        13629: 'ایمشجه',
        13630: 'خواجه شاهی',
        13631: 'قره گنای',
        13632: 'آغبلاغ گورانلو',
        13633: 'آغچه ریش',
        13634: 'اورتاسو',
        13635: 'دوه یاتاقی',
        13636: 'عمواوغلی',
        13637: 'بارگاه',
        13638: 'تخت سفلی',
        13639: 'ذاکرکندی',
        13640: 'بابونه سفلی',
        13641: 'گویجه قلعه',
        13642: 'نظرکهریزی',
        13643: 'یانیق',
        13644: 'آسایش',
        13645: 'ولی کندی',
        13646: 'کهل بلاغی',
        13647: 'یهرچی',
        13648: 'پاشابیگ',
        13649: 'آلاقیه',
        13650: 'قره کلک',
        13651: 'آتش بیگ',
        13652: 'بسیط',
        13653: 'توپ آغاج',
        13654: 'سراسکندسفلی',
        13655: 'قرخ سقر',
        13656: 'اهر',
        13657: 'ناظم آباد',
        13658: 'کوربلاغ',
        13659: 'کقالق',
        13660: 'خونیق',
        13661: 'قشلاق شاه وردی',
        13662: 'زندآباد',
        13663: 'اذغان',
        13664: 'ورگهان',
        13665: 'دشدور',
        13666: 'یخفروزان',
        13667: 'اللو',
        13668: 'چول قشلاقی',
        13669: 'کسانق',
        13670: 'افیل',
        13671: 'ویجینی',
        13672: 'دایلار',
        13673: 'رشت آباد',
        13674: 'کردلراهر',
        13675: 'گنگل آباد',
        13676: 'دوپیق',
        13677: 'گونجیک',
        13678: 'نقدوز',
        13679: 'قلندر',
        13680: 'خرم آباد',
        13681: 'یاورکندی',
        13682: 'دامناب',
        13683: 'ریحان',
        13684: 'انجرد',
        13685: 'قلعه ملک',
        13686: 'گرده سنگ',
        13687: 'گرانکاه',
        13688: 'کلهراهر',
        13689: 'نقاره کوب',
        13690: 'شیربیت',
        13691: 'باباجان',
        13692: 'شیخ قشلاق',
        13693: 'باللی قشلاق',
        13694: 'زگیلیگ سفلی',
        13695: 'داشبلاغ مغار',
        13696: 'بهل',
        13697: 'هلان اهر',
        13698: 'هووای',
        13699: 'هوراند',
        13700: 'مجیدآباداهر',
        13701: 'آق براز',
        13702: 'قمیشلو',
        13703: 'اینجار',
        13704: 'نواسر',
        13705: 'حوری درق',
        13706: 'گورن',
        13707: 'ارنان',
        13708: 'چیناب',
        13709: 'خان کندی',
        13710: 'قتانلو',
        13711: 'قلعه کندی اهر',
        13712: 'خویسرق',
        13713: 'هلان صفرعلی',
        13714: 'نیق',
        13715: 'ینگجه اهر',
        13716: 'کاسین',
        13717: 'علویق',
        13718: 'ورزقان اهر',
        13719: 'صومعه دل',
        13720: 'ارزیل',
        13721: 'مسقران',
        13722: 'آغبلاغ سفلی',
        13723: 'جاجان',
        13724: 'روزی',
        13725: 'دیزج ملک',
        13726: 'مهترلو',
        13727: 'اندرگان/ارسباران',
        13728: 'میوه رود',
        13729: 'دوریق',
        13730: 'ایری علیا',
        13731: 'نچق',
        13732: 'داشکسن اهر',
        13733: 'استمال',
        13734: 'طرزم',
        13735: 'اولیق',
        13736: 'لمبران',
        13737: 'آقابابافرامرزی',
        13738: 'سیه کلان',
        13739: 'شرف آباد',
        13740: 'تخمدل',
        13741: 'جوشین',
        13742: 'گال',
        13743: 'زغن آباد',
        13744: 'مزرعه شادی',
        13745: 'نهریق',
        13746: 'دستجرداهر',
        13747: 'سرخه دیزج',
        13748: 'خروانق',
        13749: 'اوان',
        13750: 'حاجی لار',
        13751: 'صیفار',
        13752: 'علی آبادورزقان',
        13753: 'علیار',
        13754: 'گوراند',
        13755: 'لیلی خانی',
        13756: 'مشک عنبر',
        13757: 'چلناب',
        13758: 'کلیبر',
        13759: 'آبش احمد',
        13760: 'گوزالان',
        13761: 'بشاب',
        13762: 'نجف تراکمه',
        13763: 'پیغام',
        13764: 'مولان',
        13765: 'یوزبند',
        13766: 'قیه باشی',
        13767: 'حدادان/آتی کندی',
        13768: 'قلعه کندی کلیبر',
        13769: 'نوجه ده بهشتی',
        13770: 'دیل بیلمز',
        13771: 'سردارآباد',
        13772: 'چای کندی اهر',
        13773: 'گوار',
        13774: 'عربشاه خان',
        13775: 'اسکلو',
        13776: 'خالان',
        13777: 'هجران دوست',
        13778: 'نوجه ده رجائی',
        13779: 'شاملوکلیبر',
        13780: 'قشلاق ازبک',
        13781: 'متعلق',
        13782: 'سیرک',
        13783: 'ایل یوردی',
        13784: 'آس قدیم',
        13785: 'شیخلان سفلی',
        13786: 'عبدالرزاق',
        13787: 'قشلاق قره باغلو',
        13788: 'کلالق',
        13789: 'اولی قشلاق',
        13790: 'شاه ولی',
        13791: 'اوزی',
        13792: 'مرزرود',
        13793: 'دمیرچی حدادان',
        13794: 'قشلاق قره درق',
        13795: 'کاغلوگوزلو',
        13796: 'قره قیه',
        13797: 'گلی قوزی',
        13798: 'انباستیق',
        13799: 'جانانلو',
        13800: 'خمارلو',
        13801: 'لاریجان',
        13802: 'گون گورمز',
        13803: 'شرفه',
        13804: 'بسطاملو',
        13805: 'عاشقلو',
        13806: 'مردانقم',
        13807: 'احمدآباد/کلیبر',
        13808: 'اسکانلوی علیا',
        13809: 'تاتارعلیا',
        13810: 'دریلو',
        13811: 'شجایلو',
        13812: 'طوعلی علیا',
        13813: 'ابراهیم سمیع',
        13814: 'کدخدالوی بالا',
        13815: 'محمودآباد',
        13816: 'حیدرکانلو',
        13817: 'صفرلو',
        13818: 'زنبلان',
        13819: 'علیوردی اوشاقی',
        13820: 'تازه کندوینق',
        13821: 'عمارت',
        13822: 'دایان',
        13823: 'قزل یول',
        13824: 'ستن',
        13825: 'شجاع خانلو',
        13826: 'عباس آباد',
        13827: 'کلاله علیا',
        13828: 'وایقان اهر',
        13829: 'کنزه رود',
        13830: 'مرزآباد',
        13831: 'اجاق کندی',
        13832: 'کلاله اسلامی',
        13833: 'خلف بیگلو',
        13834: 'ایری بوجاق',
        13835: 'سراب',
        13836: 'اسبفروشان',
        13837: 'داراب',
        13838: 'دانباران',
        13839: 'روستای/هریس سراب',
        13840: 'اسفستان',
        13841: 'کلیان',
        13842: 'بهرمان',
        13843: 'فرگوش',
        13844: 'ابرغان سراب',
        13845: 'اردها',
        13846: 'آغمیون',
        13847: 'بیجند',
        13848: 'سردها',
        13849: 'اوغان',
        13850: 'دامنجان',
        13851: 'اندراب',
        13852: 'سهزاب',
        13853: 'چه گوش',
        13854: 'اسلام آباد',
        13855: 'کادیجان',
        13856: 'شیره جین',
        13857: 'اسبقران',
        13858: 'چوللو',
        13859: 'قزل گچی',
        13860: 'تکلدان',
        13861: 'چرلو',
        13862: 'سنزیق',
        13863: 'شالغون',
        13864: 'جلده باخان',
        13865: 'جهیزدان',
        13866: 'سوین',
        13867: 'قوشچی',
        13868: 'گواشین',
        13869: 'کلانترسفلی',
        13870: 'هولیق',
        13871: 'امام چائی',
        13872: 'ایده لو',
        13873: 'تازه کندسراب',
        13874: 'دولت آباد/سراب',
        13875: 'ینگجه سراب',
        13876: 'وانق سفلی',
        13877: 'احمدآباد/سفلی',
        13878: 'ملایعقوب',
        13879: 'هروان',
        13880: 'رازلیق',
        13881: 'تیکمه داش',
        13882: 'شیروانه ده',
        13883: 'قزلجه',
        13884: 'ینگجه عباسی',
        13885: 'قران قیه',
        13886: 'قره چمن',
        13887: 'قره بابا',
        13888: 'عین الدین',
        13890: 'چرم خوران',
        13891: 'گل قاسم',
    },
    14: {
        16887: 'یاسوج',
        16888: 'سروک',
        16889: 'وزگ',
        16890: 'سپیدار',
        16891: 'ده برآفتاب',
        16892: 'فیروزآباد',
        16893: 'تنگ سرخ',
        16894: 'پاسداران/کاکان',
        16895: 'حسین آباد/دشتروم',
        16896: 'مختار',
        16897: 'مزدک',
        16898: 'کالوس',
        16899: 'مله باریک',
        16900: 'گنجه ای بزرگ',
        16901: 'نره گاه',
        16902: 'سراب تاوه',
        16903: 'چنارستان',
        16904: 'دوگنبدان گچساران',
        16905: 'پادوک',
        16906: 'باباکلان',
        16907: 'خیرآباد/جلیل',
        16908: 'سرآبننیز',
        16909: 'تلخاب شیرین',
        16910: 'خیرآباد/ناصر',
        16911: 'آرو',
        16912: 'پشه کان',
        16913: 'ماهورباشت',
        16914: 'کمبل',
        16915: 'دژسلیمان',
        16916: 'نازمکان',
        16917: 'سعادت آباد',
        16918: 'آبجیرک',
        16919: 'بی بی حکیمه',
        16920: 'انجیرسیاه',
        16921: 'دیل',
        16922: 'آبشیرین',
        16923: 'لیشتر/مظفرآباد',
        16924: 'امامزاده/جعفر',
        16925: 'سربیشه گچساران',
        16926: 'چناربرم',
        16927: 'مادوان/مهریان',
        16928: 'کوخدان',
        16929: 'تنگاری',
        16930: 'سی سخت',
        16931: 'کریک',
        16932: 'توت نده',
        16933: 'پاتاوه',
        16934: 'چیتاب',
        16935: 'میمند',
        16936: 'ده شیخ',
        16937: 'دارشاهی',
        16938: 'تمنک',
        16939: 'دروهان',
        16940: 'بن زرد',
        16941: 'بهرام بیگی',
        16942: 'سیمرون/گورگنجو',
        16943: 'باگ',
        16944: 'بنستان',
        16945: 'موگر',
        16946: 'درب کلات',
        16947: 'راه مالی',
        16948: 'هادی آباد',
        16949: 'مارگون',
        16950: 'جوکار',
        16951: 'چین',
        16952: 'موشمی',
        16953: 'پوله',
        16954: 'مارین',
        16955: 'بهره عنا',
        16956: 'باشت',
        16957: 'بوستان',
        16958: 'خان احمد',
        16959: 'سرآبیز',
        16960: 'آبدهگاه',
        16961: 'چاه تلخ',
        16962: 'بیدک',
        16963: 'تلچگاه',
        16964: 'گروس',
        16965: 'چم بلبل',
        16966: 'دهدشت',
        16967: 'سوق',
        16968: 'راک',
        16969: 'جنگلوا',
        16970: 'دم مهد',
        16971: 'قلعه دختر',
        16972: 'طولیان',
        16973: 'ضرغام آباد',
        16974: 'سواری',
        16975: 'چیر',
        16976: 'سرپری/چهارمه',
        16977: 'خلیفه ای',
        16978: 'دشت بن',
        16979: 'فیلگاه',
        16980: 'قلعه گل',
        16981: 'قیام',
        16982: 'گچی',
        16983: 'کوشک ابول',
        16984: 'دره کلالی',
        16985: 'بی منجگان',
        16986: 'چرام',
        16987: 'سرفاریاب',
        16988: 'کلایه سفلی',
        16989: 'بردیان',
        16990: 'مندان',
        16991: 'بناری',
        16992: 'القچین',
        16993: 'فشیان',
        16994: 'لیرتلخک',
        16995: 'سرآسیاب یوسفی',
        16996: 'لنده',
        16997: 'ایدنک',
        16998: 'قلعه رئیسی',
        16999: 'دیشموک',
        17000: 'سربیشه دهدشت',
        17001: 'جاورده',
        17002: 'الکن',
        17003: 'سادات مشهدی',
        17004: 'امامزاده/محمود',
        17005: 'لیکک کت بهمئی',
        17006: 'مامازینب',
        17007: 'شهرک/ولیعصر',
        17008: 'قلعه ممبی',
        17009: 'آبله',
        17010: 'چاه گرگی',
        17011: 'گراب',
    },
    15: {
        11021: 'گرگان',
        11022: 'کفشگیری',
        11023: 'سدن/سیدمیران',
        11024: 'قلعه محمود',
        11025: 'لمسک/ورسن',
        11026: 'هاشم آباد',
        11027: 'نومل',
        11028: 'حیدرآباد/گرگان',
        11029: 'زیارت',
        11030: 'آهنگرمحله',
        11031: 'سعدآباد',
        11032: 'شموشک سفلی',
        11033: 'نوچمن',
        11034: 'تخشی محله',
        11035: 'کلاجان قاجار',
        11036: 'نودیجه',
        11037: 'شاهکوه سفلی',
        11038: 'چهارباغ',
        11039: 'توسکستان',
        11040: 'اصفهان کلاته',
        11041: 'قرن آباد',
        11042: 'شاهکوه علیا',
        11043: 'گنبدکاووس',
        11044: 'عرب سرنگ',
        11045: 'آبادان تپه',
        11046: 'قوچ مراد',
        11047: 'ایمرملاساری',
        11048: 'باغلی مرامه',
        11049: 'سلاق نوری',
        11050: 'قول حاجی',
        11051: 'حالی آخوند',
        11052: 'بی بی شیروان',
        11053: 'ایگدرعلیا',
        11054: 'فجر/قوینلی',
        11055: 'ملک علی تپه',
        11056: 'یاسی تپه',
        11057: 'سارجه کر',
        11058: 'ملاعلی تپه',
        11059: 'ایگدرسفلی',
        11060: 'اوبه محمدایمر',
        11061: 'اگری بوغاز',
        11062: 'بایلر',
        11063: 'آقچلی سفلی',
        11064: 'کاکا',
        11065: 'کوچک خرطوم',
        11066: 'آق آباد',
        11067: 'سلاق غایب',
        11068: 'سلطانعلی',
        11069: 'سارلی علیا',
        11070: 'سارلی سفلی',
        11071: 'دیگچه/سرگچن',
        11072: 'حاجی قوشان',
        11073: 'کسکن قوجق',
        11074: 'نوده ملک',
        11075: 'زنگیان',
        11076: 'قلی آباد',
        11077: 'فوجرد',
        11078: 'کریم آباد',
        11079: 'محمدآباد',
        11080: 'نصرآباد',
        11081: 'معصوم آباد',
        11082: 'گوزن فارس',
        11083: 'میرمحله/شمس آباد',
        11084: 'علی آبادکنارشهر',
        11085: 'قرق',
        11086: 'کماسی',
        11087: 'سرخن کلاته',
        11088: 'تورنگ تپه',
        11089: 'سلطان آباد',
        11090: 'تقی آباد',
        11091: 'جلین علیا',
        11092: 'آلوکلاته',
        11093: 'امیرآباد/گز',
        11094: 'مرزن کلاته',
        11095: 'کردکوی',
        11096: 'بالاجاده',
        11097: 'مهترکلاته',
        11098: 'چهارده',
        11099: 'یساقی',
        11100: 'سرکلاته',
        11101: 'دنگلان',
        11102: 'کارکنده/سوته',
        11103: 'ایلوار',
        11104: 'میاندره',
        11105: 'سالیکنده',
        11106: 'گرجی محله/سفیدآباد',
        11107: 'رادکان',
        11108: 'بندر/گز',
        11109: 'لیوان',
        11110: 'نوکنده',
        11111: 'سرطاق',
        11112: 'شهرک صنعتی/بندر/گز',
        11113: 'بندر/ترکمن',
        11114: 'پنج پیکر',
        11115: 'سیجوال',
        11116: 'قره تپه',
        11117: 'قره قاشلی',
        11118: 'قره سو',
        11119: 'گمیشان',
        11120: 'قرنجیک نظر',
        11121: 'قارقی بناور',
        11122: 'چپق لقی',
        11123: 'آرخ بزرگ',
        11124: 'خواجه نفس',
        11125: 'چارقلی',
        11126: 'آلتین تخماق',
        11127: 'قلعه جیق',
        11128: 'سقرتپه',
        11129: 'خواجه لر',
        11130: 'اسلام تپه',
        11131: 'بصیرآباد',
        11132: 'آق قلا',
        11133: 'صحنه سفلی',
        11134: 'گری دوجی',
        11135: 'یامپی',
        11136: 'قربان آباد',
        11137: 'میرزاعلی یلقی',
        11138: 'بهلکه داشلی',
        11139: 'عطاآباد',
        11140: 'انقلاب',
        11141: 'قانقرمه',
        11142: 'دوگنجی',
        11143: 'قرنجیک پورامان',
        11144: 'شورحیات',
        11145: 'اوچ تپه',
        11146: 'قوشجان آباد',
        11147: 'یلمه سالیان',
        11148: 'وحدت',
        11149: 'اونق یلقی',
        11150: 'شفت آلوباغ',
        11151: 'بهلکه شیخ موسی',
        11152: 'آق زبیر',
        11153: 'قزلی',
        11154: 'جهان آباد',
        11155: 'پیراوش سفلی',
        11156: 'انبارآلوم',
        11157: 'چین سبیلی',
        11158: 'شهرک صنعتی/آق قلا',
        11159: 'امین آباد',
        11160: 'علی آباد/کتول',
        11161: 'علی آباد',
        11162: 'قره بلاغ',
        11163: 'سنگ دوین',
        11164: 'فاضل آبادگرگان',
        11165: 'برفتان',
        11166: 'حاجی آباد',
        11167: 'حاجی کلاته',
        11168: 'بدراق نوری',
        11169: 'حکیم آباد',
        11170: 'کوچک نظرخانی',
        11171: 'اودک دوجی/حسن طبیب',
        11172: 'شیرنگ',
        11173: 'آزادتپه',
        11174: 'باقرآباد',
        11175: 'مزرعه کتول',
        11176: 'کرند',
        11177: 'اینچه برون',
        11178: 'داشلی برون',
        11179: 'دوزالوم',
        11180: 'گمرک پل/تنگلی',
        11181: 'قره ماخر',
        11182: 'آقبند',
        11183: 'هوتن',
        11184: 'نارلی داغ',
        11185: 'ایتمر',
        11186: 'کلاله',
        11187: 'تمرقره قوزی',
        11188: 'دهنه',
        11189: 'قره شور',
        11190: 'کنگور',
        11191: 'تراجیق',
        11192: 'پیش کمر',
        11193: 'قوشه سو',
        11194: 'عزیزآباد',
        11195: 'قدونه',
        11196: 'حاجی بیک علیا',
        11197: 'صوفیان',
        11198: 'قپان',
        11199: 'حیدرآباد/گنبدکاووس',
        11200: 'صوفی شیخ دازغراوی',
        11201: 'اجن شیرملی',
        11202: 'یل چشمه',
        11203: 'عرب بوران',
        11204: 'مراوه تپه',
        11205: 'قرناوه',
        11206: 'گلیداغ',
        11207: 'عرب قاری حاجی',
        11208: 'آق امام',
        11209: 'چناران',
        11210: 'سوزش',
        11211: 'چنارلی',
        11212: 'مینودشت',
        11213: 'قلعه قافه',
        11214: 'قلمی',
        11215: 'قره چشمه',
        11216: 'دوزین',
        11217: 'محمدزمان خان',
        11218: 'تخت',
        11219: 'زندانچال',
        11220: 'ده چناشک',
        11221: 'صفی آباد',
        11222: 'تاش ده',
        11223: 'کلاسره',
        11224: 'گالیکش',
        11225: 'ینقاق',
        11226: 'تنگراه',
        11227: 'پاسنگ بالا',
        11228: 'فارسیان فرنگ',
        11229: 'آب پران',
        11230: 'آق قمیش',
        11231: 'صادق آباد',
        11232: 'رامیان',
        11233: 'خانببین',
        11234: 'دارکلاته',
        11235: 'دلند',
        11236: 'توران فارس',
        11237: 'تاتارعلیا',
        11238: 'رضاآباد',
        11239: 'زینب آباد',
        11240: 'ارازگل',
        11241: 'توران ترک',
        11242: 'تاتارسفلی',
        11243: 'آزادشهر1',
        11244: 'نظام آباد',
        11245: 'آزادشهر2',
        11246: 'قورچای',
        11247: 'قزلجه آق امام',
        11248: 'تیل آباد',
        11249: 'خوش ییلاق',
        11250: 'نوده خاندوز',
        11251: 'فاضل آبادگنبدکاووس',
        11252: 'سیدآباد',
        11253: 'مرزبان',
        11254: 'سوسرا',
        11255: 'وامنان',
        11256: 'کاشیدار',
        11257: 'فارسیان/قانچی',
        11258: 'وطن',
        11259: 'شیرآباد',
        11260: 'نراب',
        11261: 'گلها/حاجی نبی',
        11262: 'رودبارقشلاق'
    },
    17: {
        18308: 'سنندج',
        18309: 'نایسر',
        18310: 'قلیان',
        18311: 'باینجوب',
        18312: 'سراب قامیش',
        18313: 'حسن آباد',
        18314: 'صلوات آباد',
        18315: 'سرخه دزج',
        18316: 'نوره',
        18317: 'قلیچیان',
        18318: 'صوفیان',
        18319: 'باباریز',
        18320: 'حسین آباد/سنندج',
        18321: 'آرندان',
        18322: 'قار',
        18323: 'تخته',
        18324: 'دوشان',
        18325: 'کیلانه',
        18326: 'هشمیز',
        18327: 'کره سی',
        18328: 'نران',
        18329: 'سرنجیانه سفلی',
        18330: 'توریور',
        18331: 'کرجو',
        18332: 'گلین',
        18333: 'دادانه',
        18334: 'شیان',
        18335: 'تودارملا',
        18336: 'نشورسفلی',
        18337: 'هندیمن',
        18338: 'فارس آباد',
        18339: 'قورق',
        18340: 'یمینان سفلی',
        18341: 'نزار',
        18342: 'شویشه',
        18343: 'آویهنگ',
        18344: 'نگل',
        18345: 'میانه',
        18346: 'عیسی آباد',
        18347: 'هویه',
        18348: 'سرهویه',
        18349: 'تودارروته',
        18350: 'برقرو',
        18351: 'کلاته',
        18352: 'زونج',
        18353: 'دانیکش',
        18354: 'کامیاران',
        18355: 'موچش',
        18356: 'طای',
        18357: 'الک',
        18358: 'تنگی سر',
        18359: 'خامسان',
        18360: 'شاهینی',
        18361: 'سرچی',
        18362: 'لون سادات',
        18363: 'کوله ساره',
        18364: 'نیر',
        18365: 'دولاب',
        18366: 'دیواندره',
        18367: 'زرینه',
        18368: 'پاپاله',
        18369: 'قلعه جغه',
        18370: 'نساره علیا',
        18371: 'ابراهیم آباد',
        18372: 'وزمان',
        18373: 'کلکان',
        18374: 'باقرآباد',
        18375: 'رشیدآباد',
        18376: 'قلعه روتله',
        18377: 'قره دره',
        18378: 'دربند',
        18379: 'شریف آباد',
        18380: 'زرینه ورمزیار',
        18381: 'یاپل',
        18382: 'قراگل',
        18383: 'بیجار',
        18384: 'خاندان قلی',
        18385: 'توپ آغاج',
        18386: 'سیدان',
        18387: 'بیان لو',
        18388: 'جعفرآباد',
        18389: 'خورخوره',
        18390: 'نجف آباد',
        18391: 'قشلاق نوروز',
        18392: 'بابارشانی',
        18393: 'پیرتاج',
        18394: 'چشمه منتش',
        18395: 'هفت اصحاب',
        18396: 'حسن تیمور',
        18397: 'خسروآباد',
        18398: 'حسن آباد/یاسوکند',
        18399: 'قروه',
        18400: 'وینسار',
        18401: 'دزج',
        18402: 'قزلجه کند',
        18403: 'مالوجه',
        18404: 'میهم سفلی',
        18405: 'قلعه قروه',
        18406: 'گنداب علیا',
        18407: 'میهم علیا',
        18408: 'سریش آباد',
        18409: 'ویهج',
        18410: 'دلبران',
        18411: 'قصلان',
        18412: 'بهارلو',
        18413: 'نارنجک',
        18414: 'دیوزند',
        18415: 'شکوه آباد',
        18416: 'سنگین آباد',
        18417: 'گنجی',
        18418: 'کنگره',
        18419: 'یالقوزآغاج',
        18420: 'قاملو',
        18421: 'آونگان',
        18422: 'دهگلان',
        18423: 'میره کی',
        18424: 'کروندان',
        18425: 'بلدستی',
        18426: 'قوری چای',
        18427: 'باشماق سنندج',
        18428: 'سیس',
        18429: 'گردمیران علیا',
        18430: 'گردمیران سفلی',
        18431: 'بلبان آباد',
        18432: 'سرنجیانه قروه',
        18433: 'سراب حاجی پمق',
        18434: 'شیروانه',
        18435: 'پالنگان',
        18436: 'دژن',
        18437: 'پشاباد',
        18438: 'ماراب',
        18439: 'سرریز',
        18440: 'سقز',
        18441: 'شهرصنعتی/سقز',
        18442: 'قیلسون',
        18443: 'ترجان',
        18444: 'تموغه',
        18445: 'کهریزه',
        18446: 'سرچشمه',
        18447: 'میدان غله',
        18448: 'مرخز',
        18449: 'آیچی',
        18450: 'کسنزان',
        18451: 'قباقلو',
        18452: 'قهرآبادسفلی',
        18453: 'هیجانان',
        18454: 'سوته',
        18455: 'بسطام',
        18456: 'گردیگلان',
        18457: 'سرا',
        18458: 'میرده',
        18459: 'کوچک',
        18460: 'قلندرگاه',
        18461: 'صالح آباد',
        18462: 'کردستان',
        18463: 'صاحب سقز',
        18464: 'گل تپه سقز',
        18465: 'ماهیدرسفلی',
        18466: 'ایرانخواه سقز',
        18467: 'قهرآبادسلیمان',
        18468: 'باشماق سقز',
        18469: 'تومارقامیش',
        18470: 'قپلانتو',
        18471: 'مولان آباد',
        18472: 'گردنه/محمودآباد',
        18473: 'غارکرفتو',
        18474: 'سنته سقز',
        18475: 'یورقل',
        18476: 'گردنه/ایرانخواه',
        18477: 'مریوان',
        18478: 'محمده',
        18479: 'کانی دینار',
        18480: 'لنج آباد',
        18481: 'نی',
        18482: 'وله ژیر',
        18483: 'سردوش',
        18484: 'چوروننه',
        18485: 'برده رشه مریوان',
        18486: 'ساوجی',
        18487: 'گلیه',
        18488: 'بازارچه مرزی',
        18489: 'اسلامدشت سقز',
        18490: 'حسین آباد/سقز',
        18491: 'دری',
        18492: 'درگاه شیخان',
        18493: 'شارانی',
        18494: 'هزارخانی',
        18495: 'درکی',
        18496: 'آلمانه',
        18497: 'نژمار',
        18498: 'انجمه',
        18499: 'کماله',
        18500: 'سنگ سفید',
        18501: 'سروآباد',
        18502: 'ژنین',
        18503: 'قلعه جی',
        18504: 'دل',
        18505: 'پایگلان',
        18506: 'دزلی',
        18507: 'اورامان',
        18508: 'ژان',
        18509: 'گوشخانی',
        18510: 'بیساران',
        18511: 'چشمیدر',
        18512: 'بوریدر',
        18513: 'ژیوار',
        18514: 'دگاگا',
        18515: 'بلبر',
        18516: 'بانه',
        18517: 'ساوان',
        18518: 'شوی',
        18519: 'سبدلو',
        18520: 'آرمرده',
        18521: 'کلده سوره',
        18522: 'سرداب',
        18523: 'کانی سور',
        18524: 'بوالحسن',
        18525: 'آلوت',
        18526: 'نجنه',
        18527: 'برده رشه بانه',
        18528: 'بوئین سفلی',
        18529: 'خوری آباد',
        18530: 'ننور',
        18531: 'ناو',
        18532: 'گواز',
        18533: 'نسنار'
    },
    18: {
        17785: 'کرمانشاه',
        17786: 'شهرک/شهید/عسگری',
        17787: 'سراب نیلوفر',
        17788: 'قزانچی',
        17789: 'مرزبانی',
        17790: 'شهرک صنعتی/فرامان',
        17791: 'فرامان',
        17792: 'سیاه کمر',
        17793: 'قلعه شاهخانی',
        17794: 'چشمه سفید',
        17795: 'رحیم آباد',
        17796: 'سیاه بیدعلیا',
        17797: 'شاهینی',
        17798: 'تپه شعبان',
        17799: 'کرناچی',
        17800: 'ده پهن',
        17801: 'قمشه',
        17802: 'جامه شوران',
        17803: 'گره بان',
        17804: 'هرسین',
        17805: 'چهر',
        17806: 'پریوه',
        17807: 'سرماج',
        17808: 'تمرگ هرسین',
        17809: 'بابازید',
        17810: 'بیستون',
        17811: 'بلوردی',
        17812: 'برناج',
        17813: 'شادآباد',
        17814: 'هلشی',
        17815: 'سرونو',
        17816: 'ماهیدشت',
        17817: 'اسلام آباد/غرب',
        17818: 'شهرک صنعتی/اسلام آباد',
        17819: 'علی آباد',
        17820: 'حسن آباد',
        17821: 'کوزران',
        17822: 'مومئی',
        17823: 'کله جوب',
        17824: 'چقاکبود',
        17825: 'گردنگاه قوچمی',
        17826: 'چنگور',
        17827: 'ونائی',
        17828: 'حمیل',
        17829: 'کندهر',
        17830: 'قلعه شیان',
        17831: 'قلعه هرسم',
        17832: 'باریکه نظام',
        17833: 'توه سرخک',
        17834: 'میله سر',
        17835: 'خپگه',
        17836: 'جوانرود',
        17837: 'شروینه',
        17838: 'زلان',
        17839: 'روانسر',
        17840: 'حسن آباد/روانسر',
        17841: 'شهرک صنعتی/روانسر',
        17842: 'زالوآب',
        17843: 'نهرابی',
        17844: 'تازه آباد/ثلاث باباجانی',
        17845: 'میرآباد',
        17846: 'ازگله',
        17847: 'پاوه',
        17848: 'چورزی',
        17849: 'قشلاق/منصورآقائی',
        17850: 'شمشیر',
        17851: 'دشه',
        17852: 'سریاس',
        17853: 'قوری قلعه',
        17854: 'حجیج',
        17855: 'داریان',
        17856: 'کلال',
        17857: 'زردوئی',
        17858: 'نوسود',
        17859: 'نودشه',
        17860: 'نروی',
        17861: 'دزآور',
        17862: 'باینگان',
        17863: 'بانه وره',
        17864: 'ساتیاری',
        17865: 'سرپل ذهاب',
        17866: 'قره بلاغ اعظم',
        17867: 'سرابله',
        17868: 'حبیب وند',
        17869: 'مجتمع/کوئیک',
        17870: 'آئینه',
        17871: 'گاوچالی',
        17872: 'سرباغ گلین',
        17873: 'زرده',
        17874: 'گیلانغرب',
        17875: 'گورسفید',
        17876: 'کل کش',
        17877: 'کلاه دراز',
        17878: 'جوباغان',
        17879: 'نساردیره',
        17880: 'سراب قلعه شاهین',
        17881: 'سوخورشهبازی',
        17882: 'قمرالی',
        17883: 'محمدی سفلی',
        17884: 'کرکول کسان',
        17885: 'کرندغرب',
        17886: 'ریجاب/بانمزاران',
        17887: 'حریر',
        17888: 'قصرشیرین',
        17889: 'خسروی',
        17890: 'سیدخلیل',
        17891: 'کلانتر',
        17892: 'بازارچه مرزی پرویزخان',
        17893: 'سومار',
        17894: 'گواور',
        17895: 'گهواره',
        17896: 'کنگاور/حسن آباد',
        17897: 'کارخانه',
        17898: 'آران',
        17899: 'رحمت آباد',
        17900: 'کرماجان',
        17901: 'دهلر',
        17902: 'سلطان آباد',
        17903: 'شورچه',
        17904: 'قارلق',
        17905: 'طاهرآبادکنگاور',
        17906: 'فشخوران',
        17907: 'شهرک صنعتی/کنگاور',
        17908: 'فش',
        17909: 'گودین',
        17910: 'صحنه',
        17911: 'بیدسرخ',
        17912: 'درکه عین القاس',
        17913: 'آب باریک',
        17914: 'گاوکل',
        17915: 'علی گرزان علیا',
        17916: 'سردارآباد',
        17917: 'سیاه چقا',
        17918: 'سنقر',
        17919: 'سطرسنقر',
        17920: 'سهنله',
        17921: 'خسروآباد',
        17922: 'باوله/شهیدباهنر',
        17923: 'فارسینج',
        17924: 'حبشی',
        17925: 'شورآباد',
        17926: 'لیلمانج',
        17927: 'گزنهله',
        17928: 'کلگاه زمان',
        17929: 'چرمله سفلی',
        17930: 'بشیرآباد',
        17931: 'گردکانه',
        17932: 'مارانگاز',
        17933: 'هفت آشیان',
        17934: 'سلطان طاهر',
        17935: 'میانراهان',
        17936: 'ارمنی جان',
        17937: 'کندوله',
        17938: 'چمه',
        17939: 'طاهرآبادصحنه',
        17940: 'جیحون آباد'
    },
    19: {
        11820: 'ساوه',
        11821: 'شهر/صنعتی/کاوه/ساوه',
        11822: 'نورعلی بیک',
        11823: 'آوه',
        11824: 'احمدآباد',
        11825: 'طرازناهید',
        11826: 'آلوسجرد',
        11827: 'قره چای/قلعه کرد',
        11828: 'اندیس',
        11829: 'سقانلیق',
        11830: 'یل آباد',
        11831: 'غرق آباد',
        11832: 'نوبران',
        11833: 'بالقلو',
        11834: 'یاتان',
        11835: 'سامان',
        11836: 'رازقان',
        11837: 'مصرقان',
        11838: 'الویر',
        11839: 'دوزج',
        11840: 'علیشار',
        11841: 'مامونیه/زرند',
        11842: 'زاویه',
        11843: 'پرندک',
        11844: 'صدرآباد',
        11845: 'حکیم آباد',
        11846: 'حسین آباد',
        11847: 'خشکرود',
        11848: 'قاسم آباد/ساوه',
        18152: 'اراک',
        18153: 'کرهرود',
        18154: 'مرکزی',
        18155: 'دفاترمخابراتی',
        18156: 'مرزیجیران',
        18157: 'رباط میل',
        18158: 'شهسواران',
        18159: 'عقیل آباد',
        18160: 'ملک آباد',
        18161: 'امان آباد',
        18162: 'گوار',
        18163: 'داوودآباد',
        18164: 'ساروق',
        18165: 'ابراهیم آباد',
        18166: 'شهرصنعتی/ایبک آباد',
        18167: 'هزاوه',
        18168: 'میچان',
        18169: 'سنجان',
        18170: 'ایبک آباد',
        18171: 'ده نمک',
        18172: 'نمک کور',
        18173: 'چشمه پهن',
        18174: 'خرماباد',
        18175: 'قاسم آباداراک',
        18176: 'شهرک صنعتی/خیرآباد',
        18177: 'شهوه',
        18178: 'خیرآباد',
        18179: 'کارچان',
        18180: 'ضامن جان',
        18181: 'مشهدالکوبه',
        18182: 'جیریا',
        18183: 'شازند',
        18184: 'نهرمیان',
        18185: 'توره',
        18186: 'واشه',
        18187: 'لنجرود',
        18188: 'بازنه',
        18189: 'پاکل',
        18190: 'غینر',
        18191: 'حصار',
        18192: 'سورانه',
        18193: 'هندودر',
        18194: 'آستانه',
        18195: 'اکبرآباد',
        18196: 'سرسختی',
        18197: 'باغ برآفتاب',
        18198: 'هفته',
        18199: 'کزاز',
        18200: 'جلایر',
        18201: 'مالمیر',
        18202: 'عنبرته',
        18203: 'قره بنیاد',
        18204: 'سرسختی سفلی',
        18205: 'گل زردقلعه',
        18206: 'ظهیرآباد',
        18207: 'برای اسکان',
        18208: 'شهرک/مهاجران',
        18209: 'قدمگاه',
        18210: 'بصری',
        18211: 'ضیاآباد/نورآباد',
        18212: 'موچان',
        18213: 'سمقاور',
        18214: 'وفس',
        18215: 'چلبی',
        18216: 'چهرقان',
        18217: 'سلیم آباد',
        18218: 'اسفندان',
        18219: 'محمودآباد',
        18220: 'خسروبیک',
        18221: 'خمارباغی',
        18222: 'امامزاده/عباس',
        18223: 'کمیجان',
        18224: 'خنجین',
        18225: 'میلاجرد',
        18226: 'خنداب',
        18227: 'استوه',
        18228: 'اناج',
        18229: 'آناج',
        18230: 'کرکان',
        18231: 'مانیزان اراک',
        18232: 'آق داش',
        18233: 'مجتمع/قطران',
        18234: 'مست وایجان',
        18235: 'دهسد',
        18236: 'ده شیرخان',
        18237: 'گازران',
        18238: 'قاسم آباد',
        18239: 'فوران',
        18240: 'دیزآباد',
        18241: 'دهچال',
        18242: 'غینرجه',
        18243: 'سوزان',
        18244: 'تفرش',
        18245: 'شهراب',
        18246: 'نقوسان',
        18247: 'طراران',
        18248: 'بازرجان',
        18249: 'فراهان/فرمهین',
        18250: 'فشک',
        18251: 'تلخاب',
        18252: 'تبرته',
        18253: 'شیرین آباد',
        18254: 'دستجان',
        18255: 'مصلح آباد',
        18256: 'شتریه',
        18257: 'غیاث آباد',
        18258: 'امیرآباد',
        18259: 'کودزر',
        18260: 'مجدآبادکهنه',
        18261: 'عزیزآباد',
        18262: 'شهرصنعتی/فرمهین',
        18263: 'آشتیان',
        18264: 'مزرعه نو',
        18265: 'سیاوشان',
        18266: 'کردیجان',
        18267: 'گرکان',
        18268: 'خمین',
        18269: 'ورآباد',
        18270: 'لکان',
        18271: 'فرفهان',
        18272: 'میشیجان',
        18273: 'ازنوجان',
        18274: 'شهرک صنعتی/خمین',
        18275: 'جلماجرد',
        18276: 'چهارچشمه',
        18277: 'ریحان',
        18278: 'خوگان',
        18279: 'حشمتیه',
        18280: 'چقاسیف آباد',
        18281: 'ورچه',
        18282: 'رباط مراد',
        18283: 'ده نوصمصام',
        18284: 'قورچی باشی',
        18285: 'فرنق',
        18286: 'شهابیه',
        18287: 'محلات',
        18288: 'نیمه ور',
        18289: 'باقرآباد',
        18290: 'خورهه',
        18291: 'نخجیروان',
        18292: 'لریجان',
        18293: 'بزیجان',
        18294: 'دلیجان',
        18295: 'واران',
        18296: 'راوه',
        18297: 'قالهر',
        18298: 'مشهداردهال',
        18299: 'رباط ترک',
        18300: 'خاوه',
        18301: 'راونج',
        18302: 'وسفونقان',
        18303: 'شهرصنعتی/دلیجان',
        18304: 'هستیجان',
        18305: 'نراق',
        18306: 'دودهک',
        18307: 'شهرک صنعتی/راونج'
    },
    20: {
        15876: 'ده شاکر',
        17572: 'همدان',
        17573: 'شورین',
        17574: 'چشین',
        17575: 'ابرو',
        17576: 'رباط شورین',
        17577: 'ده پیاز',
        17578: 'گراچغا',
        17579: 'آبشینه',
        17580: 'کنجینه',
        17581: 'سنگستان',
        17582: 'تفریجان',
        17583: 'سرخ آباد',
        17584: 'سولان',
        17585: 'موئیجین',
        17586: 'پادگان/قهرمان',
        17587: 'انصارالامام',
        17588: 'یکن آباد',
        17589: 'ارزانفود',
        17590: 'گنبد',
        17591: 'جورقان',
        17592: 'شهرک/صنعتی/بوعلی',
        17593: 'امزاجرد',
        17594: 'فقیره',
        17595: 'الفاوت',
        17596: 'اسدآباد',
        17597: 'خاکریز',
        17598: 'گذرکجین',
        17599: 'حبشی',
        17600: 'طویلان سفلی',
        17601: 'چنارعلیا',
        17602: 'کمک سفلی',
        17603: 'چنارسفلی',
        17604: 'موسی آباد',
        17605: 'بادخوره',
        17606: 'جنت آباد',
        17607: 'وندرآباد',
        17608: 'نصرت آباد',
        17609: 'سیراوند',
        17610: 'یوسف آباد',
        17611: 'لکلک',
        17612: 'آجین',
        17613: 'حسام آباد/اسدآباد',
        17614: 'احمدآباد',
        17615: 'حسن آباد/امام',
        17616: 'هلور',
        17617: 'ایوراع',
        17618: 'پیرملو',
        17619: 'بهار',
        17620: 'گنج تپه',
        17621: 'پرلوک',
        17622: 'سیمین زاغه',
        17623: 'رسول آباد',
        17624: 'حسن قشلاق',
        17625: 'مهاجران',
        17626: 'حسام آباد/بهار',
        17627: 'آبرومند',
        17628: 'چوتاش',
        17629: 'صالح آباد',
        17630: 'همه کسی نهاوند',
        17631: 'حسین آباد/لتگاه',
        17632: 'راه هموار',
        17633: 'کوشک آباد',
        17634: 'حسین آباد/آشوری',
        17635: 'خلیل کرد',
        17636: 'پهنه بر',
        17637: 'باباعلی',
        17638: 'لالجین',
        17639: 'شهرک/بهار',
        17640: 'روان',
        17641: 'خوشاب علیا',
        17642: 'وهنان',
        17643: 'حیدره قاضی خانی',
        17644: 'گنبدان بهار',
        17645: 'گنده جین',
        17646: 'کریم آباد',
        17647: 'هارون آباد',
        17648: 'میهمله علیا',
        17649: 'لتگاه',
        17650: 'دینارآباد',
        17651: 'حصارقره باغی',
        17652: 'زاغه',
        17653: 'مالک اشتر',
        17654: 'کبودرآهنگ',
        17655: 'قزلجه حاجیلو',
        17656: 'طاهرلو',
        17657: 'کوهین',
        17658: 'داق داق آباد',
        17659: 'ویان',
        17660: 'کوریجان',
        17661: 'شیرین سو',
        17662: 'حاتم آباد',
        17663: 'مهدی آباد',
        17664: 'ایده لو',
        17665: 'اوریاد',
        17666: 'دستجرد',
        17667: 'طاسیران',
        17668: 'مسجدین',
        17669: 'بابان',
        17670: 'اورقین',
        17671: 'خان آباد',
        17672: 'قاباق تپه',
        17673: 'آب مشکین',
        17674: 'وصله',
        17675: 'سردارآباد',
        17676: 'علی صدر',
        17677: 'گزل ابدال',
        17678: 'امیرآباد/کبودرآهنگ',
        17679: 'پایگاه/نوژه',
        17680: 'کردآباد',
        17681: 'روعان',
        17682: 'اکنلو',
        17683: 'بشیک تپه',
        17684: 'قراگل',
        17685: 'کندتپه',
        17686: 'آق تپه',
        17687: 'اوزن دره',
        17688: 'رامیشان',
        17689: 'عبدالمومن',
        17690: 'باباخنجر',
        17691: 'چارلی',
        17692: 'حصارکوچه باغی',
        17693: 'گل تپه',
        17694: 'سوباشی',
        17695: 'قهوردسفلی',
        17696: 'قهوردعلیا',
        17697: 'سراب',
        17698: 'خبرارخی',
        17699: 'گمین قلعه',
        17700: 'آقبلاغ/آق داق',
        17701: 'شاوه',
        17702: 'نوآباد',
        17703: 'سرایجوق',
        17704: 'آقکند',
        17705: 'رزن',
        17706: 'شهرک صنعتی/رزن',
        17707: 'شاهنجرین',
        17708: 'کرفس',
        17709: 'گونلو',
        17710: 'سورتجین',
        17711: 'درجزین',
        17712: 'نظام آباد',
        17713: 'کاج',
        17714: 'سیراب',
        17715: 'نوار',
        17716: 'آب باریک',
        17717: 'جامیشلو',
        17718: 'هریان',
        17719: 'امتلر',
        17720: 'نیر',
        17721: 'پشتجین',
        17722: 'کهارد',
        17723: 'شوند',
        17724: 'خنجرآباد',
        17725: 'سایان',
        17726: 'سوزن',
        17727: 'فارسجین',
        17728: 'سنقرآباد',
        17729: 'قروه درجزین',
        17730: 'عین آباد',
        17731: 'ساریجلو',
        17732: 'جربانلو',
        17733: 'حکان',
        17734: 'بهکندان',
        17735: 'قراکند',
        17736: 'ماه نیان',
        17737: 'امیرآباد/رزن',
        17738: 'دمق',
        17739: 'بابانظر',
        17740: 'گاوسوار',
        17741: 'خورونده',
        17742: 'چورمق',
        17743: 'سلطان آباددمق',
        17744: 'قایش',
        17745: 'قینرجه',
        17746: 'قادرخلج',
        17747: 'تخت',
        17748: 'چایان',
        17749: 'آرپادره',
        17750: 'ملابلاق',
        17751: 'کهریزبغازی',
        17752: 'تپه دیبی',
        17753: 'اورته قمیش',
        17754: 'قره بلاغ',
        17755: 'فامنین',
        17756: 'اصله',
        17757: 'نگارخاتون',
        17758: 'حاجی آباد/فامنین',
        17759: 'تاوه سناج',
        17760: 'فیض آباد',
        17761: 'سراوک',
        17762: 'زرقان',
        17763: 'ستق',
        17764: 'امیرآباد/فامنین',
        17765: 'نصیرآباد',
        17766: 'قلعه جوق',
        17767: 'قزل آباد',
        17768: 'دهلق',
        17769: 'یسرلو',
        17770: 'کله سر',
        17771: 'قهاوند',
        17772: 'بیوک آباد',
        17773: 'قرخلر',
        17774: 'جیحون آباد',
        17775: 'میلاجرد',
        17776: 'همه کسی همدان',
        17777: 'هیزج',
        17778: 'خیرآباد',
        17779: 'عبدالرحیم',
        17780: 'راهجرد',
        17781: 'کوه زره',
        17782: 'دشته',
        17783: 'احمدآباد/شرا',
        17784: 'امامزاده/پیرنهان',
        18030: 'ملایر',
        18031: 'داویجان',
        18032: 'رضوان کده',
        18033: 'جوزان',
        18034: 'ازناوله',
        18035: 'توسک ملایر',
        18036: 'مهرآباد',
        18037: 'توچغاز',
        18038: 'کرکان',
        18039: 'شوشاب',
        18040: 'پیروز',
        18041: 'بیغش',
        18042: 'گرجایی',
        18043: 'پیهان',
        18044: 'زنگنه',
        18045: 'ده میانه',
        18046: 'کمازان',
        18047: 'میشن',
        18048: 'سلطان آباد/بهاره',
        18049: 'سامن',
        18050: 'حسین آباد/ناظم',
        18051: 'آورزمان',
        18052: 'کرتیل آباد',
        18053: 'دهلق ملایر',
        18054: 'لولوهر',
        18055: 'بلرتو',
        18056: 'رحمان آباد',
        18057: 'واشان',
        18058: 'انوچ',
        18059: 'نمازگاه',
        18060: 'دهنوآورزمان',
        18061: 'کهکدان',
        18062: 'طجرسامن',
        18063: 'آبدر',
        18064: 'جوکار',
        18065: 'علی آباددمق',
        18066: 'ننج',
        18067: 'کسب',
        18068: 'ینگی کند',
        18069: 'اسلام آباد',
        18070: 'حسین آباد/شاملو',
        18071: 'ازندریان',
        18072: 'زمان آباد',
        18073: 'علوی',
        18074: 'کمری',
        18075: 'منگاوی',
        18076: 'خردمند',
        18077: 'عشاق',
        18078: 'اوچ تپه',
        18079: 'دهنوعلی آباد',
        18080: 'بوربور',
        18081: 'طاسبندی',
        18082: 'طجرعلوی',
        18083: 'نهاوند',
        18084: 'چولک اصلی',
        18085: 'جهان آباد',
        18086: 'دهفول',
        18087: 'مهین آباد',
        18088: 'ورازنه',
        18089: 'شعبان',
        18090: 'کوهانی',
        18091: 'عسگرآباد',
        18092: 'گیان',
        18093: 'حسین آباد/گیان',
        18094: 'قلعه قباد',
        18095: 'کفراش',
        18096: 'توانه',
        18097: 'باباقاسم',
        18098: 'زرامین سفلی',
        18099: 'برزول',
        18100: 'کرک سفلی',
        18101: 'گیل آباد',
        18102: 'بیان',
        18103: 'سفیدخانی',
        18104: 'میلاب',
        18105: 'فاماسب',
        18106: 'بابارستم',
        18107: 'وهمان',
        18108: 'فیازمان',
        18109: 'طائمه',
        18110: 'کهریزسلیم',
        18111: 'وسج',
        18112: 'ملوسان',
        18113: 'فیروزان',
        18114: 'دهنوعبدالملکی',
        18115: 'ده موسی',
        18116: 'شریف آباد',
        18117: 'شهرک/نهاوند',
        18118: 'فارسبان',
        18119: 'رزینی',
        18120: 'گنبدکبود',
        18121: 'تویسرکان',
        18122: 'آرتیمان',
        18123: 'اشتران',
        18124: 'گشانی',
        18125: 'سیدشهاب',
        18126: 'باباپیر',
        18127: 'جیجانکوه',
        18128: 'شهرستانه',
        18129: 'سرکان',
        18130: 'جعفریه',
        18131: 'وردآوردعلیا',
        18132: 'اشترمل',
        18133: 'قلقل رود',
        18134: 'کهنوش',
        18135: 'فریازان',
        18136: 'مالیچه',
        18137: 'کرزان',
        18138: 'بوجان',
        18139: 'مبارک آباد',
        18140: 'دارانی',
        18141: 'فرسفج',
        18142: 'چاشتخوره',
        18143: 'لامیان',
        18144: 'کارخانه',
        18145: 'والاشجرد',
        18146: 'باباکمال',
        18147: 'میانده',
        18148: 'سوتلق',
        18149: 'قلعه نو',
        18150: 'شان آباد',
        18151: 'جرا'
    },
    21: {
        12773: 'یزد',
        12774: 'شحنه',
        12775: 'خویدک',
        12776: 'سیدمیرزا',
        12777: 'احمدآباد/مشیر',
        12778: 'فهرج',
        12779: 'دهنو',
        12780: 'حسین آباد/ریسمانی',
        12781: 'محمدآبادیزد',
        12782: 'اشکذر',
        12783: 'زارچ',
        12784: 'حسن آباد/حسین آباد',
        12785: 'شمسی',
        12786: 'شرف آباد',
        12787: 'صدرآباد',
        12788: 'تقویه',
        12789: 'بندرآباد',
        12790: 'خضرآباد',
        12791: 'ندوشن',
        12792: 'کذاب/هامانه',
        12793: 'صدرآبادندوشن',
        12794: 'سورک',
        12795: 'بافق',
        12796: 'بساب',
        12797: 'شیطور/دولت آباد',
        12798: 'باجگان',
        12799: 'ده کوشک',
        12800: 'بهاباد',
        12801: 'احمدآباد/کریم آباد',
        12802: 'آسفیج',
        12803: 'کویجان',
        12804: 'علی آباد/خیرآباد',
        12805: 'بنستان',
        12806: 'بنیز',
        12807: 'ده جمال',
        12808: 'آریج',
        12809: 'خوسف/بشگان',
        12810: 'مهریز',
        12811: 'خورمیز',
        12812: 'تنگ چنار',
        12813: 'شهرک صنعتی/مهریز',
        12814: 'سریزد',
        12815: 'سروارنان',
        12816: 'بهادران',
        12817: 'علی آبادچهل گزی',
        12818: 'طزنج',
        12819: 'هنزا',
        12820: 'مزرعه/حاجی عبداله',
        12821: 'منشاد',
        12822: 'گردکوه',
        12823: 'بنادک',
        12824: 'هرات',
        12825: 'فتح آباد',
        12826: 'ترکان/هراورجان',
        12827: 'مروست',
        12828: 'کرخنگان',
        12829: 'توتک',
        12831: 'هاشم آباد',
        12832: 'چاهک/هاشم آباد',
        12833: 'تفت',
        12834: 'گلویک',
        12835: 'مزرعه حاج علی عسگر',
        12836: 'فیض آباد/صادق آباد',
        12837: 'خودسفلی',
        12838: 'سانیج',
        12839: 'ده بالا',
        12840: 'طزرجان',
        12841: 'نصرآباد',
        12842: 'همت آباد',
        12843: 'اسلامیه',
        12844: 'سعیدآباد',
        12845: 'علی آباد',
        12846: 'نیر',
        12847: 'رشکوئیه',
        12848: 'کهدوئیه',
        12849: 'زردین',
        12850: 'میرهاشم',
        12851: 'توران پشت',
        12852: 'عبداله',
        12853: 'حسن آباد/دره زرشک',
        12854: 'سلطانب',
        12855: 'شواز',
        12856: 'شریف آباد',
        12857: 'چاهوک/پندر',
        12858: 'بیدآخوید',
        12859: 'بنادکوک دیزه',
        12860: 'سخوید',
        12861: 'بخ',
        12862: 'دهشیر',
        12863: 'ابرکوه',
        12864: 'شهراسب',
        12865: 'بهمن',
        12866: 'خرم آباد',
        12867: 'شهرآباد',
        12868: 'فراغه',
        12869: 'صادق آباد',
        12870: 'بداف',
        12871: 'شمس آباد',
        12872: 'مریم آباد',
        12873: 'اسفندآباد',
        12874: 'ده عرب',
        12875: 'فیروزآباد',
        12876: 'اردکان',
        12877: 'احمدآباد/اردکان',
        12878: 'هفتادر',
        12879: 'سروسفلی',
        12880: 'عقدا',
        12881: 'مزرعه نو',
        12882: 'سروعلیا',
        12883: 'چاه افضل',
        12884: 'اشتیجه',
        12885: 'فخرآباد',
        12886: 'زرجوع',
        12887: 'خرانق',
        12888: 'رباط پشت بادام',
        12889: 'ساغند',
        12890: 'حاجی آباد/زرین',
        12891: 'میبد',
        12892: 'شهرک صنعتی/میبد',
        12893: 'رکن آباد/مهرآباد',
        12894: 'حجت آباد/محمدآباد',
        12895: 'هفتهر',
        12896: 'مزرعه کلانتر',
        12897: 'طبس',
        12898: 'جوخواه',
        12899: 'حلوان',
        12900: 'دیهوک',
        12901: 'کریت',
        12902: 'فهالنج',
        12903: 'پیکوه',
        12904: 'مرغوب',
        12905: 'خسروآباد',
        12906: 'محمدآبادطبس',
        12907: 'زنوغان',
        12908: 'اسفندیار',
        12909: 'عرب آباد',
        12910: 'نایبند',
        12911: 'اصفهک',
        12912: 'عشق آباد',
        12913: 'هودر',
        12914: 'ده محمد',
        12915: 'رضویه'
    },
    22: {
        12272: 'اصفهان',
        12273: 'قهجاورستان',
        12274: 'مولنجان',
        12275: 'پایگاه/هشتم شکاری',
        12276: 'ردان فیزادان',
        12277: 'دنارت',
        12278: 'شهرک/بهارستان',
        12279: 'هرمدان',
        12280: 'حسن آباد/قهاب',
        12281: 'شیدان',
        12282: 'ده کرم',
        12283: 'رحیم آباد',
        12284: 'منشیان',
        12285: 'سرشبادران',
        12286: 'تیمیارت/فساران',
        12287: 'اشکاوند',
        12288: 'روران',
        12289: 'جوزدان برآن',
        12290: 'کبوترآباد',
        12291: 'زیار',
        12292: 'دشتی',
        12293: 'جور/اسفینا',
        12294: 'ایچی/جار/یفران',
        12295: 'جیلان آباد',
        12296: 'برسیان',
        12297: 'پیله وران',
        12298: 'کندلان/دستجا',
        12299: 'اسپارت',
        12300: 'کوهان برآن',
        12301: 'زردنجان',
        12302: 'اصفهان1',
        12303: 'خمینی شهر',
        12304: 'دستگردقداده',
        12305: 'قلعه امیریه',
        12306: 'کوشک',
        12307: 'اصغرآباد/خمینی شهر',
        12308: 'تیرانچی',
        12309: 'درچه پیاز',
        12310: 'میمه/وزوان',
        12311: 'لای بید',
        12312: 'موته',
        12313: 'حسن رباط',
        12314: 'ونداده',
        12315: 'اذان',
        12316: 'شاهین شهر',
        12317: 'شاهپورآباد',
        12318: 'کمشچه',
        12319: 'سین',
        12320: 'سه برخوار',
        12321: 'کلهرود',
        12322: 'جهادآباد',
        12323: 'دستجرد/برخوار',
        12324: 'خورزق/برخوار',
        12325: 'حبیب آبادبرخوار',
        12326: 'بیدشک/دهلر',
        12327: 'مورچه خورت',
        12328: 'گزبرخوار',
        12329: 'گرگاب',
        12330: 'دولت آباد',
        12331: 'دولت آباد/صنعتی',
        12332: 'علی آبادملاعلی',
        12333: 'کوهپایه',
        12334: 'هرند',
        12335: 'جندان',
        12336: 'اشکهران',
        12337: 'تودشک',
        12338: 'زفره',
        12339: 'جزه اصفهان',
        12340: 'مزرعه شور',
        12341: 'اسلام آباد',
        12342: 'سهر',
        12343: 'هاشم آباد',
        12344: 'شهرک صنعتی/سجزی',
        12345: 'ورزنه',
        12346: 'کلیشاد/هرند',
        12347: 'حبیب آباد/آذرخواران',
        12348: 'قورتان',
        12349: 'کفران/فارفان',
        12350: 'جوشقان',
        12351: 'باقرآباد/کوهپایه',
        12352: 'مشکنان',
        12353: 'قهی',
        12354: 'اژیه',
        12355: 'پایگاه هوائی/هاشم آباد',
        12356: 'سهران',
        12357: 'سجزی',
        12358: 'خرم/خورچان',
        12359: 'جندابه',
        12360: 'بزم',
        12361: 'کفرود',
        12362: 'فیض آباد/شریف آباد',
        12363: 'گیشی/قمشنان/قلعه بالا',
        12364: 'طهمورثات',
        12365: 'علوان آباد',
        12366: 'ورتون',
        12367: 'سونیچی',
        12368: 'نیک آباد',
        12369: 'محمدآبادجرقویه',
        12370: 'مالواجرد',
        12371: 'اسفنداران',
        12372: 'دستجرد/کمال آباد',
        12373: 'نصرآبادجرقویه',
        12374: 'رامشه',
        12375: 'سیان/گنج آباد',
        12376: 'حیدرآباد',
        12377: 'حسن آباد/جرقویه',
        12378: 'پیکان',
        12379: 'شهرضا',
        12380: 'جرم افشار',
        12381: 'اسفرجان',
        12382: 'هونجان',
        12383: 'منظریه',
        12384: 'مهیار',
        12385: 'قصرچم',
        12386: 'امین آباد',
        12387: 'بوان',
        12388: 'امامزاده/علی اکبر',
        12389: 'مقصودبیک/وشاره/باغ سرخ',
        12390: 'سولار',
        12391: 'زیارتگاه',
        12392: 'کهرویه',
        12393: 'اسلام آباد/شهرضا',
        12394: 'دهاقان',
        12395: 'پوده/قهه',
        12396: 'علی آبادجمبزه شهرضا',
        12397: 'قمبوان',
        12398: 'همگین',
        12399: 'موسی آباد',
        12400: 'قمیشلو',
        12401: 'دزج',
        12402: 'کره',
        12403: 'سمیرم',
        12404: 'فتح آباد',
        12405: 'ونک',
        12406: 'حنا',
        12407: 'مهرگرد',
        12408: 'گرموک',
        12409: 'کمه',
        12410: 'بیده',
        12411: 'کیفته پادنا',
        12412: 'چهارراه/سعادت آباد',
        12413: 'خفرشهرضا',
        12414: 'سیور',
        12415: 'نقل/دنگزلو',
        12416: 'دماب',
        12417: 'بافران',
        12418: 'نائین',
        12419: 'فوداز',
        12420: 'کجان نائین',
        12421: 'بلان نائین',
        12422: 'نیستانک',
        12423: 'مهرآدران',
        12424: 'سهیل/سپرو',
        12425: 'هماآباد',
        12426: 'بنویدعلیا',
        12427: 'انارک',
        12428: 'چوپانان',
        12429: 'خور/بیابانک',
        12430: 'بیاضه',
        12431: 'جندق نائین',
        12432: 'ایراج نائین',
        12433: 'مهرجان نائین',
        12434: 'چاه ملک',
        12435: 'فرخی نائین',
        12436: 'جعفرآباد/ابراهیم آباد',
        12437: 'گرمه',
        12438: 'عروسان گلستان',
        12439: 'اردیب',
        12440: 'هفتومان',
        12441: 'نجف آباد',
        12442: 'گلدشت',
        12443: 'ویلاشهر',
        12444: 'جوزدان/نجف آباد',
        12445: 'کهریزسنگ',
        12446: 'رحمت آباد/نجف آباد',
        12447: 'امیرآباد',
        12448: 'یزدانشهر',
        12449: 'حاجی آباد',
        12450: 'نهضت آبادنجف آباد',
        12451: 'تیران',
        12452: 'عسگران',
        12453: 'افجان',
        12454: 'میرآبادنجف آباد',
        12455: 'قلعه ناظر',
        12456: 'قهریزجان',
        12457: 'تندران',
        12458: 'خرمنان',
        12459: 'بودان',
        12460: 'کنهران',
        12461: 'کردعلیا',
        12462: 'کردسفلی',
        12463: 'ورپشت',
        12464: 'دولت آباد/نجف آباد',
        12465: 'مهدی آبادنجف آباد',
        12466: 'الوار',
        12467: 'آبگرم',
        12468: 'عزیزآباد',
        12469: 'دره بید/نجف آباد',
        12470: 'رضوانشهر',
        12471: 'سوران',
        12472: 'حسن آباد/آبریزه',
        12473: 'کوهان نجف آباد',
        12474: 'جعفرآباد/خمیران',
        12475: 'آب پونه',
        12476: 'دوتو',
        12477: 'حسن آباد/علیا',
        12478: 'دهق',
        12479: 'علویجه',
        12480: 'حسین آباد/عربستان',
        12481: 'خونداب',
        12482: 'اشن',
        12483: 'دماب/نجف آباد',
        12484: 'گلدره',
        12485: 'خیرآباد/نجف آباد',
        12486: 'علی آبادمهردشت',
        12487: 'زرین شهر',
        12488: 'چمگردان',
        12489: 'ورنامخواست',
        12490: 'سده لنجان',
        12491: 'مدیسه',
        12492: 'کارخانه/ذوب آهن',
        12493: 'فولادشهر',
        12494: 'کجان زرین شهر',
        12495: 'شهرزاینده رود/بهجت آباد/باباشیخعلی/کله/سلمان/مسیح',
        12496: 'اله آباد',
        12497: 'جعفرآباد/نائین',
        12498: 'مجتمع/صنایع دفاع',
        12499: 'نوگوران',
        12500: 'اوشیان',
        12501: 'کچوئیه',
        12502: 'فلاورجان',
        12503: 'کلیشادفلاورجان',
        12504: 'سیاه افشار',
        12505: 'لارگان/لارگیجی',
        12506: 'باغ ابریشم/یزدآباد',
        12507: 'کاویان',
        12508: 'قلعه میر',
        12509: 'مینادشت',
        12510: 'اشترجان/ایمانشهر',
        12511: 'زازران',
        12512: 'کرسکان',
        12513: 'قهدریجان',
        12514: 'هویه/ریاخون',
        12515: 'زفره فلاورجان',
        12516: 'پیربکران',
        12517: 'سهرفیروزان',
        12518: 'سهلوان/باغکومه',
        12519: 'علیشاهدان',
        12520: 'پلارنگان/دارافشان',
        12521: 'آبنیل',
        12522: 'طاد/ونهر',
        12523: 'دارگان',
        12524: 'مهرگان',
        12525: 'مبارکه',
        12526: 'شهرک/صفائیه',
        12527: 'اراضی/باغ ملک',
        12528: 'حسن آباد/تنگ بیدکان',
        12529: 'دیزیچه/نکوآباد',
        12530: 'شهرک صنعتی/مبارکه',
        12531: 'کرکوند',
        12532: 'فولادمبارکه',
        12533: 'شهرک/علامه مجلسی',
        12534: 'هراتمه',
        12535: 'حوض ماهی/آبرو',
        12536: 'ده سرخ',
        12537: 'طالخونچه',
        12538: 'خولنجان/آدرگان/لنج/زیباشهر',
        12539: 'کوشکیچه/بارچان/دستگردمهرآوران',
        12540: 'بروزاد/میرآباد',
        12541: 'باغ بهادران',
        12542: 'چرمهین',
        12543: 'کرچگان',
        12544: 'مورکان',
        12545: 'چم نور/چم یوسفعلی',
        12546: 'کلیشادرخ',
        12547: 'هاردنگ',
        12548: 'کته شور/صادق آباد',
        12549: 'چم طاق/چم حیدر',
        12550: 'لای بید/حاجت آقا',
        12551: 'پرکستان',
        12552: 'زمان آباد',
        12553: 'خشوئیه',
        12554: 'کاهریز',
        12555: 'جعفرآباد/زرین شهر',
        12830: 'مبارکه',
        12916: 'کاشان',
        12917: 'خرمدشت',
        12918: 'دره',
        12919: 'جوشقان استرک',
        12920: 'جزه کاشان',
        12921: 'سن سن',
        12922: 'مشکان',
        12923: 'شهرک صنعتی/امیرکبیر',
        12924: 'استرک',
        12925: 'آبشیرین',
        12926: 'جهق',
        12927: 'شهرک/22بهمن',
        12928: 'راوند',
        12929: 'طاهرآباد',
        12930: 'خزاق',
        12931: 'قه',
        12932: 'مرق/سادیان',
        12933: 'حسین آباد/کویر',
        12934: 'قاسم آباد',
        12935: 'اسحاق آباد',
        12936: 'ابوزیدآباد',
        12937: 'علی آبادفخره',
        12938: 'ریجان',
        12939: 'آران/بیدگل',
        12940: 'نوش آباد',
        12941: 'نصرآبادکاشان',
        12942: 'علی آباد/محمدآباد',
        12943: 'یزدل',
        12944: 'نیاسر',
        12945: 'ویدوج',
        12946: 'نشلج',
        12947: 'رهق',
        12948: 'علوی',
        12949: 'وادقان',
        12950: 'آزران',
        12951: 'ویدوجا',
        12952: 'ازوار',
        12953: 'ورکان',
        12954: 'حسنارود',
        12955: 'برزوک',
        12956: 'کله/ارمک',
        12957: 'قمصرکاشان',
        12958: 'جوشقان قالی',
        12959: 'قزاآن',
        12960: 'قهرود',
        12961: 'کامو',
        12962: 'نطنز',
        12963: 'کمجان',
        12964: 'طرق رود',
        12965: 'بادرودنطنز',
        12966: 'ابیانه',
        12967: 'ده آباد/متین آباد/فهی',
        12968: 'اریسمان',
        12969: 'طار',
        12970: 'طامه',
        12971: 'مجتمع/کالای الکتریک',
        12972: 'هنجن',
        12973: 'نیه',
        12974: 'طره',
        12975: 'چیمه',
        12976: 'اوره',
        12977: 'برز',
        12978: 'یارند',
        12979: 'ولوجرد',
        12980: 'کشه',
        12981: 'بیدهند',
        12982: 'فریزهند',
        12983: 'خفرکاشان',
        12984: 'نسران',
        12985: 'اردستان',
        12986: 'مهاباد',
        12987: 'باقرآباد/اردستان',
        12988: 'موغار',
        12989: 'زواره کاشان',
        12990: 'کچومثقال',
        12991: 'تلک آباد',
        12992: 'رحمت آباد/کاشان',
        12993: 'کچورستاق/امیران',
        12994: 'احمدآباد/گلزارمحمد',
        12995: 'درباغ',
        12996: 'ظفرقند',
        12997: 'سفیده',
        12998: 'شهراب',
        12999: 'قهساره',
        13000: 'حسین آباد/اردستان',
        13001: 'جنبه',
        13002: 'نیسیان',
        13003: 'کهنگ',
        13004: 'نهوج',
        13005: 'خیرآباد/کاشان',
        13006: 'خوانسار',
        13007: 'قودجان/تیدجان',
        13008: 'ارجنگ/کهرت',
        13009: 'دوشخراط',
        13010: 'تجره/مهرآباد',
        13011: 'سنگ سفید',
        13012: 'ویست',
        13013: 'خم پیچ',
        13014: 'رحمت آباد/خوانسار',
        13015: 'وانشان',
        13016: 'گلپایگان/نیوان',
        13017: 'سراور',
        13018: 'شادگان/فاویان',
        13019: 'کنجدجان',
        13020: 'تیکن',
        13021: 'در',
        13022: 'ورزنه گلپایگان',
        13023: 'سعیدآباد',
        13024: 'هنده',
        13025: 'داران',
        13026: 'سواران',
        13027: 'قودجانک',
        13028: 'خلج/قوهک',
        13029: 'گشنیزجان',
        13030: 'چهل خانه',
        13031: 'نهرخلج',
        13032: 'آنالوچه',
        13033: 'دامنه',
        13034: 'اسکندری',
        13035: 'بادجان',
        13036: 'گنجه',
        13037: 'عادگان',
        13038: 'ننادگان',
        13039: 'سفتجان',
        13040: 'قفر',
        13041: 'خویگان سفلی',
        13042: 'بلمیر',
        13043: 'اوزنبلاغ',
        13044: 'قره بلطاق',
        13045: 'نماگرد',
        13046: 'بوئین/میاندشت',
        13047: 'تخماقلو',
        13048: 'کرچ',
        13049: 'هندوکش',
        13050: 'بتلیجه',
        13051: 'بلطاق',
        13052: 'قائم آباد',
        13053: 'آغچه',
        13054: 'دره بیدخوانسار',
        13055: 'ازناوله',
        13056: 'معصوم آباد',
        13057: 'میرآبادخوانسار',
        13058: 'چادگان',
        13059: 'رزوه',
        13060: 'حجت آباد',
        13061: 'کمیتک',
        13062: 'مشهدکاوه',
        13063: 'علی آباد/قلعه شاهرخ',
        13064: 'معروف آباد/قرقر',
        13065: 'اورگان',
        13066: 'سدزاینده رود',
        13067: 'فریدونشهر',
        13068: 'سیبک',
        13069: 'خویگان علیا',
        13070: 'نهضت آبادخوانسار',
        13071: 'قلعه سرخ',
        13072: 'دهسور',
        13073: 'افوس',
        13074: 'چقیورت',
        13075: 'چغا',
        13076: 'خمسلو',
        18544: 'گلپایگان'
    },
    23: {
        17941: 'ایلام',
        17942: 'چالسرا',
        17943: 'شهرک/شهید/کشوری/سرتاف',
        17944: 'مهدی آباد',
        17945: 'چشمه کبود',
        17946: 'هفت چشمه',
        17947: 'جعفرآباد',
        17948: 'شهرک صنعتی/ایلام',
        17949: 'چوار',
        17950: 'مورت',
        17951: 'گنجوان',
        17952: 'ایوان غرب',
        17953: 'سراب',
        17954: 'شهرک/نبوت',
        17955: 'کلان',
        17956: 'چهارمله',
        17957: 'کله جوب ایوان',
        17958: 'خوران',
        17959: 'زرنه',
        17960: 'کپنه کران',
        17961: 'ترن',
        17962: 'سرابله',
        17963: 'زنجیره سفلی',
        17964: 'کهره هلیلان',
        17965: 'خورده چشمه',
        17966: 'شباب',
        17967: 'صیدنظری سفلی',
        17968: 'شله کش',
        17969: 'صیدنظری علیا',
        17970: 'زنجیره علیا',
        17971: 'کل کل',
        17972: 'سرتنگ مله ماران',
        17973: 'سنگ سفید',
        17974: 'جان جان',
        17975: 'شیراوند',
        17976: 'علی مدد',
        17977: 'بلاوه تره سفلی',
        17978: 'تخم بلوط سفلی',
        17979: 'زیرتنگ',
        17980: 'هلسم',
        17981: 'لومار',
        17982: 'سراب کلان',
        17983: 'لرینی',
        17984: 'علی آبادعلیا',
        17985: 'قنات آباد',
        17986: 'کله جوب شیروان چرداول',
        17987: 'دره شهر',
        17988: 'ماژین',
        17989: 'ارمو',
        17990: 'عباس آباد',
        17991: 'اسلام آباد',
        17992: 'وحدت آباد',
        17993: 'چم ژاب',
        17994: 'شیخ مکان',
        17995: 'دلفان آباد',
        17996: 'دشت چمران',
        17997: 'بدره/گچکوبان/شهرک ولیعصر',
        17998: 'چشمه شیرین',
        17999: 'زرانگوش',
        18000: 'تلخاب',
        18001: 'کلم',
        18002: 'آبدانان',
        18003: 'پشت قلعه',
        18004: 'سراب باغ',
        18005: 'مورموری',
        18006: 'هزارانی',
        18007: 'چم کبود',
        18008: 'وچکاب',
        18009: 'آب انار',
        18010: 'ژیور',
        18011: 'انجیره',
        18012: 'گنداب',
        18013: 'دهلران',
        18014: 'بیشه دراز',
        18015: 'موسیان',
        18016: 'دشت عباس',
        18017: 'پهله زرین آباد',
        18018: 'میمه',
        18019: 'بردی',
        18020: 'مهران',
        18021: 'چالاب',
        18022: 'شهرک/اسلامیه',
        18023: 'بان رحمان',
        18024: 'چنگوله',
        18025: 'ارکوازملک شاهی',
        18026: 'مهرملکشاهی',
        18027: 'گنبدپیرمحمد',
        18028: 'صالح آباد',
        18029: 'گلان'
    },
    24: {
        17244: 'بندر بوشهر',
        17245: 'چغارک',
        17246: 'آب طویل',
        17247: 'هلیله',
        17248: 'چاه کوتاه',
        17249: 'سرمل حسینکی',
        17250: 'احمدی/دویره',
        17251: 'بندرگاه',
        17252: 'جزیره/شیف',
        17253: 'تل اشکی',
        17254: 'نوکارمخی',
        17255: 'خارک/جزیره خارک',
        17256: 'بندرگناوه',
        17257: 'مال قائد',
        17258: 'چاه بردی',
        17259: 'محمدصالحی',
        17260: 'فخرآوری',
        17261: 'بهمنیارشرقی',
        17262: 'گماران',
        17263: 'بندر/ریگ',
        17264: 'جزیره/ریگ',
        17265: 'چهارروستائی',
        17266: 'محمدی',
        17267: 'پوزه گاه',
        17268: 'چهارمحال',
        17269: 'گوابین',
        17270: 'گاوسفید',
        17271: 'مال محمود',
        17272: 'چهاربرج گناوه',
        17273: 'رودشور',
        17274: 'بندر/دیلم',
        17275: 'سیاه مکان',
        17276: 'کنارکوه',
        17277: 'بیدو',
        17278: 'عامری دیلم',
        17279: 'امام/حسن',
        17280: 'حصار',
        17281: 'بنه اسماعیل',
        17282: 'اهرم',
        17283: 'آباد',
        17284: 'بازوئی',
        17285: 'بنه گز',
        17286: 'سمل جنوبی',
        17287: 'قباکلکی',
        17288: 'کناری',
        17289: 'شورکی',
        17290: 'عالی حسینی',
        17291: 'باغک',
        17292: 'اشکالی',
        17293: 'چاه پیر',
        17294: 'خیاری',
        17295: 'گلکی',
        17296: 'دلوارساحلی',
        17297: 'ابوالخیر',
        17298: 'بندر/رستمی',
        17299: 'جائینک',
        17300: 'عامری ساحلی',
        17301: 'عالی شهر',
        17302: 'عالی چنگی',
        17303: 'باشی',
        17304: 'گورک سادات',
        17305: 'پهلوان کشی',
        17306: 'گرگور',
        17307: 'چاه تلخ شمالی',
        17308: 'خورشهاب',
        17309: 'گورک دژگاه',
        17310: 'کری',
        17311: 'خورموج',
        17312: 'درازی',
        17313: 'چاووشی',
        17314: 'چارک',
        17315: 'کلل دشتی',
        17316: 'عربی',
        17318: 'محمدآباد',
        17319: 'بوحیری',
        17320: 'لاوررزمی',
        17321: 'شیخیان ماری',
        17322: 'گنخک شیخی',
        17323: 'باغان',
        17324: 'درویشی',
        17325: 'لاورساحلی',
        17326: 'سنا',
        17327: 'شنبه',
        17328: 'سرمک',
        17329: 'کاکی',
        17330: 'بادوله',
        17331: 'زیارت ساحلی',
        17332: 'بنیاد',
        17333: 'باب منیر',
        17334: 'کردوان علیا',
        17335: 'بندر/کنگان',
        17336: 'چاه مبارک',
        17337: 'بندر/طاهری',
        17338: 'عسلویه',
        17339: 'پرک',
        17340: 'اخند',
        17341: 'شیرینو',
        17342: 'نخل تقی',
        17343: 'بنک',
        17344: 'بیدخون',
        17345: 'منطقه ویژه/پارس جنوبی',
        17346: 'بستانو',
        17347: 'هاله',
        17348: 'ببود',
        17349: 'سهموشمالی',
        17350: 'بندو',
        17351: 'خره',
        17352: 'کلات',
        17353: 'میانلو',
        17354: 'جم',
        17355: 'دولنگه',
        17356: 'ریز',
        17357: 'انارستان',
        17358: 'دره بان',
        17359: 'جم',
        17360: 'آبگرمک',
        17361: 'گندمزار',
        17362: 'جنوب جم',
        17363: 'تنگمان',
        17364: 'قائدی',
        17365: 'صیدی',
        17366: 'بندر/دیر',
        17367: 'بندر/الی',
        17368: 'دوراهک',
        17369: 'آبدان',
        17370: 'بردستان',
        17371: 'لمبدان',
        17372: 'سرمستان',
        17373: 'جبرانی',
        17374: 'گنوی',
        17375: 'ملگه',
        17376: 'بردخون',
        17377: 'شهنیا',
        17378: 'آبکش',
        17379: 'مغدان',
        17380: 'برازجان',
        17381: 'نورآباد',
        17382: 'چاه خانی',
        17383: 'عیسوند',
        17384: 'سرکره',
        17385: 'زیارت',
        17386: 'دالکی',
        17387: 'بوشکان',
        17388: 'فاریاب',
        17389: 'خوشاب',
        17390: 'راهدار',
        17391: 'بنداروز',
        17392: 'کره بند',
        17393: 'دهرودسفلی',
        17394: 'کلمه',
        17395: 'تنگ ارم',
        17396: 'رودفاریاب',
        17397: 'قلعه سفید',
        17398: 'طلحه',
        17399: 'جمیله',
        17400: 'دهرودعلیا',
        17401: 'کلل دشتستان',
        17402: 'پرگانک',
        17403: 'نی نیزک',
        17404: 'خیرآباد',
        17405: 'سعدآباد',
        17406: 'نظرآقا',
        17407: 'وحدتیه',
        17408: 'درودگاه',
        17409: 'جتوط',
        17410: 'تل سرکوب',
        17411: 'بشیرآباد',
        17412: 'سربست',
        17413: 'هلپه ای',
        17414: 'سرقنات',
        17415: 'شول',
        17416: 'آب پخش',
        17417: 'خلیفه ای',
        17418: 'ده کهنه/شبانکاره',
        17419: 'دهداران',
        17420: 'دشتی اسماعیل خانی',
        17421: 'محمدجمالی',
        17422: 'دشتگور',
        17423: 'بویری',
        17424: 'میاندشت',
        17425: 'چهاربرج برازجان',
        17426: 'بنارآزادگان',
        17427: 'عطیبه',
        17428: 'چهل ذرعی عجم',
        17429: 'میلک',
        17430: 'لایپه'
    },
    25: {
        13077: 'شهر کرد',
        13078: 'ارجنک',
        13079: 'پیربلوط',
        13080: 'کالولک',
        13081: 'فرخ شهر',
        13082: 'طاقانک',
        13083: 'هفشجان',
        13084: 'شمس آباد',
        13085: 'شلمزار',
        13086: 'قلعه تک',
        13087: 'گهرو',
        13088: 'نافج',
        13089: 'سورک',
        13090: 'قلعه میکلا',
        13091: 'ایرانچه',
        13092: 'خیرآباد',
        13093: 'زوردگان',
        13094: 'دزک',
        13095: 'حاجی آباد',
        13096: 'امامزاده/دستگرد',
        13097: 'دستنا',
        13098: 'خراجی',
        13099: 'سرتشنیز',
        13100: 'گشنیزجان',
        13101: 'تشنیز',
        13102: 'سورشجان',
        13103: 'خوی',
        13104: 'مرغملک',
        13105: 'هارونی',
        13106: 'وانان',
        13107: 'مصطفی آباد',
        13108: 'اسدآباد',
        13109: 'سوده جان',
        13110: 'سامان',
        13111: 'مارکده/قوچان',
        13112: 'چم چنگ',
        13113: 'چم خلیفه',
        13114: 'شوراب کبیر',
        13115: 'گرمدره',
        13116: 'سوادجان',
        13117: 'هوره',
        13118: 'چم عالی',
        13119: 'چم زین/چلیوان',
        13120: 'کاهکش',
        13121: 'شوراب صغیر',
        13122: 'چم کاکا/دشتی',
        13123: 'بن',
        13124: 'شیخ شعبان',
        13125: 'یان چشمه',
        13126: 'بارده',
        13127: 'هرچگان',
        13128: 'وردنجان',
        13129: 'حیدری',
        13130: 'لارک',
        13131: 'تومانک',
        13132: 'یاسه چاه',
        13133: 'بروجن',
        13134: 'دهنوبروجن',
        13135: 'نقنه',
        13136: 'فرادنبه',
        13137: 'سفیددشت',
        13138: 'گندمان',
        13139: 'بلداجی',
        13140: 'امام/قیس',
        13141: 'سیبک',
        13142: 'کنارک',
        13143: 'مورچگان',
        13144: 'کردشامی',
        13145: 'آورگان',
        13146: 'گلوگرد',
        13147: 'بیژگرد',
        13148: 'نصیرآباد',
        13149: 'سیف آباد',
        13150: 'دوراهان',
        13151: 'کلبی بک',
        13152: 'آقبلاغ',
        13153: 'حسین آباد',
        13154: 'سولیجان',
        13155: 'گدارکبک',
        13156: 'لردگان',
        13157: 'سردشت',
        13158: 'کینک',
        13159: 'کهیان',
        13160: 'بوگر',
        13161: 'دهنومیلاس',
        13162: 'چمن بید',
        13163: 'بیدله',
        13164: 'دهنوگرگ اله',
        13165: 'معمور',
        13166: 'پل بریده',
        13167: 'منجرمویی',
        13168: 'منج/مشکدوزان',
        13169: 'ارمند',
        13170: 'باغ انارمیلاس',
        13171: 'سونک',
        13172: 'ناغان لردگان',
        13173: 'چله گاه',
        13174: 'آلونی',
        13175: 'مرادان',
        13176: 'بردبر',
        13177: 'ده صحرا',
        13178: 'باغ بهزاد',
        13179: 'سلح چین',
        13180: 'گوشکی',
        13181: 'چنارمحمودی',
        13182: 'جوانمردی',
        13183: 'مال خلیفه',
        13184: 'یونکی',
        13185: 'سندگان',
        13186: 'دشت پاگرد',
        13187: 'شهریار',
        13188: 'ابواسحاق',
        13189: 'گنج/گرداب',
        13190: 'سهل آباد/ده سوخته',
        13191: 'اردل',
        13192: 'آلیکوه',
        13193: 'رستم آباد',
        13194: 'کاج',
        13195: 'سرچاه',
        13196: 'دشتک',
        13197: 'معدن',
        13198: 'جغدان',
        13199: 'ناغان',
        13200: 'باجگیران',
        13201: 'قلعه رشید',
        13202: 'دورک اناری',
        13203: 'شلیل',
        13204: 'گل سفید/دوپلان',
        13205: 'رفن',
        13206: 'ده کهنه رویگر',
        13207: 'چهراز',
        13208: 'کاونددرویشان',
        13209: 'لیرابی',
        13210: 'دوازده امام',
        13211: 'سرمور/ممسنی',
        13212: 'سرخون',
        13213: 'برجوئی',
        13214: 'هلوسعد',
        13215: 'گندمکار',
        13216: 'فارسان/کران',
        13217: 'عیسی آباد',
        13218: 'باباحیدر',
        13219: 'گوشه/چغاهست',
        13220: 'امیدآباد',
        13221: 'جونقان',
        13222: 'فیل آباد',
        13223: 'چلیچه',
        13224: 'کوهرنگ',
        13225: 'دهنوکوهرنگ',
        13226: 'میهه',
        13227: 'دشت زرین',
        13228: 'گردو',
        13229: 'چمن گلی',
        13230: 'بهمن آباد/صمصامی',
        13231: 'مورز'
    },
    26: {
        16082: 'اهواز',
        16083: 'دغاغله',
        16084: 'ام الطمیر',
        16085: 'غیزانیه کوچک',
        16086: 'غیزانیه بزرگ',
        16087: 'الباجی',
        16088: 'بهر',
        16089: 'گبیریک',
        16090: 'بروایه یوسف',
        16091: 'عشاره بزرگ',
        16092: 'عین دو',
        16093: 'الهائی',
        16094: 'کریت برومی',
        16095: 'جنگیه/عمیره',
        16096: 'قلعه چنعان',
        16097: 'حمیدیه',
        16098: 'طراح سیدعلی',
        16099: 'جسانیه بزرگ',
        16100: 'شیخ زهراو',
        16101: 'عوده',
        16102: 'گمبوعه بزرگ',
        16103: 'منازل سازمانی/دشت آزادگان',
        16104: 'شهرک صنعتی/الباجی',
        16105: 'یکاویه یک',
        16106: 'چمیان',
        16107: 'بیت واوی',
        16108: 'صفحه 2',
        16109: 'ملاثانی',
        16110: 'زرگان/ابوفاضل',
        16111: 'شیبان',
        16112: 'ویس اهواز',
        16113: 'کوت سیدسلطان',
        16114: 'سوسنگرد',
        16115: 'دهلاویه',
        16116: 'کوت سیدنعیم',
        16117: 'مرعی',
        16118: 'ساریه',
        16119: 'جلالیه',
        16120: 'مالکیه',
        16121: 'آلبوعفری',
        16122: 'شیخ صالح',
        16123: 'جلیزیه رضا',
        16124: 'هوفل شرقی',
        16125: 'جلیزه حنظله',
        16126: 'غوابش',
        16127: 'هویزه',
        16128: 'رفیع',
        16129: 'سمیده',
        16130: 'هورت عاگول',
        16131: 'یزدنو',
        16132: 'بستان',
        16133: 'کهباد',
        16134: 'کنارپیر',
        16135: 'شهرک/نورمحمدی',
        16136: 'شهرک/شهید/شرافت',
        16137: 'عرب اسد',
        16138: 'مهدی آباد',
        16139: 'عرب حسن',
        16140: 'دیلم',
        16141: 'شوشتر',
        16142: 'شهرک/شهید/رجائی',
        16143: 'شهرک/شهید/بهشتی اهواز',
        16144: 'شلیلی بزرگ',
        16145: 'گوریه',
        16146: 'سردارآباد',
        16147: 'زویه 2',
        16148: 'لنگر',
        16149: 'حسام آباد',
        16150: 'آب گرمک علیا',
        16151: 'گتوند',
        16152: 'جنت مکان',
        16153: 'شهرک/شهید/چمران شوشتر',
        16154: 'کایدان',
        16155: 'ترکالکی',
        16156: 'شهرک/شهید/محمدی',
        16157: 'کوشکک',
        16158: 'سماله',
        16159: 'آبادان',
        16160: 'تنگه مرکزی',
        16161: 'ابوشانک',
        16162: 'رده سادات',
        16163: 'ثوامر',
        16164: 'طره خضر',
        16165: 'چوئبده',
        16166: 'طره بخاخ',
        16167: 'اروندکنار',
        16168: 'منیوحی/ابوخضراوی',
        16169: 'ابوصدرین',
        16170: 'شادگان',
        16171: 'جفال',
        16172: 'بوزی',
        16173: 'بدرانی',
        16174: 'دارخوین',
        16175: 'خنافره',
        16176: 'نهرمسلم',
        16177: 'سالمی',
        16178: 'عبودی',
        16179: 'نهرحسین',
        16180: 'نهرمضیف',
        16181: 'دریسیه سفلی',
        16182: 'خرمشهر',
        16183: 'بازارچه مرزی/شلمچه',
        16184: 'حفارشرقی',
        16185: 'منیخ',
        16186: 'شهرک صنعتی/خرمشهر',
        16187: 'سوره',
        16188: 'جزیره/مینو',
        16189: 'دزفول',
        16190: 'شهرک/محمدبن جعفر',
        16191: 'شهرک/حمزه',
        16192: 'فضیلی',
        16193: 'شهرک/عدالت',
        16194: 'شهرک/شهید/منتظری',
        16195: 'سیاه منصور',
        16196: 'شهرک/انقلاب',
        16197: 'کهنگ',
        16198: 'شهرک/شهید/کریمی',
        16199: 'شهرک/مهاجرین',
        16200: 'جاته',
        16201: 'اسلام آباد/دزفول',
        16202: 'شهرک/خیبر',
        16203: 'چغامیش',
        16204: 'شهرک/شهید/مطهری',
        16205: 'شهرک/سیدنور',
        16206: 'قلعه نوشمس آباد',
        16207: 'بنوت بالا',
        16208: 'بلادیه',
        16209: 'شهرک/شهید/بهشتی دزفول',
        16210: 'شهرک/بنه حاجات',
        16211: 'شهرک/طالقانی دزفول',
        16212: 'هفت تپه',
        16213: 'شهرک/امام/حسین/صفی آباد',
        16214: 'شهرک/توحید/شهرک/شمس آباد',
        16215: 'شهرک/امام خمینی',
        16216: 'انجیرک',
        16217: 'بندبال',
        16218: 'سردشت',
        16220: 'شیرین آب',
        16221: 'اندیمشک',
        16222: 'دوکوهه',
        16223: 'قلعه لور',
        16224: 'شهرک/آزادی',
        16225: 'چمگلک',
        16226: 'شهرک/شهید/مدنی/دزفول',
        16227: 'علی آباد',
        16228: 'بلوارناظر',
        16229: 'دوبندار',
        16230: 'سددز',
        16231: 'حسینیه',
        16232: 'بیدروبه/کلگه دره',
        16233: 'جااردو',
        16234: 'گلگه دره یک',
        16235: 'شوش/عمله سیف/شهرک/شهید/دانش',
        16236: 'شوش دانیال',
        16237: 'شهرک/ابوذرغفاری',
        16238: 'شهرک/سلمان فارسی',
        16239: 'سیدرضی',
        16240: 'شهرک/بهرام',
        16241: 'خلف مسلم',
        16242: 'صالح مشطط',
        16243: 'صالح داوود',
        16244: 'جریه سیدمحمد',
        16245: 'خشان',
        16246: 'عبدالخان',
        16247: 'خویس',
        16248: 'میان آب دزفول',
        16249: 'سیدعباس',
        16250: 'شهرک/مسلم بن عقیل',
        16251: 'شیخ علی اصغر',
        16252: 'ابیتر',
        16253: 'شهرک/حربن ریاحی',
        16254: 'احمدمولا',
        16255: 'بنه رحیمه',
        16256: 'مالک اشتر',
        16257: 'مزرعه یک',
        16258: 'خسرج راضی حمد',
        16259: 'حسین غلیم',
        16260: 'سدشاور',
        16261: 'سربندر',
        16263: 'بندر/ماهشهر',
        16264: 'شهرک/شهید/چمران ماهشهر',
        16265: 'گرگرعلیا',
        16266: 'کشتیرانی/بندر/امام/خمینی',
        16267: 'مجتمع/پتروشیمی/بندر/امام/خمینی',
        16268: 'منطقه اقتصادی/بندر/امام/خمینی',
        16269: 'شهرک/شهید/مدنی/سربندر',
        16270: 'پایانه/بندر/امام/خمینی',
        16271: 'مجتمع/پتروشیمی/رازی سربندر',
        16272: 'امیدیه',
        16273: 'میانکوه',
        16274: 'چاه سالم',
        16275: 'آسیاب',
        16276: 'سویره',
        16277: 'امیرالمومنین',
        16278: 'هندیجان',
        16279: 'چم خلف عیسی',
        16280: 'ده ملا',
        16281: 'شهرک/طالقانی ماهشهر',
        16282: 'امامزاده/عبداله',
        16283: 'ناصرآباد',
        16447: 'بهبهان',
        16448: 'پیرآباد',
        16449: 'شهروئی',
        16450: 'منصوریه',
        16451: 'مشهدتشان',
        16452: 'کردستان',
        16453: 'آل طیب',
        16454: 'تاکائیدی',
        16455: 'کره سیاه تلخ',
        16456: 'دودانگه',
        16457: 'قالندعلیا',
        16458: 'کلگه زار',
        16459: 'اسدآباد',
        16460: 'شهرک/وحدت',
        16461: 'اسلام آباد/علیا',
        16462: 'ویسی',
        16463: 'گروه/پدافندهوائی',
        16464: 'تل گوینه',
        16465: 'زیدون',
        16466: 'قلعه کعبی',
        16467: 'لنگیرات',
        16468: 'درونک',
        16469: 'چم',
        16470: 'آغاجاری',
        16471: 'جایزان',
        16472: 'جولکی',
        16473: 'ارمش',
        16474: 'ده صفر',
        16475: 'مسجدسلیمان',
        16476: 'کوشک',
        16477: 'گلگیر',
        16478: 'هفت چشمه شهیدان',
        16479: 'رضاآباد/عوض آباد',
        16480: 'قلعه خواجه',
        16481: 'اسلام آباد/مسجدسلیمان',
        16482: 'آبژدان',
        16483: 'لالی',
        16484: 'گچ گرسا',
        16485: 'ططرآباد',
        16486: 'چگارمان',
        16487: 'سرگچ',
        16488: 'شهرک/شهید/اسدپور',
        16489: 'رامهرمز',
        16490: 'سلطان آباد',
        16491: 'مربچه',
        16492: 'باصدی',
        16493: 'رستم آباد',
        16494: 'بیت صیوان',
        16495: 'شهرک/شهید/رایگانی',
        16496: 'رامشیر',
        16497: 'رمیله',
        16498: 'پایگاه/پنجم شکاری',
        16499: 'مشراگه',
        16500: 'هفتگل رامهرمز',
        16501: 'رودزرد',
        16502: 'شهرک/طالقانی/هفتگل',
        16503: 'باغملک',
        16504: 'قلعه تل',
        16505: 'میداوودسفلی',
        16506: 'بارانگرد',
        16507: 'لران',
        16508: 'ابوالعباس',
        16509: 'چلچلک',
        16510: 'لالب',
        16511: 'تکیه',
        16512: 'صیدون',
        16513: 'پتک جلالی',
        16514: 'سرحانی',
        16515: 'دوراهی/اسلام آباد',
        16516: 'طلاور',
        16517: 'سرله',
        16518: 'برآفتاب',
        16519: 'دره نی',
        16520: 'دالان',
        16521: 'علا',
        16522: 'ایذه',
        16523: 'راسوند',
        16524: 'دهدز',
        16525: 'ده کهنه موزرم',
        16526: 'ده کیان',
        16527: 'سادات حسینی/ملاح',
        16528: 'حاجی کمال',
        16529: 'فالح',
        18534: 'پسکره',
        18546: 'پاداد اهواز'
    },
    27: {
        11577: 'سمنان',
        11578: 'لاسجرد',
        11579: 'افتر',
        11580: 'پادگان/نیروی هوائی',
        11581: 'بیابانک',
        11582: 'علا',
        11583: 'اروانه',
        11584: 'مومن آباد',
        11585: 'درجزین',
        11586: 'فولادمحله',
        11587: 'سرخه',
        11588: 'علاء',
        11589: 'مهدی شهر',
        11590: 'شهمیرزاد',
        11591: 'چاشم',
        11592: 'گرمسار',
        11593: 'محمدآباد',
        11594: 'فند/شه سفید',
        11595: 'شهرک صنعتی/والفجرگرمسار',
        11596: 'ریکان',
        11597: 'حاجی آباد',
        11598: 'آرادان',
        11599: 'داورآباد',
        11600: 'کهن آباد',
        11601: 'ایوانکی',
        11602: 'شهرک صنعتی/علی آباد',
        11603: 'شهرک صنعتی/ایوانکی',
        11604: 'شهرک صنعتی/دامغان',
        11605: 'دامغان',
        11606: 'دیباج چهارده',
        11607: 'بق',
        11608: 'حسین آباد/دولاب',
        11609: 'برم',
        11610: 'مهماندوست',
        11611: 'جزن گز',
        11612: 'آهوانو',
        11613: 'تویه رودبار',
        11614: 'کلاته رودبار',
        11615: 'معلمان',
        11616: 'نعیم آباد',
        11617: 'کوه زر',
        11618: 'مایان/وامرزان',
        11619: 'رشم',
        11620: 'طزره',
        11621: 'آستانه',
        11622: 'مومن آباددامغان',
        11623: 'امیرآباد',
        11624: 'دروار',
        11625: 'خورزان',
        11626: 'فرات',
        11627: 'تویه دروار',
        11628: 'صیدآباد',
        11629: 'عبداله آباد',
        11630: 'قدرت آباد',
        11994: 'شاهرود',
        11995: 'ده ملا',
        11996: 'رویان/دیزج',
        11997: 'حداده/کلاته ملا',
        11998: 'شهرک صنعتی/شاهرود',
        11999: 'قلعه نوخالصه',
        12000: 'قلعه شوکت/و/خوریان',
        12001: 'یونس آباد',
        12002: 'بدشت/سعدآباد',
        12003: 'طرود',
        12004: 'سطوه',
        12005: 'بسطام',
        12006: 'کلاته خیج',
        12007: 'تاش',
        12008: 'قلعه نوخرقان',
        12009: 'میغان',
        12010: 'پرو',
        12011: 'مجن',
        12012: 'ابرسیج',
        12013: 'ابرشاهرود',
        12014: 'خیج',
        12015: 'میان آباد',
        12016: 'پادگان/چهل دختر',
        12017: 'مزج',
        12018: 'حسین آباد/زنده',
        12019: 'جیلان',
        12020: 'میامی',
        12021: 'سوداغلن',
        12022: 'بکران',
        12023: 'حسین آباد/کالپوش',
        12024: 'دشت شاد',
        12025: 'فرومد',
        12026: 'نام نیک',
        12027: 'نردین',
        12028: 'تلوبین',
        12029: 'محمدآبادجودانه',
        12030: 'کرنگ',
        12031: 'ابراهیم آباد',
        12032: 'قدس',
        12033: 'باغچه',
        12034: 'عباس آباد',
        12035: 'ری آباد',
        12036: 'فیروزآباد',
        12037: 'حق الخواجه',
        12038: 'کلاته سادات',
        12039: 'کردآباد',
        12040: 'بیارجمند',
        12041: 'گیور',
        12042: 'دستجرد',
        12043: 'احمدآباد',
        12044: 'زمان آباد'
    },
    28: {
        15282: 'زاهدان',
        15283: 'نامشخص',
        15284: 'زابل',
        15285: 'خوشین',
        15286: 'میرجاوه',
        15287: 'ریگ ملک',
        15288: 'سرگه',
        15289: 'نصرت آباد',
        15290: 'خاش',
        15291: 'اسماعیل آباد',
        15292: 'نجف آباد',
        15293: 'سنگان',
        15294: 'ناصری',
        15295: 'عباس آباد',
        15296: 'ایرندگان',
        15297: 'سبزگزپشتکوه',
        15298: 'ده رئیس',
        15299: 'نوک آباد',
        15300: 'دهپابید',
        15301: 'اسکل آباد',
        15302: 'گوهرکوه',
        15303: 'تمندان',
        15304: 'کرباسک',
        15305: 'بنجار',
        15306: 'گل محمدبیک',
        15307: 'جهان تیغ',
        15308: 'ژاله ای',
        15309: 'دوست محمدخان/میان کنگی',
        15310: 'شهرک/قرقری',
        15311: 'خمر',
        15312: 'میلک',
        15313: 'مندیلان',
        15314: 'حسن خون',
        15315: 'زهک',
        15316: 'مجتمع/محمدشاه کرم',
        15317: 'خمک',
        15318: 'جزینک',
        15319: 'دشت امیرنظام',
        15320: 'کهک',
        15321: 'گوری',
        15322: 'ملک حیدری',
        15323: 'یادگار',
        15324: 'قلعه نو',
        15325: 'واصلان',
        15326: 'خراشادی',
        15327: 'محمدآبادزابل',
        15328: 'مجتمع/علی اکبر',
        15329: 'سه کوهه',
        15330: 'لوتک',
        15331: 'تیمورآباد',
        15332: 'فیروزه ای',
        15333: 'سفیدابه',
        15334: 'ادیمی',
        15335: 'گلخانی',
        15336: 'قائم آباد',
        15337: 'ده پیران',
        15338: 'غلامعلی',
        15339: 'چابهار/منطقه آزاد',
        15340: 'کنارک',
        15341: 'رمین',
        15342: 'طیس',
        15343: 'درگس',
        15344: 'نگور',
        15345: 'نوبندیان',
        15346: 'بریس',
        15347: 'صدیق زهی',
        15348: 'پلان',
        15349: 'پسابندر',
        15350: 'عورکی',
        15351: 'کنارک',
        15352: 'شهرک/کنارک دریائی',
        15353: 'کهیر',
        15354: 'پزم',
        15355: 'بندر/تنگ',
        15356: 'پایگاه هوائی',
        15357: 'زرآباد',
        15358: 'مخت',
        15359: 'نیک شهر',
        15360: 'هیچان',
        15361: 'ملوران',
        15362: 'قصرقند',
        15363: 'ساربوک',
        15364: 'هیت',
        15365: 'حمیری',
        15366: 'راسک',
        15367: 'پیشین',
        15368: 'جکیگور',
        15369: 'هدار',
        15370: 'بافتان',
        15371: 'دهان',
        15372: 'بنت',
        15373: 'ایرانشهر',
        15374: 'آبادان',
        15375: 'دامن',
        15376: 'شهردراز',
        15377: 'ابتر',
        15378: 'قاسم آباد',
        15379: 'بمپور',
        15380: 'محمدآباد',
        15381: 'میرآباد',
        15382: 'نوک جوب',
        15383: 'بزمان/گیمان',
        15384: 'دلگان',
        15385: 'جلگه چاه هاشم',
        15386: 'چاه گیجی',
        15387: 'چاه شور',
        15388: 'اسفند',
        15389: 'چاه علی',
        15390: 'شاردر',
        15391: 'سرباز',
        15392: 'کوه میتک',
        15393: 'آشار',
        15394: 'لهاباد',
        15395: 'حیط',
        15396: 'باتک',
        15397: 'نصیرآباد',
        15398: 'علی آباد',
        15399: 'جنگل',
        15400: 'پارود',
        15401: 'مغ ایتک',
        15402: 'دز',
        15403: 'مینان',
        15404: 'گورناگان',
        15405: 'بابسکان',
        15406: 'کافه بلوچی',
        15407: 'گریکان',
        15408: 'پشامک',
        15409: 'سراوان',
        15410: 'آسپیچ محمدی',
        15411: 'دهک',
        15412: 'گشت',
        15413: 'اسفندک',
        15414: 'جالق',
        15415: 'ناهوک',
        15416: 'کله گان',
        15417: 'سرسوره',
        15418: 'سوران',
        15419: 'سیب سولان',
        15420: 'کنت',
        15421: 'ناصرآباد',
        15422: 'پسکوه',
        15423: 'هیدوچ',
        15424: 'شندان',
        15425: 'سیرکان',
        15426: 'زابلی',
        15427: 'کهن مگار',
        15428: 'گدامدر',
        15429: 'اسپکه',
        15430: 'پیپ',
        15431: 'سیف آباد',
        15432: 'کوپچ',
        15433: 'چانف',
        15434: 'برشک',
        15435: 'فنوج',
        15436: 'مسکوتان',
        15437: 'کتیج',
        15438: 'محترم آباد',
        15439: 'خیرآباد'
    },
    29: {
        11757: 'قم',
        11758: 'شهرک/مهدیه',
        11759: 'شهرک صنعتی/شکوهیه',
        11760: 'شهرک/صنعتی/محمودآباد',
        11761: 'لنگرود',
        11762: 'دام شهر',
        11763: 'جمکران',
        11764: 'حاجی آباد/قنوات',
        11765: 'تاج خاتون',
        11766: 'جنداب',
        11767: 'مبارک آباد',
        11768: 'راهجرد',
        11769: 'قمرود',
        11770: 'جنت آباد',
        11771: 'حسین آباد',
        11772: 'سنجگان',
        11773: 'یکه باغ',
        11774: 'زواریان',
        11775: 'چشمه شور',
        11776: 'ملک قلعه',
        11777: 'کوه سفید',
        11778: 'طایقان',
        11779: 'سلفچگان',
        11780: 'دیزیجان',
        11781: 'شهرک/صنعتی/سلفچگان',
        11782: 'نیزار',
        11783: 'حسن آباد/نیزار',
        11784: 'کهک',
        11785: 'بیدهند',
        11786: 'ونارج',
        11787: 'فردو',
        11788: 'کرمچکان',
        11789: 'وشنوه',
        11790: 'قلعه چم',
        11791: 'صرم/خورآباد',
        11792: 'خدیجه خاتون',
        11793: 'خاوه',
        11794: 'سیرو',
        11795: 'علی آبادنیزار',
        11796: 'ورجان',
        11797: 'میم',
        11798: 'دستجردخلجستان',
        11799: 'چاهک',
        11800: 'کهندان',
        11801: 'موجان',
        11802: 'مهرزمین',
        11803: 'نایه',
        11804: 'نویس',
        11805: 'قاهان',
        11806: 'گیو/عیسی آباد/طینوج',
        11807: 'کندرود',
        11808: 'رستگان',
        11809: 'زیزگان',
        11810: 'وسفونجرد',
        11811: 'سناوند',
        11812: 'اسفید',
        11813: 'جعفرآباد/گازران',
        11814: 'ونارد',
        11815: 'علی آبادانقلاب',
        11816: 'محمودآباد',
        11817: 'پاچیان',
        11818: 'الویرآباد',
        11819: 'دولت آباد/طغرود'
    },
    30: {
        17012: 'کهتوئیه',
        17069: 'بندر عباس',
        17070: 'شهرصنعتی/بندرعباس',
        17071: 'آبشورک',
        17072: 'شهرک/مروارید',
        17073: 'پشته ایسین',
        17074: 'کشتی سازی/صدرا',
        17075: 'تازیان بالا',
        17076: 'ایسین',
        17077: 'تازیان پائین',
        17078: 'چه چکور',
        17079: 'درگیر',
        17080: 'بندر/لنگه',
        17081: 'بندر/حمیران',
        17082: 'بندر/معلم',
        17083: 'گزیر',
        17084: 'دیوان',
        17085: 'چاه مسلم',
        17086: 'بستانه',
        17087: 'بندر/شناس',
        17088: 'مغویه',
        17089: 'بندر/کنگ',
        17090: 'تخت',
        17091: 'سرخون',
        17092: 'شهرو',
        17093: 'قلعه قاضی',
        17094: 'خورگو',
        17095: 'قلات بالا',
        17096: 'دهنوپائین',
        17097: 'پایانه کامیونداران',
        17098: 'شمیل بندر',
        17099: 'چاهستان',
        17100: 'سرخنگی',
        17101: 'کنارو',
        17102: 'بوستانلو',
        17103: 'فین',
        17104: 'سیاهو',
        17105: 'رضوان',
        17106: 'گچین بالا',
        17107: 'سرزه',
        17108: 'قطب آباد',
        17109: 'چاهو',
        17110: 'گهره',
        17111: 'زمین سنگ',
        17112: 'کشکو',
        17113: 'گچین پائین',
        17114: 'بندر/خمیر',
        17115: 'بندر/پل',
        17116: 'روئیدر',
        17117: 'کهورستان',
        17118: 'کشارچمردان',
        17119: 'کشاربالا',
        17120: 'حاجی آباد',
        17121: 'سرگزاحمدی',
        17122: 'شمیل حاجی آباد',
        17123: 'هاشم آباد',
        17124: 'جائین',
        17125: 'طاشکویه',
        17126: 'فارغان',
        17127: 'باغات',
        17128: 'دشت آشکارا',
        17129: 'دهستان',
        17130: 'سرچاهان',
        17131: 'قشم',
        17132: 'درگهان',
        17133: 'جزیره/هرمز',
        17134: 'رمچاه',
        17135: 'رمکان',
        17136: 'گیاهدان',
        17137: 'لافت',
        17138: 'گوران',
        17139: 'کاروان/کوشه',
        17140: 'کوه وای',
        17141: 'طولا',
        17142: 'پی پشت',
        17143: 'شهاب سوزا',
        17144: 'دیرستان',
        17145: 'سهیلی',
        17146: 'طبل',
        17147: 'مسن',
        17148: 'باسعیدو',
        17149: 'دولاب',
        17150: 'صلخ',
        17151: 'لارک',
        17152: 'ابوموسی',
        17153: 'دژگان',
        17154: 'لمزان',
        17155: 'پدل',
        17156: 'کنخ',
        17157: 'بندر/حسینه',
        17158: 'بستک',
        17159: 'جناح',
        17160: 'چاه بنارد',
        17161: 'دهنگ',
        17162: 'فتوئیه',
        17163: 'گورین',
        17164: 'گزه',
        17165: 'کمشک',
        17166: 'کوخرد',
        17167: 'کوهیج',
        17168: 'هنگویه',
        17169: 'هرنگ',
        17170: 'دهتل',
        17171: 'کنارسیاه',
        17172: 'مردنو',
        17173: 'انوه',
        17174: 'بست قلات',
        17175: 'زنگارد',
        17176: 'تدروئیه',
        17177: 'کنچی',
        17178: 'ایلود',
        17179: 'فاریاب کوهیج',
        17180: 'فاریاب سنگوئیه',
        17181: 'کچوئیه',
        17182: 'بیسه',
        17183: 'مغدان/بستک',
        17184: 'داربست',
        17185: 'چیروئیه',
        17186: 'بندر/چارک بندرلنگه',
        17187: 'بندرمقام',
        17188: 'مراغ',
        17189: 'رستاق',
        17190: 'کیش',
        17191: 'لاوان',
        17192: 'گاوبندی',
        17193: 'دشتی',
        17194: 'کوشک کنار',
        17195: 'بوچیر',
        17196: 'برکه دوکا',
        17197: 'عمانی',
        17198: 'به ده',
        17199: 'ستلو',
        17200: 'بستانوبندرلنگه',
        17201: 'مغدان/گاوبندی',
        17202: 'هشنیز',
        17203: 'زیارت',
        17204: 'حمیران گاوبندی',
        17205: 'چهواز',
        17206: 'کناردان',
        17207: 'فارسی اکبری',
        17208: 'میناب',
        17209: 'دهو',
        17210: 'بندزک',
        17211: 'بندر/کلاهی',
        17212: 'کرگان',
        17213: 'کریان',
        17214: 'بندر/تیاب',
        17215: 'حاجی خادمی',
        17216: 'حکمی',
        17217: 'دمشهر',
        17218: 'گوربند',
        17219: 'گورزانک',
        17220: 'تیرور',
        17221: 'نخل ابراهیمی',
        17222: 'چاه اسماعیل',
        17223: 'راونگ',
        17224: 'چراغ آباد',
        17225: 'هشتبندی',
        17226: 'توکهور',
        17227: 'سندرک',
        17228: 'سیریک',
        17229: 'گروک',
        17230: 'کوهستک',
        17231: 'رودان/ده بارز',
        17232: 'جغین',
        17233: 'خراجی',
        17234: 'بیکا',
        17235: 'برنطین',
        17236: 'اسلام آباد',
        17237: 'فاریاب',
        17238: 'قلعه کمیز',
        17239: 'خیرآباد',
        17240: 'زیارتعلی',
        17241: 'بندر/جاسک',
        17242: 'جاسک کهنه',
        17243: 'بشاگرد'
    },
    33: {
        12045: 'قزوین',
        12046: 'الولک',
        12047: 'هفت سنگان',
        12048: 'شفیع آباد/باراجین',
        12049: 'رزجرد',
        12050: 'شهرک/شهید/بهشتی',
        12051: 'عبدل آبادمرکزی',
        12052: 'کورانه',
        12053: 'رشتقون',
        12054: 'چوبین در',
        12055: 'نجف آباد',
        12056: 'ناصرآباد',
        12057: 'شینقر',
        12058: 'اسماعیل آباد',
        12059: 'شهرک صنعتی',
        12060: 'شهرصنعتی/البرز',
        12061: 'رامشان',
        12062: 'محمودآبادنمونه',
        12063: 'پیریوسفیان',
        12064: 'آقابابا',
        12065: 'شترک ماخورین',
        12066: 'بیدستان',
        12067: 'فارسیان',
        12068: 'مشعلدار',
        12069: 'شریف آباد',
        12070: 'پاورس',
        12071: 'ورس',
        12072: 'خرمن سوخته',
        12073: 'نظام آباد',
        12074: 'حسین آباد',
        12075: 'مشکین آباد',
        12076: 'محمودآبادعلمخانی',
        12077: 'قدیم آباد',
        12078: 'کمال آباد',
        12079: 'زیباشهر',
        12080: 'سیردان',
        12081: 'آلتین کش',
        12082: 'عباس آباد',
        12083: 'نیارک',
        12084: 'کلج',
        12085: 'بکندی',
        12086: 'سیاهپوش',
        12087: 'کوهین',
        12088: 'بوئینگ بشر',
        12089: 'اورکن کرد',
        12090: 'کوهگیرعلیا',
        12091: 'صمغ آباد',
        12092: 'آبیک',
        12093: 'زیاران',
        12094: 'خاک علی',
        12095: 'حصارخروان',
        12096: 'قشلاق',
        12097: 'میرپنجی',
        12098: 'حسن آباد/کلج',
        12099: 'زرجه بستان',
        12100: 'کوندج',
        12101: 'آمادگاه آبیک',
        12102: 'چناسک',
        12103: 'عبدل آباد',
        12104: 'خرم پشته',
        12105: 'نودوز',
        12106: 'خطایان',
        12107: 'حاجی تپه',
        12108: 'رازمیان',
        12109: 'رجائی دشت',
        12110: 'هیر',
        12111: 'اکوجان/وشته',
        12112: 'معلم کلایه',
        12113: 'آوان',
        12114: 'زواردشت/زرآباد',
        12115: 'گرمارود',
        12116: 'مسعودآباد',
        12117: 'دیکین',
        12118: 'دستجردعلیا',
        12119: 'بوئین زهرا',
        12120: 'امیرآباد/کهنه',
        12121: 'قلعه هاشم خان',
        12122: 'خرم آباد',
        12123: 'طزرک',
        12124: 'آراسنج',
        12125: 'سگزآباد',
        12126: 'شاهین تپه',
        12127: 'رودک',
        12128: 'سعیدآباد',
        12129: 'شال',
        12130: 'عصمت آباد',
        12131: 'ارداق',
        12132: 'رحمت آباد',
        12133: 'مجتمع/لیا',
        12134: 'لوشکان',
        12135: 'اسفرورین',
        12136: 'ابراهیم آباد',
        12137: 'خونان',
        12138: 'قشلاق چرخلو',
        12139: 'خوزنین',
        12140: 'دانسفهان',
        12141: 'حسین آباد/بوئین زهرا',
        12142: 'امیرآبادنو',
        12143: 'خیارج',
        12144: 'شهرستانک',
        12145: 'ولازجرد',
        12146: 'زین آباد',
        12147: 'آوج',
        12148: 'اسماعیل آباد/بوئین زهرا',
        12149: 'شهیدآباد',
        12150: 'کلنجین',
        12151: 'نصرت آباد',
        12152: 'آبگرم',
        12153: 'کامیشگان',
        12154: 'نیارج',
        12155: 'علی آباد',
        12156: 'اردلان',
        12157: 'ارتش آباد',
        12158: 'چنگوره',
        12159: 'حصارولیعصر',
        12160: 'دشتک',
        12161: 'پارسپانج',
        12162: 'استلج',
        12163: 'هرائین علیا',
        12164: 'چسکین',
        12165: 'اروان',
        12166: 'تاکستان',
        12167: 'آک',
        12168: 'نرجه',
        12169: 'شیداصفهان',
        12170: 'یحیی آباد',
        12171: 'خورهشت',
        12172: 'دیال آباد',
        12173: 'کهک',
        12174: 'شامی شاپ',
        12175: 'اسلام آباد/اقبالیه',
        12176: 'نیکوئیه',
        12177: 'کنشکین',
        12178: 'مهدی آباد',
        12179: 'قمیک بزرگ',
        12180: 'انداق',
        12181: 'داغلان',
        12182: 'دستجردتاکستان',
        12183: 'قرقسین',
        12184: 'دولت آباد',
        12185: 'کندر',
        12186: 'ضیاآباد',
        12187: 'حیدریه',
        12188: 'پناه آباد',
        12189: 'داکان/رادکان',
        12190: 'ساج',
        12191: 'نهاوند',
        12192: 'فارسجین',
        12193: 'قاسم آباد',
        12194: 'شنستق علیا',
        12195: 'حسن آباد/سادات',
        12196: 'برزلجین',
        12197: 'شیزند',
        12198: 'چوزه',
        12199: 'اورنه',
        12200: 'رحیم آباد/تاکستان',
        12201: 'سولیقان',
        12202: 'اسپیک',
        12203: 'خاتون آباد',
        12204: 'شارد',
        12205: 'رحیم آباد/بوئین زهرا',
        12206: 'محمدآبادخررود',
        12207: 'صدرآباد',
        12208: 'ولدآباد',
        12209: 'فیض آباد',
        12210: 'شهرک صنعتی/آراسنج',
        12211: 'پریجان',
        12212: 'فتح آباد',
        12213: 'مندرآباد',
        12214: 'شادمیان',
        12215: 'کوچار',
        12216: 'قشلاق مرانلو',
        12217: 'وثوق آباد',
        12218: 'طزرکش',
        12219: 'دیزج',
        12220: 'همت آباد',
        12221: 'یانس آباد'
    },
    35: {
        10369: 'بابل',
        10370: 'بائیکلا/شهیدآباد',
        10371: 'کمانگربرسمنان',
        10372: 'اسبوکلا',
        10373: 'میررودپشت',
        10374: 'درزیکلاآخوندی',
        10375: 'گنج افروز',
        10376: 'هریکنده',
        10377: 'روشن آباد',
        10378: 'چاری',
        10379: 'اندیکلا',
        10380: 'اسب شورپی',
        10381: 'زرگرمحله/آرادکلا',
        10382: 'دیودشت',
        10383: 'امین آباد',
        10384: 'ورمتون',
        10385: 'خشرودپی',
        10386: 'دیوا',
        10387: 'گلوگاه بندپی',
        10388: 'زوارده',
        10389: 'آری',
        10390: 'پوست کلا',
        10391: 'ابوالحسن کلا',
        10392: 'بیشه سر',
        10393: 'رمنت',
        10394: 'بولی کلا/درویش خیل',
        10395: 'موزیکله',
        10396: 'سلطان محمدطاهر',
        10397: 'پیچاکلا',
        10398: 'آغوزبن بابل',
        10399: 'فولادکلابابل',
        10400: 'گاوان کلا/سیدکلا',
        10401: 'درونکلای غربی',
        10402: 'درونکلای شرقی',
        10403: 'شوبکلا/معلم کلا',
        10404: 'درزی کلا/کریم کلا',
        10405: 'کاظم بیگی',
        10406: 'گتاب',
        10407: 'دونه سر',
        10408: 'کرکنار',
        10409: 'بالامیرکلا',
        10410: 'کشتله',
        10411: 'هلیدشت',
        10412: 'عزیزک',
        10413: 'ولوکلا',
        10414: 'مرزیکلا/بابل کنار',
        10415: 'اله رودبار',
        10416: 'بالابازیار',
        10417: 'آهنگرکلا',
        10418: 'درازکلا',
        10419: 'اله شاه/علی آباد',
        10420: 'نوشیروانکلا',
        10421: 'بالااحمدچاله پی',
        10422: 'پایین احمدچاله پی',
        10423: 'کلاگرمحله',
        10424: 'کاردرکلا',
        10425: 'انجیلسی',
        10426: 'بابلسر/دریاکنار/باقرتنگه',
        10427: 'عرب خیل',
        10428: 'بهنمیر',
        10429: 'بابل پشت',
        10430: 'رودبست',
        10431: 'خشکرود',
        10432: 'ولیکرودپشت',
        10433: 'کرفون',
        10434: 'کله بست',
        10435: 'فریدون کنار',
        10436: 'نوائی محله',
        10437: 'سوته/فریدون کنار',
        10438: 'ازباران',
        10439: 'کاردگرمحله بابل',
        10440: 'طوله سرا',
        10441: 'فریم',
        10442: 'زاهدکلا',
        10443: 'تنکابن',
        10444: 'آمل',
        10445: 'میخران',
        10446: 'شهرک صنعتی/آمل',
        10447: 'قلعه کش',
        10448: 'سائیچ محله',
        10449: 'سنگچال',
        10450: 'محمدآباد',
        10451: 'اسکومحله/امامزاده عبداله',
        10452: 'سورک آمل',
        10453: 'مریج محله',
        10454: 'رئیس آباد',
        10455: 'رودبار/اورطشت',
        10456: 'اوجاک',
        10457: 'شهنه کلا',
        10458: 'تمسک/سرخکلا',
        10459: 'دنگ پیا',
        10460: 'رزکه',
        10461: 'حسین آباد/لیتکو',
        10462: 'کوکده',
        10463: 'فیروزکلاآمل',
        10464: 'عالیکلاآهی',
        10465: 'بانصرکلا',
        10466: 'شاه کتی',
        10467: 'وسطی کلاآمل',
        10468: 'اجوارکلا',
        10469: 'پاشاکلاآمل',
        10470: 'کلیکسر',
        10471: 'اوجی آباد',
        10472: 'هشتل',
        10473: 'کمانگرکلا',
        10474: 'ورکاده',
        10475: 'نشل',
        10476: 'آهنگرکلا/شهدای/دابو/مرزنگو',
        10477: 'اندوار',
        10478: 'قائمیه',
        10479: 'آب اسک',
        10480: 'پلور',
        10481: 'رینه لاریجان',
        10482: 'گزنک',
        10483: 'نوا',
        10484: 'بایجان',
        10485: 'نیاک',
        10486: 'دینان',
        10487: 'آبگرم',
        10488: 'شاندشت/شنگلده/وانا',
        10489: 'ایرا',
        10490: 'ناندل',
        10491: 'سوا',
        10492: 'نمار',
        10493: 'شیخ محله',
        10494: 'نوسر',
        10495: 'پنجاب',
        10496: 'پردمه',
        10497: 'لاسم',
        10498: 'بلده',
        10499: 'اوزکلا',
        10500: 'ناحیه',
        10501: 'چل',
        10502: 'یوش',
        10503: 'یالرود',
        10504: 'تاکر',
        10505: 'میناک',
        10506: 'کمربن',
        10507: 'کمرود',
        10508: 'نسن',
        10509: 'ورازان',
        10510: 'نج',
        10511: 'دونا',
        10512: 'رزن',
        10513: 'مزید',
        10514: 'کرسی',
        10515: 'خجیرکلا',
        10516: 'بطاهرکلا',
        10517: 'ایل وکلا',
        10518: 'چمستان',
        10519: 'جوربند',
        10520: 'آهودشت',
        10521: 'بنفشه ده',
        10522: 'شیرکلا',
        10523: 'سعادت آباد',
        10524: 'لاویج',
        10525: 'علی آباد/آمل',
        10526: 'اناده',
        10527: 'نانواکلا',
        10528: 'دارکلا',
        10529: 'جلیکان علیا',
        10530: 'نور/علمده',
        10531: 'رستم رود/ایزدشهر/آکامشهر',
        10532: 'رویان',
        10533: 'سلیاکتی',
        10534: 'کاردگرمحله آمل',
        10535: 'چالیسیو',
        10536: 'رستم رود/ایزدشهر/آکامشهرمخابراتی',
        10537: 'واز',
        10538: 'دونکوه',
        10539: 'گلندرود',
        10540: 'حسن آباد',
        10541: 'پیمود',
        10542: 'آهی محله',
        10543: 'خشت سر',
        10544: 'سرخرود',
        10545: 'کلوده',
        10546: 'بیشه کلا',
        10547: 'خانه دریا',
        10548: 'اهلم/آزادمون',
        10549: 'کله مرز/رودپشت',
        10550: 'گله محله سیرجارون',
        10551: 'معلم کلا',
        10552: 'عبداله آباد',
        10553: 'اسکنده/وازیک',
        10554: 'حاجی کلابزرگ',
        10555: 'احمدآباد/کلیج',
        10556: 'یمچی متوریج',
        10557: 'کنس مرز',
        10558: 'بائوده سفلی',
        10559: 'شومیا',
        10560: 'برجنده/شرفتی',
        10561: 'محمودآباد',
        10562: 'محمود آباد',
        10563: 'گالشپل',
        10564: 'قائم شهر',
        10565: 'قراخیل',
        10566: 'خرماکلا',
        10567: 'خطیرکلا/باغدشت',
        10568: 'چفته کلا',
        10569: 'ملک خیل',
        10570: 'طارسی کلا',
        10571: 'رکابدارکلا',
        10572: 'المشیر',
        10573: 'ابوخیل ارطه',
        10574: 'دوک/زیلت',
        10575: 'قادیکلای بزرگ',
        10576: 'وسطی کلاقائم شهر',
        10577: 'دیوکلا',
        10578: 'ریکنده',
        10579: 'سیدابوصالح',
        10580: 'سوادکوه',
        10581: 'شیرخوارکلا',
        10582: 'سنگتاب',
        10583: 'جویبار',
        10584: 'دونه چال',
        10585: 'سروکلا',
        10586: 'لاریم',
        10587: 'انارمرز',
        10588: 'کیاکلا',
        10589: 'رکن کلا',
        10590: 'شورکا',
        10591: 'آیت محله',
        10592: 'پهناب',
        10593: 'کردکلا/کوهی خیل',
        10594: 'میانده',
        10595: 'بیزکی',
        10596: 'مشک آباد',
        10597: 'شیرگاه',
        10598: 'کتی لته',
        10599: 'کلیج خیل',
        10600: 'بشل/چاکسر',
        10601: 'ایوک/بورخیل',
        10602: 'لاجیم',
        10603: 'رئیس کلا',
        10604: 'شارقلت',
        10605: 'عالمکلا',
        10606: 'بورخانی',
        10607: 'پل سفید',
        10608: 'ورسک',
        10609: 'فلورد',
        10610: 'آلاشت',
        10611: 'ارات بن',
        10612: 'زیراب',
        10613: 'کارمزد',
        10614: 'پاشاکلاکسلیان',
        10615: 'لله بند',
        10616: 'لیند',
        10617: 'اتو',
        10881: 'ساری',
        10882: 'سرخکلا/شهرک/فرهنگیان',
        10883: 'فیروزکنده',
        10884: 'خرم آباد',
        10885: 'عیسی خندق',
        10886: 'اسلام آباد',
        10887: 'اسرم/جامخانه',
        10888: 'بادله',
        10889: 'طبقده',
        10890: 'ولوجا',
        10891: 'زیدسفلی',
        10892: 'بزمین آباد',
        10893: 'تازه آباد/سپاه',
        10894: 'برگه',
        10895: 'ماکران',
        10896: 'ورکلا/ورندان',
        10897: 'سوربن/برارده',
        10898: 'عزت الدین',
        10899: 'شرفدارکلا',
        10900: 'گلما',
        10901: 'پاشاکلاساری',
        10902: 'دامیر/دینک',
        10903: 'اسبوکلا/ولاشد',
        10904: 'سیدمحله',
        10905: 'خارکش',
        10906: 'امره',
        10907: 'خزرآباد',
        10908: 'طوقدار',
        10909: 'صفرخیل/میارکلا',
        10910: 'آکند/پنبه زارکتی',
        10911: 'پهنه کلا',
        10912: 'حمیدآباد',
        10913: 'اوجامحله',
        10914: 'دازمیرکنده',
        10915: 'هولار',
        10916: 'زرین آباد',
        10917: 'تیرکلا/ماچک پشت',
        10918: 'دنگ سرک',
        10919: 'تنگه لته',
        10920: 'خانه سرمرز',
        10921: 'مرمت',
        10922: 'پنبه چوله',
        10923: 'سمسکنده',
        10924: 'ولشکلا',
        10925: 'سنگ تراشان',
        10926: 'ماهفروجک',
        10927: 'گیله کلا/باریک آبسر',
        10928: 'صاحبی',
        10929: 'دارابکلا',
        10930: 'قرتیکلا',
        10931: 'ماهفروزمحله',
        10932: 'شهرک/صنعتی/ساری',
        10933: 'پائین کلا',
        10934: 'کارکنده',
        10935: 'اجارستاق',
        10936: 'سرکت',
        10937: 'صنایع/چوب/کاغذساری',
        10938: 'سورک ساری',
        10939: 'اومال/بریجان',
        10940: 'قلعه سر',
        10941: 'سوچلما',
        10942: 'استخرپشت',
        10943: 'بهشهر',
        10944: 'قره تپه',
        10945: 'نوذرآباد',
        10946: 'زاغمرز',
        10947: 'رستم کلا',
        10948: 'حسین آباد/لله مرز',
        10949: 'کوهستان/آسیابسر',
        10950: 'امیرآباد',
        10951: 'بندر/امیرآباد',
        10952: 'عسگرآباد',
        10953: 'کشتی سازی/ایران صدرا',
        10954: 'شهرک صنعتی/بهشهر',
        10955: 'امام/ده',
        10956: 'نکا',
        10957: 'اطرب/بهزادکلا',
        10958: 'خورشید',
        10959: 'کمیشان',
        10960: 'طوسکلا/سیاوشکلا',
        10961: 'زرندین',
        10962: 'میانگله/چناربن',
        10963: 'کلت',
        10964: 'کوهسارکنده',
        10965: 'بایع کلا',
        10966: 'تازه آباد',
        10967: 'چمان',
        10968: 'چلمردی',
        10969: 'آلوکنده/حاجی محله',
        10970: 'زیارت کلا',
        10971: 'پوروا',
        10972: 'سه کیله',
        10973: 'فریمک',
        10974: 'گلوگاه ساری',
        10975: 'تیله نو',
        10976: 'خلیل محله',
        10977: 'مهدی رجه',
        10978: 'ریحان آباد/ولمازو',
        10979: 'لمراسک/تیرتاش/سراج محله',
        10980: 'قلعه پایان',
        10981: 'ساروپسند',
        10982: 'بیشه بنه',
        10983: 'یخکش',
        10984: 'کلا',
        10985: 'پرکلا',
        10986: 'پیته نو',
        10987: 'ارضت',
        10988: 'نیالا',
        10989: 'غریب محله',
        10990: 'متکازین',
        10991: 'اوارد',
        10992: 'سرخ کریه',
        10993: 'پاوند',
        10994: 'کیاسرچهاردانگه',
        10995: 'اورست/مالخواست',
        10996: 'لالا',
        10997: 'کنیم',
        10998: 'خال خیل',
        10999: 'قادیکلاچهاردانگه',
        11000: 'چورت',
        11001: 'برما',
        11002: 'آغوزگله',
        11003: 'سعیدآباد',
        11004: 'تلمادره',
        11005: 'لنگر',
        11006: 'کلاگرده',
        11007: 'ایول',
        11008: 'وری',
        11009: 'ازنی',
        11010: 'محمدآباددودانگه',
        11011: 'سنگده',
        11012: 'سوتکلا/دادکلا',
        11013: 'پاجی/میانا',
        11014: 'علی آباد/ساری',
        11015: 'کرسب/مسکوپا',
        11016: 'تلوک',
        11017: 'مرگاو',
        11018: 'رسکت',
        11019: 'پاشاکلادودانگه',
        11020: 'سیاهدشت',
        11267: 'بندر',
        11349: 'چالوس',
        11350: 'کشکسرا',
        11351: 'پل کرات',
        11352: 'هچیرود/هرطه کلا',
        11353: 'شهرک/نمک آبرود',
        11354: 'چالوس',
        11355: 'کلارستاق',
        11356: 'علی آباد/عسگرخان',
        11357: 'خیرود/مزگاه',
        11358: 'چلندر',
        11359: 'خیرودکنار/سیدعلی کیا',
        11360: 'صلاح الدین کلا/ونوش',
        11361: 'کورکورسر',
        11362: 'نوشهر',
        11363: 'لتینگان',
        11364: 'خیره سر',
        11365: 'فیروزکلاچالوس',
        11366: 'صالحان',
        11367: 'پول',
        11368: 'میخساز/کندلوس',
        11369: 'لشکنار',
        11370: 'نیم ور',
        11371: 'لاشک',
        11372: 'لرگان',
        11373: 'کجور',
        11374: 'نیچکوه',
        11375: 'کوهپر',
        11376: 'نیرس',
        11377: 'سما',
        11378: 'حیرت',
        11379: 'علویکلا',
        11380: 'عزت/منوچهرکلا',
        11381: 'دلسم/ویسر',
        11382: 'کلاردشت',
        11383: 'پی قلعه',
        11384: 'سرکا',
        11385: 'مرزن آباد',
        11386: 'پیشنبور',
        11387: 'کردیچال',
        11388: 'گویتر',
        11389: 'کله نو',
        11390: 'پردنگون',
        11391: 'سنارسفلی',
        11392: 'حریث',
        11393: 'تنکابن/خرم آباد',
        11394: 'کشکوه',
        11395: 'گاوبر',
        11396: 'برسه',
        11397: 'نعمت آباد',
        11398: 'امامزاده/قاسم',
        11399: 'قلعه گردن',
        11400: 'عظیمیه چالکش',
        11401: 'لتاک',
        11402: 'شیرود',
        11403: 'ولی آباد',
        11404: 'سلیمان آباد',
        11405: 'لشتو/لزربن',
        11406: 'دینارسرا',
        11407: 'گل علی آباد',
        11408: 'گلیجان',
        11409: 'ایثارده',
        11410: 'جلیل آباد/کراتچال',
        11411: 'عباس آباد',
        11412: 'نشتارود',
        11413: 'دراسرا',
        11414: 'کترا',
        11415: 'کاظم کلا',
        11416: 'اسب چین',
        11417: 'رودگر/پل سرا',
        11418: 'فقیه آباد',
        11419: 'سفیداب',
        11420: 'سلمان شهر',
        11421: 'کلارآباد',
        11422: 'شهرک صنعتی/دانیال',
        11423: 'ولیکستان',
        11424: 'رامسر',
        11425: 'جواهرده',
        11426: 'جنت رودبار',
        11427: 'سفیدتمشک',
        11428: 'چالکرود',
        11429: 'گلین/چی لی لی سر',
        11430: 'تمل',
        11431: 'اکراسر',
        11432: 'سرلیماک',
        11433: 'گرسماسر',
        11434: 'سلمل',
        11435: 'چرته',
        11436: 'لیماک',
        18535: 'برنت',
        18542: 'نور',
        18543: 'بابلسر'
    },
    36: {
        15813: 'کوشکی/جوشقان',
        15814: 'سست',
        15815: 'برج/بزنج',
        15816: 'اسفراین',
        15817: 'روئین',
        15818: 'خوشین',
        15819: 'کلات',
        15820: 'توی',
        15821: 'ایرج',
        15823: 'چهاربرج',
        15824: 'محمودی',
        15825: 'خالدآباد',
        15826: 'گراتی',
        15827: 'صفی آباد',
        15828: 'بام',
        15829: 'دهنه اجاق',
        15830: 'نوده بام',
        15831: 'دهنه شیرین',
        15833: 'الست علیا',
        15834: 'قنبرباغی',
        15835: 'دستجرد',
        15836: 'اسپید',
        15837: 'جهان',
        15840: 'دارین',
        15935: 'بجنورد',
        15936: 'ینگه قلعه بجنورد',
        15937: 'اله وردیخان',
        15938: 'باباامان',
        15939: 'رئین',
        15940: 'دهگاه',
        15941: 'بوربور',
        15942: 'قره خانبندی',
        15943: 'درغانلو',
        15944: 'حصارحسینی/حصارشاهوردیخان',
        15945: 'بیدک',
        15946: 'بدرانلو',
        15947: 'درتوم',
        15948: 'علی آباد',
        15949: 'مهنان',
        15950: 'ارکان',
        15951: 'قراجه',
        15952: 'کچرانلو',
        15953: 'باغچق',
        15954: 'تاتار',
        15955: 'گلی',
        15956: 'رختیان',
        15957: 'لنگر',
        15958: 'گریوان',
        15959: 'اسفیدان',
        15960: 'چناران',
        15961: 'حصار/گرمخان',
        15962: 'نوده چناران',
        15963: 'قتلیش',
        15964: 'سلولی',
        15965: 'سرچشمه/هانوزی',
        15966: 'ناوه/قزلقان',
        15967: 'طراقی ترک',
        15968: 'جمی',
        15969: 'جاجرم',
        15970: 'گرمه',
        15971: 'شوقان',
        15972: 'طبر',
        15973: 'درق',
        15974: 'کرف',
        15975: 'دشت جاجرم',
        15976: 'سنخواست',
        15977: 'جربت',
        15978: 'چشمه خان',
        15979: 'ایور',
        15980: 'خراشاه',
        15981: 'چهاربید',
        15982: 'رباط قره بیل',
        15983: 'امیرآباد',
        15984: 'قلی',
        15985: 'آشخانه',
        15986: 'مهمانک',
        15987: 'قاضی',
        15988: 'محمدآبادشوقان',
        15989: 'پیش قلعه',
        15990: 'زرد',
        15991: 'رسالت',
        15992: 'خرم دره',
        15993: 'چمن بید',
        15994: 'کشانک',
        15995: 'لنگر/عزیزآباد',
        15996: 'نجف',
        15997: 'بازارقارناس',
        15998: 'اسلام آباد/بجنورد',
        15999: 'شهرآبادکرد',
        16000: 'چخماقلو',
        16001: 'کریک',
        16002: 'اینچه سفلی',
        16003: 'بهکده رضوی',
        16004: 'عشق آباد',
        16005: 'شهرآبادنیروی هوائی',
        16006: 'کلانتر/کیکانلو',
        16007: 'آمند/قره قانلو',
        16008: 'کوشکی کیکانلو',
        16009: 'کشک آباد',
        16010: 'کاستان',
        16011: 'استاد',
        16012: 'زمان صوفی',
        16013: 'درکش',
        16014: 'اینچه علیا',
        16015: 'قزلر',
        16016: 'کلاته چنار',
        16017: 'کوشکی ترکمن',
        16018: 'دشتک علیا',
        16019: 'کهنه جلگه',
        16020: 'حیدرآباد',
        16021: 'حسن سو',
        16022: 'شورسو',
        16023: 'خرتوت',
        16024: 'گرماب',
        16025: 'اسپاخو',
        16026: 'راز',
        16027: 'غلامان',
        16028: 'گیفان',
        16029: 'یکه سعودعلیا/سفلی',
        16030: 'راستقان',
        16031: 'تازه قلعه',
        16032: 'داشلی قلعه',
        16033: 'دویدوخ علیا',
        16034: 'سوخسوهاشم',
        16035: 'تنگه ترکمن',
        16036: 'پشینده',
        16037: 'باغلق',
        16038: 'بک پولاد',
        16039: 'پرسه سوعلیا/سفلی',
        16040: 'تکله قوز',
        16041: 'شیروان',
        16042: 'زوارم',
        16043: 'دوین بجنورد',
        16044: 'تنسوان',
        16045: 'زیارت/حسین آباد',
        16046: 'اسلام آباد/شیروان',
        16047: 'اله آباد',
        16048: 'پیرشهید',
        16049: 'اسطرخی',
        16050: 'شهرک/امام/رضا',
        16051: 'شهرک/امام/سجاد',
        16052: 'گلیان/حصارپهلوانلو',
        16053: 'برزل آباد/رضاآباد',
        16054: 'باغان',
        16055: 'فجرآباد',
        16056: 'توده',
        16057: 'لوجلی',
        16058: 'ینگه قلعه شیروان',
        16059: 'کوسه/الخالص',
        16060: 'بیگان',
        16061: 'سنجد',
        16062: 'قلعه حسن',
        16063: 'نامانلو',
        16064: 'سولدی',
        16065: 'برزلان علیا',
        16066: 'رباط',
        16067: 'فاروج',
        16068: 'گزکوه',
        16069: 'کوران ترکیه',
        16070: 'چری',
        16071: 'کواکی',
        16072: 'مردکانلو',
        16073: 'باش محله',
        16074: 'ینگه قلعه فاروج',
        16075: 'قره چشمه',
        16076: 'خرق',
        16077: 'مایوان',
        16078: 'یام',
        16079: 'نجف آباد',
        16080: 'جعفرآباد',
        16081: 'تیتکانلو',
        16219: 'ماهوربرنجی'
    },
    37: {
        15538: 'بیرجند',
        15539: 'نوفرست',
        15540: 'شاخن',
        15541: 'گازار',
        15542: 'بویک',
        15543: 'مهموئی',
        15544: 'آسو',
        15545: 'مزداب',
        15546: 'فلارگ',
        15547: 'چاچ',
        15548: 'خنگ',
        15549: 'نقنج',
        15550: 'اوجان',
        15551: 'سورگ',
        15552: 'بهدان',
        15553: 'واشان',
        15554: 'شهرک/صنعتی/بیرجند',
        15555: 'سرچاه تازیان',
        15556: 'نوده',
        15557: 'بجد',
        15558: 'ساقدر',
        15559: 'بیدخت',
        15560: 'شوشود',
        15561: 'مولید',
        15562: 'مرک',
        15563: 'خراشاد',
        15564: 'ساقی',
        15565: 'گوکچین',
        15566: 'افضل آباد',
        15567: 'میریک',
        15568: 'مود',
        15569: 'خونیکسار',
        15570: 'شیرگ ججک',
        15571: 'مختاران',
        15572: 'گز',
        15573: 'رزق',
        15574: 'فنود',
        15575: 'حاجی آباد/مود',
        15576: 'هریوند',
        15577: 'گسک',
        15578: 'اسدیه',
        15579: 'درخش',
        15580: 'درمیان',
        15581: 'طبس مسینا',
        15582: 'فیض آباد',
        15583: 'گزیک',
        15584: 'نوغاب بیرجند',
        15585: 'نوزاد',
        15586: 'دستگرد',
        15587: 'نگینان',
        15588: 'تخته جان',
        15589: 'آسفیچ',
        15590: 'کوشکک',
        15591: 'گیت',
        15592: 'فورخاص',
        15593: 'فورگ',
        15594: 'بورنگ',
        15595: 'آواز',
        15596: 'مسک',
        15597: 'هندوالان',
        15598: 'خوان',
        15599: 'آنیک نوغاب',
        15600: 'براندود',
        15601: 'بیدسک منند',
        15602: 'نصرالدین',
        15603: 'سربیشه',
        15604: 'چنشت',
        15605: 'بیژائم',
        15606: 'درح',
        15607: 'لانو',
        15608: 'مشوکی',
        15609: 'نازدشت',
        15610: 'پخت',
        15611: 'گیو',
        15612: 'زیدر',
        15613: 'خوسف',
        15614: 'تقاب/معصوم آباد',
        15615: 'سیوجان',
        15616: 'گل',
        15617: 'شهرستانک/عیلکی',
        15618: 'فدشک',
        15619: 'خور',
        15620: 'ماژان',
        15621: 'معدن قلعه زری',
        15622: 'بصیران',
        15623: 'قائن',
        15624: 'روم',
        15625: 'برکوک',
        15626: 'عباس آباددشت',
        15627: 'بسکاباد',
        15628: 'ورزگ',
        15629: 'زول',
        15630: 'قومنجان',
        15631: 'چاهک موسویه',
        15632: 'سده بیرجند',
        15633: 'خضری',
        15634: 'نوغاب حاجی آباد',
        15635: 'پهنائی',
        15636: 'اسلام آباد',
        15637: 'کلاته نصیر',
        15638: 'بیهود',
        15639: 'کروه',
        15640: 'باراز/کلاته سعید',
        15641: 'محمدآبادعلم',
        15642: 'دهشک',
        15643: 'اسفشاد',
        15644: 'خشک',
        15645: 'شهرک/قدس',
        15646: 'آفریز',
        15647: 'نیگ',
        15648: 'کرغند',
        15649: 'زهان',
        15650: 'فخران',
        15651: 'افین',
        15652: 'بیناباج',
        15653: 'تیغدر',
        15654: 'تیغاب',
        15655: 'شهرک/هاشمیه',
        15656: 'نوغاب پسکوه',
        15657: 'کبودان',
        15658: 'شیرگ سارجین',
        15659: 'پیش بر',
        15660: 'بزن آباد',
        15661: 'گرماب',
        15662: 'گریمنج',
        15663: 'آبیز',
        15664: 'حاجی آباد/زیرکوه',
        15665: 'شاهرخت',
        15666: 'اسفدن',
        15667: 'بمرود',
        15668: 'فندخت',
        15669: 'اسفاد',
        15670: 'بهمن آباد',
        15671: 'استند',
        15672: 'اردکول',
        15673: 'بارنجگان',
        15674: 'نهبندان',
        15675: 'خونیک سفلی',
        15676: 'چاه داشی',
        15677: 'خوان شرف',
        15678: 'کلاته سیدعلی',
        15679: 'بیچند',
        15680: 'طبسین',
        15681: 'چاهشند',
        15682: 'چاه حسن سموری',
        15683: 'چاه عباس اردنی',
        15684: 'بندان',
        15685: 'اسدآباد',
        15686: 'میغان',
        15687: 'سیدال',
        15688: 'دهنو',
        15689: 'رومه',
        15690: 'چهارفرسخ',
        15691: 'شوسف',
        15692: 'دهک',
        15693: 'جوان',
        15694: 'طارق',
        15695: 'چاه دراز',
        15696: 'سهل آباد',
        15697: 'سرایان',
        15698: 'آیسک',
        15699: 'سه قلعه',
        15700: 'مصعبی',
        15701: 'چرمه',
        15702: 'بغداده',
        15703: 'بسطاق',
        15704: 'کریمو',
        15705: 'دوحصاران',
        15706: 'دوست آباد',
        15707: 'زنگوئی'
    },
    38: {
        16284: 'خرم آباد',
        16285: 'بروجرد',
        16286: 'جهان آباد',
        16287: 'خایان',
        16288: 'ده کرد',
        16289: 'فیال',
        16290: 'والانجرد',
        16291: 'دهنومقدسی',
        16292: 'همت آباد',
        16293: 'فلک الدین',
        16294: 'پادگان/مهندسی',
        16295: 'شیروان',
        16296: 'کیدان',
        16297: 'کیجالی سفلی',
        16298: 'طنجور',
        16299: 'زرشکه',
        16300: 'دره صیدی',
        16301: 'گوشه محسن ابن علی',
        16302: 'تلوری سفلی',
        16303: 'بدرآباد',
        16304: 'دارائی',
        16305: 'کهریز/کمالوند',
        16306: 'رباط نمکی',
        16307: 'پل باباحسین',
        16308: 'سراب چنگائی',
        16309: 'ایمان آباد',
        16310: 'تجره گله دار',
        16311: 'سراب ناوه کش',
        16312: 'پیرجد',
        16313: 'ویسیان',
        16314: 'شوراب سفلی',
        16315: 'زاغه',
        16316: 'رازان',
        16317: 'چغلوندی',
        16318: 'پلدختر',
        16319: 'هلوش',
        16320: 'پاعلم',
        16321: 'مورانی',
        16322: 'سرنجه زیودار',
        16323: 'افرینه',
        16324: 'معمولان خرم آباد',
        16325: 'سراب حمام',
        16326: 'چم مهر',
        16327: 'شهرک/ولیعصر',
        16328: 'بابازید',
        16329: 'جلگه خلج',
        16330: 'واشیان/چشمه شیرین',
        16331: 'تنگ فنی',
        16332: 'بن لار',
        16333: 'زورآنتل',
        16334: 'جلوگیر',
        16335: 'میدان بزرگ',
        16336: 'سپیددشت',
        16337: 'الشتر/سلسله',
        16338: 'اصلانشاهی',
        16339: 'فیروزآباد',
        16340: 'ده حسنعلی',
        16341: 'سیاهپوش',
        16342: 'دکاموند',
        16343: 'ده رحم',
        16344: 'مومن آبادخرم آباد',
        16345: 'تمیله',
        16346: 'شیخ آباد',
        16347: 'سراب چنار',
        16348: 'علی آباد/جوانمرد',
        16349: 'سراب دوره',
        16350: 'ملک آبادسماق',
        16351: 'تشکن',
        16352: 'خاطره فرج',
        16353: 'کوهدشت',
        16354: 'چناردمچهر',
        16355: 'خوشناموند',
        16356: 'اشتره گل گل',
        16357: 'اولادقباد',
        16358: 'پشت باغ ضرونی',
        16359: 'داوودرشیدخان',
        16360: 'چغابل/رومشکان',
        16361: 'رومیانی',
        16362: 'قاطرچی',
        16363: 'بازوند',
        16364: 'کهریزگیژیان',
        16365: 'پشت تنگ سیاب',
        16366: 'درب گنبد',
        16367: 'کونانی',
        16368: 'وحدت شهر/باباگردعلی',
        16369: 'زیرسنگ سیاب/گرخوشاب',
        16370: 'بلوران',
        16371: 'چغابیت',
        16372: 'شرشره',
        16373: 'نورآباد/دلفان',
        16374: 'شهرک/امام خمینی',
        16375: 'برخوردار',
        16376: 'کفراج',
        16377: 'هفت چشمه',
        16378: 'حسن آباد/سنجابی',
        16379: 'فرهادآباد',
        16380: 'ایرانشاه',
        16381: 'دمباغ',
        16382: 'گلام بحری',
        16383: 'ده کبودچواری',
        16384: 'گل باغی',
        16385: 'مرادآباد/حسن آبادمیربک',
        16386: 'سرخانجوب',
        16387: 'الیگودرز',
        16388: 'اشترینان',
        16389: 'دره گرگ',
        16390: 'توده زن',
        16391: 'جعفرآباد',
        16392: 'ونائی',
        16393: 'کفشگران',
        16394: 'قائدطاهر',
        16395: 'گلچهران/ملیجان',
        16396: 'دهریز',
        16397: 'چهاربره',
        16398: 'کرکیخان',
        16399: 'بندیزه',
        16400: 'ده ترکان',
        16401: 'درود',
        16402: 'خسروآباد',
        16403: 'ناصرالدین',
        16404: 'ترشاب',
        16405: 'ژان',
        16406: 'چغابدار',
        16407: 'سندرکان',
        16408: 'صنایع دفاع/دورود',
        16409: 'بهرام آباد',
        16410: 'چالان چولان',
        16411: 'بیاتان',
        16412: 'کاغه/عالم آباد',
        16413: 'امام/آباد',
        16414: 'پهلوانکل',
        16415: 'مروک',
        16416: 'احمدآباد',
        16417: 'گندمینه',
        16418: 'ده نصیر',
        16419: 'شهرک/ابوذر',
        16420: 'چمن سلطان',
        16421: 'فرسش',
        16422: 'دوزان',
        16423: 'گایکان',
        16424: 'برم/خان آباد',
        16425: 'خمه علیا',
        16426: 'خمه سفلی',
        16427: 'سور',
        16428: 'سیاوش آباد',
        16429: 'دولت آباد',
        16430: 'جوشان',
        16431: 'مغانک سفلی',
        16432: 'خاک بتیه',
        16433: 'هما',
        16434: 'کانسرخ',
        16435: 'شول آباد',
        16436: 'ازنا/شهرک/المهدی',
        16437: 'مومن آباددرود',
        16438: 'مدآباد',
        16439: 'فرزیان',
        16440: 'دربند',
        16441: 'آشورآباد',
        16442: 'مسعودآباد',
        16443: 'قاضی آباد',
        16444: 'مرزیان',
        16445: 'گنجه',
        16446: 'کلکله'
    },
    39: {
        11849: 'کرج',
        11880: 'اشتهارد',
        11927: 'هشتگرد/ساوجبلاغ',
        11990: 'نظرآباد'
    },
    59: {
        18537: 'کیش'
    }
};
